export enum Language {
  ENGLISH = "en",
  SPANISH = "es",
  PORTUGUESE = "pt",
}

interface Dictionary {
  [key: string]: {
    [key in Language]: string;
  };
}

export const dictionary: Dictionary = {
  // LANDING PAGE
  "fluxi-is-free": {
    [Language.ENGLISH]: "Fluxi is 100% free",
    [Language.SPANISH]: "Fluxi es 100% gratis",
    [Language.PORTUGUESE]: "Fluxi é 100% gratuito",
  },
  "add-your-product-with-ia": {
    [Language.ENGLISH]:
      "Add your product, and Fluxi creates your sales funnel in seconds",
    [Language.SPANISH]:
      "Agrega tu producto, y Fluxi crea tu embudo de ventas en segundos",
    [Language.PORTUGUESE]:
      "Adicione seu produto, e o Fluxi cria seu funil de vendas em segundos",
  },
  "fluxi-complementary-offers": {
    [Language.ENGLISH]:
      "Fluxi´s AI finds complementary offers that maximize your average sales ticket with automatic upsells, downsells, and bump offers.",
    [Language.SPANISH]:
      "Fluxi en segundos, diseña y optimiza embudos de venta de altísima conversión, creando  ofertas complementarias",
    [Language.PORTUGUESE]:
      "A IA do Fluxi encontra ofertas complementares que maximizam seu ticket médio com upsells, downsells e bump offers automáticos.",
  },
  "register-now": {
    [Language.ENGLISH]: "Register now!",
    [Language.SPANISH]: "Regístrate ahora",
    [Language.PORTUGUESE]: "Registre-se agora!",
  },
  "try-now": {
    [Language.ENGLISH]: "Try now!",
    [Language.SPANISH]: "Prueba ahora",
    [Language.PORTUGUESE]: "Experimente agora!",
  },
  "sign-up-now": {
    [Language.ENGLISH]: "Sign up now!",
    [Language.SPANISH]: "¡Regístrate ahora!",
    [Language.PORTUGUESE]: "Cadastre-se agora!",
  },
  "continuous-optimization": {
    [Language.ENGLISH]:
      "Continuous optimization based on your buyers real behavior.",
    [Language.SPANISH]:
      "Fluxi crea copys persuasivos basados en investigación en tiempo real del cliente de tu producto.",
    [Language.PORTUGUESE]:
      "Otimização contínua baseada no comportamento real dos seus compradores.",
  },
  "fluxi-soon": {
    [Language.ENGLISH]:
      "Fluxi is coming soon. Join our waitlist and get priority access before anyone else.",
    [Language.SPANISH]:
      "Fluxi llegará pronto. Únete a nuestra lista de espera y obtén acceso prioritario antes que nadie.",
    [Language.PORTUGUESE]:
      "Fluxi está chegando. Junte-se à nossa lista de espera e tenha acesso prioritário antes de todos.",
  },
  "self-optimizing": {
    [Language.ENGLISH]: "Self-optimizing pages with AI",
    [Language.SPANISH]: "Páginas autooptimizadas con IA",
    [Language.PORTUGUESE]: "Páginas auto-otimizadas com IA",
  },
  "works-item-1": {
    [Language.ENGLISH]: "Works with any product you want to boost sales for",
    [Language.SPANISH]:
      "Funciona con cualquier producto que quieras aumentar las ventas",
    [Language.PORTUGUESE]:
      "Funciona com qualquer produto que você queira aumentar as vendas",
  },
  "works-item-2": {
    [Language.ENGLISH]:
      "Smart and effective upsells, downsells, and bump offers for each product",
    [Language.SPANISH]:
      "Upsells, downsells y ofertas de aumento inteligentes y efectivas para cada producto",
    [Language.PORTUGUESE]:
      "Upsells, downsells e bump offers inteligentes e eficazes para cada produto",
  },
  "works-item-3": {
    [Language.ENGLISH]: "Create and edit over 30 AI-optimized sales funnels",
    [Language.SPANISH]:
      "Crea y edita más de 30 embudos de ventas optimizados con IA",
    [Language.PORTUGUESE]:
      "Crie e edite mais de 30 funis de vendas otimizados com IA",
  },
  "works-item-4": {
    [Language.ENGLISH]: "Personalized AI digital gifts, free for each funnel",
    [Language.SPANISH]:
      "Gastos digitales personalizados con IA, gratis para cada embudo",
    [Language.PORTUGUESE]:
      "Brindes digitais personalizados com IA, grátis para cada funil",
  },
  "want-your-products": {
    [Language.ENGLISH]: "Want your products to sell like magic?",
    [Language.SPANISH]:
      "¿Quieres que tus productos se vendan como por arte de magia?",
    [Language.PORTUGUESE]: "Quer que seus produtos vendam como mágica?",
  },
  "fluxi-is-perfect": {
    [Language.ENGLISH]: "Fluxi is perfect for you",
    [Language.SPANISH]: "Fluxi es perfecto para ti",
    [Language.PORTUGUESE]: "Fluxi é perfeito para você",
  },
  "for-entrepreneurs": {
    [Language.ENGLISH]: "For entrepreneurs chasing",
    [Language.SPANISH]: "Para emprendedores que persiguen",
    [Language.PORTUGUESE]: "Para empreendedores que buscam",
  },
  "remarkable-sales-conversion": {
    [Language.ENGLISH]: "remarkable sales conversion results",
    [Language.SPANISH]: "resultados de conversión de ventas notables",
    [Language.PORTUGUESE]: "resultados notáveis de conversão de vendas",
  },
  "with-the-power": {
    [Language.ENGLISH]: "with the power of AI",
    [Language.SPANISH]: "con el poder de IA",
    [Language.PORTUGUESE]: "com o poder da IA",
  },
  "we-turn-your-wishes": {
    [Language.ENGLISH]: "We turn your wishes into sales",
    [Language.SPANISH]: "Convertimos tus deseos en ventas",
    [Language.PORTUGUESE]: "Transformamos seus desejos em vendas",
  },
  "start-boosting-your-sales": {
    [Language.ENGLISH]: "Start boosting your sales significantly with Fluxi",
    [Language.SPANISH]:
      "Comienza a aumentar tus ventas significativamente con Fluxi",
    [Language.PORTUGUESE]:
      "Comece a aumentar suas vendas significativamente com o Fluxi",
  },
  faqs: {
    [Language.ENGLISH]: "FAQs",
    [Language.SPANISH]: "Preguntas frecuentes",
    [Language.PORTUGUESE]: "Perguntas frequentes",
  },
  "question-1": {
    [Language.ENGLISH]: "How does Fluxi work?",
    [Language.SPANISH]: "¿Cómo funciona Fluxi?",
    [Language.PORTUGUESE]: "Como o Fluxi funciona?",
  },
  "answer-1": {
    [Language.ENGLISH]:
      "Fluxi uses artificial intelligence to create highly effective sales funnels in seconds. Simply add your product, and Fluxi automatically generates upsells, downsells, and bump offers optimized to maximize your revenue, with no technical expertise required.",
    [Language.SPANISH]:
      "Fluxi utiliza inteligencia artificial para crear embudos de ventas altamente efectivos en segundos. Simplemente agrega tu producto, y Fluxi automáticamente genera upsells, downsells y ofertas de aumento optimizadas para maximizar tus ingresos, sin necesidad de experiencia técnica.",
    [Language.PORTUGUESE]:
      "O Fluxi usa inteligência artificial para criar funis de vendas altamente eficazes em segundos. Basta adicionar seu produto, e o Fluxi gera automaticamente upsells, downsells e bump offers otimizados para maximizar sua receita, sem necessidade de experiência técnica.",
  },
  "question-2": {
    [Language.ENGLISH]: "Do I need any experience to use Fluxi?",
    [Language.SPANISH]: "¿Necesito experiencia para usar Fluxi?",
    [Language.PORTUGUESE]: "Preciso de experiência para usar o Fluxi?",
  },
  "answer-2": {
    [Language.ENGLISH]:
      "No, Fluxi is designed to be easy to use. You don't need technical experience or sales knowledge. The platform automatically creates funnels tailored to your product, helping you boost sales without hassle.",
    [Language.SPANISH]:
      "No, Fluxi está diseñado para ser fácil de usar. No necesitas experiencia técnica o conocimientos de ventas. La plataforma automáticamente crea embudos adaptados a tu producto, ayudándote a aumentar las ventas sin complicaciones.",
    [Language.PORTUGUESE]:
      "Não, o Fluxi foi projetado para ser fácil de usar. Você não precisa de experiência técnica ou conhecimento em vendas. A plataforma cria automaticamente funis adaptados ao seu produto, ajudando você a aumentar as vendas sem complicações.",
  },
  "question-3": {
    [Language.ENGLISH]:
      "How long does it take to set up a sales funnel in Fluxi?",
    [Language.SPANISH]:
      "¿Cuánto tiempo toma configurar un embudo de ventas en Fluxi?",
    [Language.PORTUGUESE]:
      "Quanto tempo leva para configurar um funil de vendas no Fluxi?",
  },
  "answer-3": {
    [Language.ENGLISH]:
      "Setting up a sales funnel with Fluxi is instant. Just input your product information, and the AI will generate an optimized funnel in seconds, ready to start increasing your revenue.",
    [Language.SPANISH]:
      "Configurar un embudo de ventas con Fluxi es instantáneo. Simplemente ingresa la información de tu producto, y la IA generará un embudo optimizado en segundos, listo para comenzar a aumentar tus ingresos.",
    [Language.PORTUGUESE]:
      "Configurar um funil de vendas com o Fluxi é instantâneo. Basta inserir as informações do seu produto, e a IA gerará um funil otimizado em segundos, pronto para começar a aumentar sua receita.",
  },
  "question-4": {
    [Language.ENGLISH]:
      "Does Fluxi keep optimizing my funnel after it's set up?",
    [Language.SPANISH]:
      "¿Fluxi sigue optimizando mi embudo después de configurarlo?",
    [Language.PORTUGUESE]:
      "O Fluxi continua otimizando meu funil depois de configurado?",
  },
  "answer-4": {
    [Language.ENGLISH]:
      "Yes, Fluxi not only creates your funnel but also continuously optimizes it based on performance data. The AI adjusts offers, content, and structure to continually improve conversion rates and maximize your profits.",
    [Language.SPANISH]:
      "Sí, Fluxi no solo crea tu embudo sino que también lo optimiza continuamente basado en datos de rendimiento. La IA ajusta ofertas, contenido y estructura para mejorar continuamente las tasas de conversión y maximizar tus ganancias.",
    [Language.PORTUGUESE]:
      "Sim, o Fluxi não apenas cria seu funil, mas também o otimiza continuamente com base em dados de desempenho. A IA ajusta ofertas, conteúdo e estrutura para melhorar continuamente as taxas de conversão e maximizar seus lucros.",
  },
  "its-like-having": {
    [Language.ENGLISH]:
      "It's like having an expert sales optimization team working 24/7",
    [Language.SPANISH]:
      "Es como tener un equipo de optimización de ventas experto trabajando 24/7",
    [Language.PORTUGUESE]:
      "É como ter uma equipe especialista em otimização de vendas trabalhando 24/7",
  },
  "try-fluxi-for-free": {
    [Language.ENGLISH]: "Try Fluxi for free!",
    [Language.SPANISH]: "Prueba Fluxi gratis!",
    [Language.PORTUGUESE]: "Experimente o Fluxi grátis!",
  },
  "sales-like-magic": {
    [Language.ENGLISH]: "Sales like magic",
    [Language.SPANISH]: "Ventas como por arte de magia",
    [Language.PORTUGUESE]: "Vendas como mágica",
  },
  "start-for-free-now": {
    [Language.ENGLISH]: "Start for free now!",
    [Language.SPANISH]: "Comienza gratis ahora!",
    [Language.PORTUGUESE]: "Comece grátis agora!",
  },
  "made-with-passion-by-fluxi": {
    [Language.ENGLISH]: "Made with passion by Fluxi",
    [Language.SPANISH]: "Hecho con pasión por Fluxi",
    [Language.PORTUGUESE]: "Feito com paixão pelo Fluxi",
  },
  copyright: {
    [Language.ENGLISH]: "Copyright © 2025. All rights reserved.",
    [Language.SPANISH]:
      "Derechos de autor © 2025. Todos los derechos reservados.",
    [Language.PORTUGUESE]:
      "Direitos autorais © 2025. Todos os direitos reservados.",
  },
  // HOME PAGE
  "greeting-morning": {
    [Language.ENGLISH]: "Good morning",
    [Language.SPANISH]: "Buenos días",
    [Language.PORTUGUESE]: "Bom dia",
  },
  "greeting-afternoon": {
    [Language.ENGLISH]: "Good afternoon",
    [Language.SPANISH]: "Buenas tardes",
    [Language.PORTUGUESE]: "Boa tarde",
  },
  "greeting-night": {
    [Language.ENGLISH]: "Good night",
    [Language.SPANISH]: "Buenas noches",
    [Language.PORTUGUESE]: "Boa noite",
  },
  "question-home": {
    [Language.ENGLISH]: "What do you want to do today?",
    [Language.SPANISH]: "¿Qué quieres hacer hoy?",
    [Language.PORTUGUESE]: "O que você quer fazer hoje?",
  },
  "updates": {
    [Language.ENGLISH]: "UPDATES",
    [Language.SPANISH]: "ACTUALIZACIONES",
    [Language.PORTUGUESE]: "ATUALIZAÇÕES",
  },
  "create-new-funnel": {
    [Language.ENGLISH]: "Create a new funnel",
    [Language.SPANISH]: "Crear un nuevo embudo",
    [Language.PORTUGUESE]: "Criar um novo funil",
  },
  "see-my-sales": {
    [Language.ENGLISH]: "See my sales",
    [Language.SPANISH]: "Ver mis ventas",
    [Language.PORTUGUESE]: "Ver minhas vendas",
  },
  "see-my-funnels": {
    [Language.ENGLISH]: "See my funnels",
    [Language.SPANISH]: "Ver mis embudos",
    [Language.PORTUGUESE]: "Ver meus funis",
  },
  "see-my-ads": {
    [Language.ENGLISH]: "See my ads",
    [Language.SPANISH]: "Ver mis anuncios",
    [Language.PORTUGUESE]: "Ver meus anúncios",
  },
  "error-uploading-images-too-long": {
    [Language.ENGLISH]: "Error uploading images, the maximum size is 5MB",
    [Language.SPANISH]: "Error al subir imagenes, el tamaño maximo es de 5MB",
    [Language.PORTUGUESE]: "Erro ao subir imagens, o tamanho máximo é de 5MB",
  },
  "error-processing-images": {
    [Language.ENGLISH]: "Error processing images",
    [Language.SPANISH]: "Error al procesar las imágenes",
    [Language.PORTUGUESE]: "Erro ao processar imagens",
  },
  "success-uploading-images": {
    [Language.ENGLISH]: "Images uploaded successfully",
    [Language.SPANISH]: "Imágenes subidas exitosamente",
    [Language.PORTUGUESE]: "Imagens subidas com sucesso",
  },
  "success-uploading-images-failed": {
    [Language.ENGLISH]: "Images uploaded successfully. Failed {failedCount} images.",
    [Language.SPANISH]: "Imágenes subidas exitosamente. Fallaron {failedCount} imágenes.",
    [Language.PORTUGUESE]: "Imagens subidas com sucesso. Falharam {failedCount} imagens.",
  },

  "integration-activated": {
    [Language.ENGLISH]: "Integration activated",
    [Language.SPANISH]: "Integración activada",
    [Language.PORTUGUESE]: "Integração ativada",
  },
  "integration-deactivated": {
    [Language.ENGLISH]: "Integration deactivated",
    [Language.SPANISH]: "Integración desactivada",
    [Language.PORTUGUESE]: "Integração desativada",
  },
  // SIDEBAR
  home: {
    [Language.ENGLISH]: "Home",
    [Language.SPANISH]: "Inicio",
    [Language.PORTUGUESE]: "Início",
  },
  orders: {
    [Language.ENGLISH]: "Orders",
    [Language.SPANISH]: "Ordenes",
    [Language.PORTUGUESE]: "Pedidos",
  },
  products: {
    [Language.ENGLISH]: "Products",
    [Language.SPANISH]: "Productos",
    [Language.PORTUGUESE]: "Produtos",
  },
  ads: {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  hyphens: {
    [Language.ENGLISH]: "Scripts",
    [Language.SPANISH]: "Guiones",
    [Language.PORTUGUESE]: "Hífenes",
  },
  funnels: {
    [Language.ENGLISH]: "Funnels",
    [Language.SPANISH]: "Embudos",
    [Language.PORTUGUESE]: "Funis",
  },
  "ab-testing": {
    [Language.ENGLISH]: "A/B Testing",
    [Language.SPANISH]: "A/B Testing",
    [Language.PORTUGUESE]: "A/B Testing",
  },
  settings: {
    [Language.ENGLISH]: "Settings",
    [Language.SPANISH]: "Configuración",
    [Language.PORTUGUESE]: "Configurações",
  },

  training: {
    [Language.ENGLISH]: "Training",
    [Language.SPANISH]: "Entrenamiento",
    [Language.PORTUGUESE]: "Treinamento",
  },

  "come-ready": {
    [Language.ENGLISH]:
      "Com'n you are ready to get rich, do your first funnel now!",
    [Language.SPANISH]:
      "Vamos, listo para ganar dinero, crea tu primer embudo ahora!",
    [Language.PORTUGUESE]:
      "Vamos, você está pronto para ficar rico, crie seu primeiro funil agora!",
  },

  // ORDERS PAGE
  "undo-changes": {
    [Language.ENGLISH]: "Undo changes",
    [Language.SPANISH]: "Deshacer cambios",
    [Language.PORTUGUESE]: "Desfazer alterações",
  },
  "save-changes": {
    [Language.ENGLISH]: "Save changes",
    [Language.SPANISH]: "Guardar cambios",
    [Language.PORTUGUESE]: "Salvar alterações",
  },
  "filter-by-date": {
    [Language.ENGLISH]: "Filter by date",
    [Language.SPANISH]: "Filtrar por fecha",
    [Language.PORTUGUESE]: "Filtrar por data",
  },
  "relative-dates": {
    [Language.ENGLISH]: "Relative dates",
    [Language.SPANISH]: "Fechas relativas",
    [Language.PORTUGUESE]: "Datas relativas",
  },
  "specific-dates": {
    [Language.ENGLISH]: "Specific dates",
    [Language.SPANISH]: "Fechas específicas",
    [Language.PORTUGUESE]: "Datas específicas",
  },
  today: {
    [Language.ENGLISH]: "Today",
    [Language.SPANISH]: "Hoy",
    [Language.PORTUGUESE]: "Hoje",
  },
  yesterday: {
    [Language.ENGLISH]: "Yesterday",
    [Language.SPANISH]: "Ayer",
    [Language.PORTUGUESE]: "Ontem",
  },
  "this-month": {
    [Language.ENGLISH]: "This month",
    [Language.SPANISH]: "Este mes",
    [Language.PORTUGUESE]: "Este mês",
  },
  "last-month": {
    [Language.ENGLISH]: "Last month",
    [Language.SPANISH]: "Mes pasado",
    [Language.PORTUGUESE]: "Mês passado",
  },
  "start-date": {
    [Language.ENGLISH]: "Start date",
    [Language.SPANISH]: "Fecha inicial",
    [Language.PORTUGUESE]: "Data inicial",
  },
  "end-date": {
    [Language.ENGLISH]: "End date",
    [Language.SPANISH]: "Fecha final",
    [Language.PORTUGUESE]: "Data final",
  },
  "apply-filter": {
    [Language.ENGLISH]: "Apply filter",
    [Language.SPANISH]: "Aplicar filtro",
    [Language.PORTUGUESE]: "Aplicar filtro",
  },
  "no-orders-found": {
    [Language.ENGLISH]: "No orders found",
    [Language.SPANISH]: "No se encontraron órdenes",
    [Language.PORTUGUESE]: "Nenhuma ordem encontrada",
  },
  "try-different-filters": {
    [Language.ENGLISH]: "Try different filters or date range",
    [Language.SPANISH]: "Intenta con diferentes filtros o rango de fechas",
    [Language.PORTUGUESE]: "Tente diferentes filtros ou intervalo de datas",
  },
  "search-product": {
    [Language.ENGLISH]: "Search product...",
    [Language.SPANISH]: "Buscar producto...",
    [Language.PORTUGUESE]: "Buscar produto...",
  },
  "sales-orders": {
    [Language.ENGLISH]: "Sales orders",
    [Language.SPANISH]: "Ordenes",
    [Language.PORTUGUESE]: "Pedidos",
  },
  // FILTERS
  all: {
    [Language.ENGLISH]: "All",
    [Language.SPANISH]: "Todos",
    [Language.PORTUGUESE]: "Todos",
  },
  unfulfilled: {
    [Language.ENGLISH]: "Unfulfilled",
    [Language.SPANISH]: "No entregados",
    [Language.PORTUGUESE]: "Não entregues",
  },
  fulfilled: {
    [Language.ENGLISH]: "Fulfilled",
    [Language.SPANISH]: "Entregados",
    [Language.PORTUGUESE]: "Entregues",
  },
  pending: {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendientes",
    [Language.PORTUGUESE]: "Pendentes",
  },
  paid: {
    [Language.ENGLISH]: "Paid",
    [Language.SPANISH]: "Pagados",
    [Language.PORTUGUESE]: "Pagados",
  },
  unpaid: {
    [Language.ENGLISH]: "Unpaid",
    [Language.SPANISH]: "No pagados",
    [Language.PORTUGUESE]: "Não pagados",
  },
  // SALES STATS
  "total-sales": {
    [Language.ENGLISH]: "Total sales",
    [Language.SPANISH]: "Total de ventas",
    [Language.PORTUGUESE]: "Total de vendas",
  },
  "products-sold": {
    [Language.ENGLISH]: "Products sold",
    [Language.SPANISH]: "Productos vendidos",
    [Language.PORTUGUESE]: "Produtos vendidos",
  },
  buyers: {
    [Language.ENGLISH]: "Buyers",
    [Language.SPANISH]: "Compradores",
    [Language.PORTUGUESE]: "Compradores",
  },
  // SALES TABLE
  downloading: {
    [Language.ENGLISH]: "Downloading...",
    [Language.SPANISH]: "Descargando...",
    [Language.PORTUGUESE]: "Baixando...",
  },
  "download-orders": {
    [Language.ENGLISH]: "Download orders",
    [Language.SPANISH]: "Descargar ordenes",
    [Language.PORTUGUESE]: "Baixar pedidos",
  },
  date: {
    [Language.ENGLISH]: "Date",
    [Language.SPANISH]: "Fecha",
    [Language.PORTUGUESE]: "Data",
  },
  "date-and-time": {
    [Language.ENGLISH]: "Date and time",
    [Language.SPANISH]: "Fecha y hora",
    [Language.PORTUGUESE]: "Data e hora",
  },
  "order-number": {
    [Language.ENGLISH]: "Order number",
    [Language.SPANISH]: "Número de orden",
    [Language.PORTUGUESE]: "Número de pedido",
  },
  customer: {
    [Language.ENGLISH]: "Customer",
    [Language.SPANISH]: "Cliente",
    [Language.PORTUGUESE]: "Cliente",
  },
  total: {
    [Language.ENGLISH]: "Total",
    [Language.SPANISH]: "Total",
    [Language.PORTUGUESE]: "Total",
  },
  channel: {
    [Language.ENGLISH]: "Channel",
    [Language.SPANISH]: "Canal",
    [Language.PORTUGUESE]: "Canal",
  },
  payment: {
    [Language.ENGLISH]: "Payment",
    [Language.SPANISH]: "Pago",
    [Language.PORTUGUESE]: "Pagamento",
  },
  "payment-method": {
    [Language.ENGLISH]: "Payment method",
    [Language.SPANISH]: "Método de pago",
    [Language.PORTUGUESE]: "Método de pagamento",
  },
  status: {
    [Language.ENGLISH]: "Status",
    [Language.SPANISH]: "Estado",
    [Language.PORTUGUESE]: "Estado",
  },
  "payment-status": {
    [Language.ENGLISH]: "Payment status",
    [Language.SPANISH]: "Estado de pago",
    [Language.PORTUGUESE]: "Estado de pagamento",
  },
  fulfillment: {
    [Language.ENGLISH]: "Fulfillment",
    [Language.SPANISH]: "Envío",
    [Language.PORTUGUESE]: "Envio",
  },
  "fulfillment-status": {
    [Language.ENGLISH]: "Fulfillment status",
    [Language.SPANISH]: "Estado de envío",
    [Language.PORTUGUESE]: "Estado de envio",
  },
  items: {
    [Language.ENGLISH]: "Items",
    [Language.SPANISH]: "Unidades",
    [Language.PORTUGUESE]: "Unidades",
  },
  actions: {
    [Language.ENGLISH]: "Actions",
    [Language.SPANISH]: "Acciones",
    [Language.PORTUGUESE]: "Ações",
  },
  "paid-state": {
    [Language.ENGLISH]: "Paid",
    [Language.SPANISH]: "Pagado",
    [Language.PORTUGUESE]: "Pago",
  },
  "pending-state": {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendiente",
    [Language.PORTUGUESE]: "Pendente",
  },
  "unpaid-state": {
    [Language.ENGLISH]: "Unpaid",
    [Language.SPANISH]: "No pagado",
    [Language.PORTUGUESE]: "Não pago",
  },
  "fulfilled-state": {
    [Language.ENGLISH]: "Fulfilled",
    [Language.SPANISH]: "Entregado",
    [Language.PORTUGUESE]: "Entregado",
  },
  "unfulfilled-state": {
    [Language.ENGLISH]: "Unfulfilled",
    [Language.SPANISH]: "No entregado",
    [Language.PORTUGUESE]: "Não entregado",
  },
  view: {
    [Language.ENGLISH]: "View",
    [Language.SPANISH]: "Ver",
    [Language.PORTUGUESE]: "Ver",
  },
  "view-details": {
    [Language.ENGLISH]: "View Details",
    [Language.SPANISH]: "Ver Detalles",
    [Language.PORTUGUESE]: "Ver Detalhes",
  },

  // ORDER DETAILS PAGE
  "order-details": {
    [Language.ENGLISH]: "Order details",
    [Language.SPANISH]: "Detalles de la orden",
    [Language.PORTUGUESE]: "Detalhes da ordem",
  },
  priority: {
    [Language.ENGLISH]: "Priority",
    [Language.SPANISH]: "Prioridad",
    [Language.PORTUGUESE]: "Prioridade",
  },
  "fulfill-item": {
    [Language.ENGLISH]: "Mark as delivered",
    [Language.SPANISH]: "Marcar como entregado",
    [Language.PORTUGUESE]: "Marcar como entregado",
  },
  "unfulfill-item": {
    [Language.ENGLISH]: "Mark as not delivered",
    [Language.SPANISH]: "Marcar como no entregado",
    [Language.PORTUGUESE]: "Marcar como não entregado",
  },
  "first-time-customer": {
    [Language.ENGLISH]: "First time customer",
    [Language.SPANISH]: "Primer pedido",
    [Language.PORTUGUESE]: "Primeiro pedido",
  },
  "customer-details": {
    [Language.ENGLISH]: "Customer details",
    [Language.SPANISH]: "Detalles del cliente",
    [Language.PORTUGUESE]: "Detalhes do cliente",
  },
  "payment-details": {
    [Language.ENGLISH]: "Payment details",
    [Language.SPANISH]: "Detalles de pago",
    [Language.PORTUGUESE]: "Detalhes de pagamento",
  },
  subtotal: {
    [Language.ENGLISH]: "Subtotal",
    [Language.SPANISH]: "Subtotal",
    [Language.PORTUGUESE]: "Subtotal",
  },
  "paid-on": {
    [Language.ENGLISH]: "Paid on",
    [Language.SPANISH]: "Pagado el",
    [Language.PORTUGUESE]: "Pago em",
  },
  "paid-with": {
    [Language.ENGLISH]: "Paid with",
    [Language.SPANISH]: "Pagado con",
    [Language.PORTUGUESE]: "Pago com",
  },
  "shipping-address": {
    [Language.ENGLISH]: "Shipping address",
    [Language.SPANISH]: "Dirección de envío",
    [Language.PORTUGUESE]: "Endereço de envio",
  },

  // PRODUCTS PAGE
  product: {
    [Language.ENGLISH]: "Product",
    [Language.SPANISH]: "Producto",
    [Language.PORTUGUESE]: "Produto",
  },
  price: {
    [Language.ENGLISH]: "Price",
    [Language.SPANISH]: "Precio",
    [Language.PORTUGUESE]: "Preço",
  },
  "last-updated": {
    [Language.ENGLISH]: "Last updated",
    [Language.SPANISH]: "Última actualización",
    [Language.PORTUGUESE]: "Última atualização",
  },
  "optional": {
    [Language.ENGLISH]: "OPTIONAL",
    [Language.SPANISH]: "OPCIONAL",
    [Language.PORTUGUESE]: "OPCIONAL",
  },
  colors: {
    [Language.ENGLISH]: "Colors",
    [Language.SPANISH]: "Colores",
    [Language.PORTUGUESE]: "Cores",
  },
  "upload-your-own-template": {
    [Language.ENGLISH]: "Upload your own template",
    [Language.SPANISH]: "Subir tu propio template",
    [Language.PORTUGUESE]: "Subir seu próprio template",
  },

  // ADS PAGE
  "ai-will-create-for-you": {
    [Language.ENGLISH]: "AI will create for you",
    [Language.SPANISH]: "La IA creará para ti",
    [Language.PORTUGUESE]: "A IA criará para você",
  },
  "automatically-optimized": {
    [Language.ENGLISH]: "Automatically optimized",
    [Language.SPANISH]: "Automáticamente optimizado",
    [Language.PORTUGUESE]: "Automaticamente otimizado",
  },
  "unique-ad-image-creatives": {
    [Language.ENGLISH]: "Unique ad creatives (images)",
    [Language.SPANISH]: "Creativos (imágenes) únicos de anuncios",
    [Language.PORTUGUESE]: "Criativos (imagens) únicos de anúncios",
  },
  "ready-for-your-campaigns": {
    [Language.ENGLISH]: "Ready for your campaigns",
    [Language.SPANISH]: "Listos para tus campañas",
    [Language.PORTUGUESE]: "Prontos para suas campanhas",
  },
  "customize-creatives": {
    [Language.ENGLISH]: "Customize creatives",
    [Language.SPANISH]: "Personalizar creativos",
    [Language.PORTUGUESE]: "Personalizar criativos",
  },
  "optional-describe-style": {
    [Language.ENGLISH]: "Optional · Describe the desired style",
    [Language.SPANISH]: "Opcional · Describe el estilo deseado",
    [Language.PORTUGUESE]: "Opcional · Descreva o estilo desejado",
  },
  "generate-ads": {
    [Language.ENGLISH]: "Generate ads",
    [Language.SPANISH]: "Generar Anuncios",
    [Language.PORTUGUESE]: "Gerar anúncios",
  },
  "ads-created": {
    [Language.ENGLISH]: "ads created",
    [Language.SPANISH]: "anuncios creados",
    [Language.PORTUGUESE]: "anúncios criados",
  },
  "images": {
    [Language.ENGLISH]: "Images",
    [Language.SPANISH]: "Imágenes",
    [Language.PORTUGUESE]: "Imagens",
  },
  "videos": {
    [Language.ENGLISH]: "Videos",
    [Language.SPANISH]: "Videos",
    [Language.PORTUGUESE]: "Vídeos",
  },
  "please-fill-all-the-fields": {
    [Language.ENGLISH]: "Please fill all the fields",
    [Language.SPANISH]: "Por favor, completa todos los campos",
    [Language.PORTUGUESE]: "Por favor, complete todos os campos",
  },
  "problems-with-the-creation-of-pages-and-images":{
    [Language.ENGLISH]: "We are currently experiencing problems with the creation of pages and images, we will soon re-enable this option. Thank you for your patience",
    [Language.SPANISH]: "En este momento estamos presentando problemas con la creación de páginas e imagenes, pronto volveremos a habilitar esta opción. Gracias por tu paciencia",
    [Language.PORTUGUESE]: "En este momento estamos presentando problemas com a criação de páginas e imagens, em breve voltaremos a habilitar esta opção. Obrigado pela sua paciência",

  },
  "failed-to-generate-narrative": {
    [Language.ENGLISH]: "Failed to generate narrative",
    [Language.SPANISH]: "Error al generar la narrativa",
    [Language.PORTUGUESE]: "Erro ao gerar a narrativa",
  },
  "narrative-generated-successfully": {
    [Language.ENGLISH]: "Narrative generated successfully",
    [Language.SPANISH]: "Narrativa generada correctamente",
    [Language.PORTUGUESE]: "Narrativa gerada com sucesso",
  },
  "your-ads": {
    [Language.ENGLISH]: "Your ads",
    [Language.SPANISH]: "Tus anuncios",
    [Language.PORTUGUESE]: "Seus anúncios",
  },
  "your-generated-narratives-will-appear-here": {
    [Language.ENGLISH]: "Your generated narratives will appear here.",
    [Language.SPANISH]: "Tus narrativas generadas aparecerán aquí.",
    [Language.PORTUGUESE]: "Suas narrativas geradas aparecerão aqui.",
  },
  "start-filling-the-form-on-the-right": {
    [Language.ENGLISH]: "Start filling the form on the right.",
    [Language.SPANISH]: "Comienza llenando el formulario de la derecha.",
    [Language.PORTUGUESE]: "Comece a preencher o formulário à direita.",
  },
  "no-narratives-yet": {
    [Language.ENGLISH]: "No narratives yet",
    [Language.SPANISH]: "No hay narrativas aún",
    [Language.PORTUGUESE]: "Nenhuma narrativa ainda",
  },
  "no-narratives-found-for-this-filter": {
    [Language.ENGLISH]: "No narratives found for this filter.",
    [Language.SPANISH]: "No se encontraron narrativas para este filtro.",
    [Language.PORTUGUESE]: "Nenhuma narrativa encontrada para este filtro.",
  },
  "create-your-scripts": {
    [Language.ENGLISH]: "Create your scripts",
    [Language.SPANISH]: "Crear tus guiones",
    [Language.PORTUGUESE]: "Criar seus guias",
  },
  "product-name": {
    [Language.ENGLISH]: "Product name",
    [Language.SPANISH]: "Nombre del producto",
    [Language.PORTUGUESE]: "Nome do produto",
  },
  "product-description": {
    [Language.ENGLISH]: "Product description",
    [Language.SPANISH]: "Descripción del producto",
    [Language.PORTUGUESE]: "Descrição do produto",
  },
  "confirm-your-main-product": {
    [Language.ENGLISH]: "Confirm your Main Product",
    [Language.SPANISH]: "Confirma tu Producto Principal",
    [Language.PORTUGUESE]: "Confirme seu Produto Principal",
  },
  "edit-data-if-needed": {
    [Language.ENGLISH]: "Edit the data if needed before continuing.",
    [Language.SPANISH]: "Edita los datos si es necesario antes de continuar.",
    [Language.PORTUGUESE]: "Edite os dados se necessário antes de continuar.",
  },
  "confirm-data": {
    [Language.ENGLISH]: "Confirm data",
    [Language.SPANISH]: "Confirmar datos",
    [Language.PORTUGUESE]: "Confirmar dados",
  },
  "confirm-order-bump": {
    [Language.ENGLISH]: "Confirm your Order Bump",
    [Language.SPANISH]: "Confirma tu Order Bump",
    [Language.PORTUGUESE]: "Confirme seu Order Bump",
  },
  "confirm-upsell": {
    [Language.ENGLISH]: "Confirm your Upsell",
    [Language.SPANISH]: "Confirma tu Upsell",
    [Language.PORTUGUESE]: "Confirme seu Upsell",
  },
  "sale-angle": {
    [Language.ENGLISH]: "Sale angle",
    [Language.SPANISH]: "Ángulo de venta",
    [Language.PORTUGUESE]: "Ângulo de venda",
  },
  "product-name-placeholder": {
    [Language.ENGLISH]: "Product name",
    [Language.SPANISH]: "Nombre del producto",
    [Language.PORTUGUESE]: "Nome do produto",
  },
  "product-description-placeholder": {
    [Language.ENGLISH]: "Product description",
    [Language.SPANISH]: "Descripción del producto",
    [Language.PORTUGUESE]: "Descrição do produto",
  },
  "sale-angle-placeholder": {
    [Language.ENGLISH]: "Sale angle",
    [Language.SPANISH]: "Ángulo de venta",
    [Language.PORTUGUESE]: "Ângulo de venda",
  },
  "podcast-style": {
    [Language.ENGLISH]: "Podcast style",
    [Language.SPANISH]: "Estilo podcast",
    [Language.PORTUGUESE]: "Estilo podcast",
  },
  "comedy-style": {
    [Language.ENGLISH]: "Comedy style",
    [Language.SPANISH]: "Estilo comedia",
    [Language.PORTUGUESE]: "Estilo comedia",
  },
  "tutorial-style": {
    [Language.ENGLISH]: "Tutorial style",
    [Language.SPANISH]: "Estilo tutorial",
    [Language.PORTUGUESE]: "Estilo tutorial",
  },
  "testimonial-style": {
    [Language.ENGLISH]: "Testimonial style",
    [Language.SPANISH]: "Estilo testimonial",
    [Language.PORTUGUESE]: "Estilo testimonial",
  },
  "generate-scripts": {
    [Language.ENGLISH]: "Generate scripts",
    [Language.SPANISH]: "Generar guiones",
    [Language.PORTUGUESE]: "Gerar guias",
  },
  "generating-your-scripts": {
    [Language.ENGLISH]: "Generating your scripts",
    [Language.SPANISH]: "Generando tus guiones",
    [Language.PORTUGUESE]: "Gerando seus guias",
  },
  "this-might-take-a-few-moments": {
    [Language.ENGLISH]: "This might take a few moments...",
    [Language.SPANISH]: "Esto puede tomar unos minutos...",
    [Language.PORTUGUESE]: "Isso pode levar alguns momentos...",
  },
  "create-ad": {
    [Language.ENGLISH]: "Create ad",
    [Language.SPANISH]: "Crear anuncio",
    [Language.PORTUGUESE]: "Criar anúncio",
  },
  style: {
    [Language.ENGLISH]: "Style",
    [Language.SPANISH]: "Estilo",
    [Language.PORTUGUESE]: "Estilo",
  },
  "controversial-expert-style": {
    [Language.ENGLISH]: "Controversial expert",
    [Language.SPANISH]: "Experto polémico",
    [Language.PORTUGUESE]: "Experto polêmico",
  },
  "dark-conspiracy-style": {
    [Language.ENGLISH]: "Dark conspiracy",
    [Language.SPANISH]: "Conspiración oscura",
    [Language.PORTUGUESE]: "Conspirância escura",
  },
  "honest-review-style": {
    [Language.ENGLISH]: "Honest review",
    [Language.SPANISH]: "Reseña honesta",
    [Language.PORTUGUESE]: "Resenha honesta",
  },

  // FUNNELS PAGE
  "my-funnels": {
    [Language.ENGLISH]: "My funnels",
    [Language.SPANISH]: "Mis embudos",
    [Language.PORTUGUESE]: "Meus embudos",
  },
  "manage-your-sales-funnels": {
    [Language.ENGLISH]: "Manage your sales funnels",
    [Language.SPANISH]: "Gestiona tus embudos de ventas",
    [Language.PORTUGUESE]: "Gerencia seus embudos de vendas",
  },
  "create-funnel": {
    [Language.ENGLISH]: "Create funnel",
    [Language.SPANISH]: "Crear embudo",
    [Language.PORTUGUESE]: "Criar embudo",
  },
  "create-home": {
    [Language.ENGLISH]: "Create home",
    [Language.SPANISH]: "Crear tienda",
    [Language.PORTUGUESE]: "Criar loja",
  },
  "connected-funnels": {
    [Language.ENGLISH]: "Connected funnels",
    [Language.SPANISH]: "Embudos conectados",
    [Language.PORTUGUESE]: "Embudos conectados",
  },
  "are-you-sure-you-want-to-delete-this-funnel": {
    [Language.ENGLISH]: "Are you sure you want to delete this funnel?",
    [Language.SPANISH]: "¿Estás seguro de querer eliminar este embudo?",
    [Language.PORTUGUESE]: "Tem certeza que deseja deletar este embudo?",
  },
  "this-action-cannot-be-undone": {
    [Language.ENGLISH]: "This action cannot be undone.",
    [Language.SPANISH]: "Esta acción no puede ser deshecha.",
    [Language.PORTUGUESE]: "Esta ação não pode ser desfeita.",
  },
  delete: {
    [Language.ENGLISH]: "Delete",
    [Language.SPANISH]: "Eliminar",
    [Language.PORTUGUESE]: "Deletar",
  },
  active: {
    [Language.ENGLISH]: "Active",
    [Language.SPANISH]: "Activo",
    [Language.PORTUGUESE]: "Ativo",
  },
  draft: {
    [Language.ENGLISH]: "Draft",
    [Language.SPANISH]: "Borrador",
    [Language.PORTUGUESE]: "Rascunho",
  },
  processing: {
    [Language.ENGLISH]: "Processing",
    [Language.SPANISH]: "Procesando",
    [Language.PORTUGUESE]: "Processando",
  },
  "funnel-created": {
    [Language.ENGLISH]: "Funnel created",
    [Language.SPANISH]: "Embudo creado",
    [Language.PORTUGUESE]: "Embudo criado",
  },
  edit: {
    [Language.ENGLISH]: "Edit",
    [Language.SPANISH]: "Editar",
    [Language.PORTUGUESE]: "Editar",
  },
  stats: {
    [Language.ENGLISH]: "Stats",
    [Language.SPANISH]: "Estadísticas",
    [Language.PORTUGUESE]: "Métricas",
  },
  metrics: {
    [Language.ENGLISH]: "Metrics",
    [Language.SPANISH]: "Métricas",
    [Language.PORTUGUESE]: "Métricas",
  },
  "ai-auto-optimization": {
    [Language.ENGLISH]: "AI Auto-Optimization",
    [Language.SPANISH]: "Optimización automática de IA",
    [Language.PORTUGUESE]: "Otimização automática de IA",
  },
  duplicate: {
    [Language.ENGLISH]: "Duplicate",
    [Language.SPANISH]: "Duplicar",
    [Language.PORTUGUESE]: "Duplicar",
  },
  "product-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the product has a name, price, description, and images.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el producto tenga un nombre, precio, descripción y imágenes.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o produto tenha um nome, preço, descrição e imagens.",
  },
  "product-information-incomplete-title": {
    [Language.ENGLISH]: "Product Information Incomplete",
    [Language.SPANISH]: "Información del producto incompleta",
    [Language.PORTUGUESE]: "Informações do produto incompletas",
  },
  "describe-your-custom-sales-angle": {
    [Language.ENGLISH]: "Describe your custom sales angle",
    [Language.SPANISH]: "Describe tu ángulo de venta personalizado",
    [Language.PORTUGUESE]: "Descreva seu ângulo de venda personalizado",
  },
  "describe-your-custom-sales-angle-placeholder": {
    [Language.ENGLISH]:
      "Describe how you want to position your product to potential customers...",
    [Language.SPANISH]:
      "Describe cómo quieres posicionar tu producto a potenciales clientes...",
    [Language.PORTUGUESE]:
      "Descreva como você deseja posicionar seu produto para potenciais clientes...",
  },
  "describe-your-custom-sales-angle-footer": {
    [Language.ENGLISH]:
      "Be specific about the unique selling proposition and the emotional appeal you want to create.",
    [Language.SPANISH]:
      "Sé específico sobre la propuesta de valor única y el atractivo emocional que quieres crear.",
    [Language.PORTUGUESE]:
      "Seja específico sobre a proposta de valor única e o apelo emocional que você deseja criar.",
  },
  "magic-title-step-3": {
    [Language.ENGLISH]: "Magic happens here!",
    [Language.SPANISH]: "¡Magia sucede aquí!",
    [Language.PORTUGUESE]: "A magia acontece aqui!",
  },
  "magic-description-step-3": {
    [Language.ENGLISH]:
      "Product bundles are key to increasing your average order value and making more money",
    [Language.SPANISH]:
      "Los paquetes de productos son clave para aumentar tu valor promedio de pedido y ganar más dinero",
    [Language.PORTUGUESE]:
      "Os pacotes de produtos são chave para aumentar seu valor médio de pedido e ganhar mais dinheiro",
  },
  "order-bump-description": {
    [Language.ENGLISH]:
      "Add a small complementary item that customers can add with a single click",
    [Language.SPANISH]:
      "Agrega un pequeño artículo complementario que los clientes pueden agregar con un solo clic",
    [Language.PORTUGUESE]:
      "Adicione um pequeno item complementar que os clientes podem adicionar com um único clique",
  },
  "upsell-title": {
    [Language.ENGLISH]: "UpSell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  "upsell-description": {
    [Language.ENGLISH]:
      "Offer complementary products at special prices to increase the value of the purchase",
    [Language.SPANISH]:
      "Oferta productos complementarios a precios especiales para aumentar el valor de la compra",
    [Language.PORTUGUESE]:
      "Ofereça produtos complementares a preços especiais para aumentar o valor da compra",
  },
  "complementary-products": {
    [Language.ENGLISH]: "Complementary products",
    [Language.SPANISH]: "Productos complementarios",
    [Language.PORTUGUESE]: "Produtos complementares",
  },

  // ONBOARDING PAGE
  "magical-funnel-creation": {
    [Language.ENGLISH]: "Magical funnel creation",
    [Language.SPANISH]: "Creación de embudo mágica",
    [Language.PORTUGUESE]: "Criação de funil mágico",
  },
  "product-details": {
    [Language.ENGLISH]: "Product details",
    [Language.SPANISH]: "Detalles del producto",
    [Language.PORTUGUESE]: "Detalhes do produto",
  },
  "marketing-angle": {
    [Language.ENGLISH]: "Marketing angle",
    [Language.SPANISH]: "Ángulo de marketing",
    [Language.PORTUGUESE]: "Ângulo de marketing",
  },
  "upsell-options": {
    [Language.ENGLISH]: "Upsell options",
    [Language.SPANISH]: "Opciones de upsell",
    [Language.PORTUGUESE]: "Opções de upsell",
  },
  "brand-style": {
    [Language.ENGLISH]: "Brand & style",
    [Language.SPANISH]: "Marca y estilo",
    [Language.PORTUGUESE]: "Marca e estilo",
  },
  "select-a-product-for-your-sales-funnel": {
    [Language.ENGLISH]: "Select a product for your sales funnel",
    [Language.SPANISH]: "Selecciona un producto para tu embudo de ventas",
    [Language.PORTUGUESE]: "Selecione um produto para seu funil de vendas",
  },
  "import-from-link": {
    [Language.ENGLISH]: "Import from link",
    [Language.SPANISH]: "Importar desde link",
    [Language.PORTUGUESE]: "Importar desde link",
  },
  "enter-manually": {
    [Language.ENGLISH]: "Enter manually",
    [Language.SPANISH]: "Ingresar manualmente",
    [Language.PORTUGUESE]: "Entrar manualmente",
  },
  "your-products": {
    [Language.ENGLISH]: "Your products",
    [Language.SPANISH]: "Tus productos",
    [Language.PORTUGUESE]: "Seus produtos",
  },
  "choose-different-method": {
    [Language.ENGLISH]: "Choose different method",
    [Language.SPANISH]: "Elegir un método diferente",
    [Language.PORTUGUESE]: "Escolher um método diferente",
  },
  "import-product-from-link": {
    [Language.ENGLISH]: "Import product from link",
    [Language.SPANISH]: "Importar producto desde link",
    [Language.PORTUGUESE]: "Importar produto desde link",
  },
  "searching-your-product": {
    [Language.ENGLISH]: "Searching your product...",
    [Language.SPANISH]: "Buscando tu producto...",
    [Language.PORTUGUESE]: "Buscando seu produto...",
  },
  "paste-product-url-placeholder": {
    [Language.ENGLISH]: "Paste product URL",
    [Language.SPANISH]: "Pega la URL del producto",
    [Language.PORTUGUESE]: "Cole a URL do produto",
  },
  "product-information": {
    [Language.ENGLISH]: "Product information",
    [Language.SPANISH]: "Información del producto",
    [Language.PORTUGUESE]: "Informações do produto",
  },
  "upload-image": {
    [Language.ENGLISH]: "Upload Image",
    [Language.SPANISH]: "Subir Imagen",
    [Language.PORTUGUESE]: "Subir Imagem",
  },
  "upload-images": {
    [Language.ENGLISH]: "Upload Images",
    [Language.SPANISH]: "Subir Imágenes",
    [Language.PORTUGUESE]: "Subir Imagens",
  },
  "accepted-formats": {
    [Language.ENGLISH]: "Accepted formats: JPG, PNG, WEBP and JPEG",
    [Language.SPANISH]: "Formatos aceptados: JPG, PNG, WEBP y JPEG",
    [Language.PORTUGUESE]: "Formatos aceitos: JPG, PNG, WEBP e JPEG",
  },
  "drag-and-drop-your-images-here-or-click-to-select": {
    [Language.ENGLISH]: "Drag and drop your images here or click to select",
    [Language.SPANISH]:
      "Arrastra y suelta tus imágenes aquí o haz clic para seleccionar",
    [Language.PORTUGUESE]:
      "Arraste e solte suas imagens aqui ou clique para selecionar",
  },
  "add-more-images": {
    [Language.ENGLISH]: "Add more images",
    [Language.SPANISH]: "Agregar más imágenes",
    [Language.PORTUGUESE]: "Adicionar mais imagens",
  },
  "product-details-placeholder": {
    [Language.ENGLISH]: "Product details",
    [Language.SPANISH]: "Detalles del producto",
    [Language.PORTUGUESE]: "Detalhes do produto",
  },
  "product-name-placeholder-manual-entry": {
    [Language.ENGLISH]: "Example: Adidas predator",
    [Language.SPANISH]: "Ejemplo: Adidas predator",
    [Language.PORTUGUESE]: "Exemplo: Adidas predator",
  },
  "product-details-placeholder-manual-entry": {
    [Language.ENGLISH]:
      "Describe the main features and benefits of your product...",
    [Language.SPANISH]:
      "Describe las principales características y beneficios de tu producto...",
    [Language.PORTUGUESE]:
      "Descreva as principais características e benefícios de seu produto...",
  },
  "search-previous-products-placeholder": {
    [Language.ENGLISH]: "Search previous products",
    [Language.SPANISH]: "Buscar productos anteriores",
    [Language.PORTUGUESE]: "Buscar produtos anteriores",
  },
  next: {
    [Language.ENGLISH]: "Next",
    [Language.SPANISH]: "Siguiente",
    [Language.PORTUGUESE]: "Próximo",
  },
  previous: {
    [Language.ENGLISH]: "Previous",
    [Language.SPANISH]: "Anterior",
    [Language.PORTUGUESE]: "Anterior",
  },
  "loading-personalized-sales-angles": {
    [Language.ENGLISH]: "Loading personalized sales angles...",
    [Language.SPANISH]: "Cargando ángulos de venta personalizados...",
    [Language.PORTUGUESE]: "Carregando ângulos de venda personalizados...",
  },
  recommended: {
    [Language.ENGLISH]: "Recommended",
    [Language.SPANISH]: "Recomendado",
    [Language.PORTUGUESE]: "Recomendado",
  },
  "choose-1-to-6-sales-angles-for-your-funnels": {
    [Language.ENGLISH]: "Choose 1 to 6 sales angles for your funnels",
    [Language.SPANISH]: "Elige 1 a 6 ángulos de venta para tus embudos",
    [Language.PORTUGUESE]: "Escolha 1 a 6 ângulos de venda para seus embudos",
  },
  "free-shipping": {
    [Language.ENGLISH]: "Free shipping",
    [Language.SPANISH]: "Envío gratis",
    [Language.PORTUGUESE]: "Frete grátis",
  },
  "30-days-warranty": {
    [Language.ENGLISH]: "30 days warranty",
    [Language.SPANISH]: "30 días de garantía",
    [Language.PORTUGUESE]: "30 dias de garantia",
  },
  "90-days-warranty": {
    [Language.ENGLISH]: "90 days warranty",
    [Language.SPANISH]: "90 días de garantía",
    [Language.PORTUGUESE]: "90 dias de garantia",
  },
  "custom-warranty": {
    [Language.ENGLISH]: "Custom warranty",
    [Language.SPANISH]: "Garantía personalizada",
    [Language.PORTUGUESE]: "Garantia personalizada",
  },
  "no-products-found": {
    [Language.ENGLISH]: "No products found",
    [Language.SPANISH]: "No se encontraron productos",
    [Language.PORTUGUESE]: "Nenhum produto encontrado",
  },
  "loading-products": {
    [Language.ENGLISH]: "Loading products...",
    [Language.SPANISH]: "Cargando productos...",
    [Language.PORTUGUESE]: "Carregando produtos...",
  },
  "import-order bump-from-link": {
    [Language.ENGLISH]: "Import order bump from link",
    [Language.SPANISH]: "Importar oferta de aumento desde link",
    [Language.PORTUGUESE]: "Importar oferta de aumento desde link",
  },
  "import-upsell-from-link": {
    [Language.ENGLISH]: "Import upsell from link",
    [Language.SPANISH]: "Importar upsell desde link",
    [Language.PORTUGUESE]: "Importar upsell desde link",
  },
  "product-image-automatically-imported": {
    [Language.ENGLISH]:
      "The product image will be automatically imported from the marketplace.",
    [Language.SPANISH]:
      "La imagen del producto se importará automáticamente desde el marketplace.",
    [Language.PORTUGUESE]:
      "A imagem do produto será importada automaticamente do marketplace.",
  },
  "upload-an-image-of-your-product": {
    [Language.ENGLISH]: "Upload an image of your product",
    [Language.SPANISH]: "Subir una imagen de tu producto",
    [Language.PORTUGUESE]: "Subir uma imagem do seu produto",
  },
  "upload-product-image": {
    [Language.ENGLISH]: "Upload product image",
    [Language.SPANISH]: "Subir imagen del producto",
    [Language.PORTUGUESE]: "Subir imagem do produto",
  },
  description: {
    [Language.ENGLISH]: "Description",
    [Language.SPANISH]: "Descripción",
    [Language.PORTUGUESE]: "Descrição",
  },
  "enter-product-name-placeholder": {
    [Language.ENGLISH]: "Enter product name",
    [Language.SPANISH]: "Ingresar nombre del producto",
    [Language.PORTUGUESE]: "Digite o nome do produto",
  },
  "enter-price-placeholder": {
    [Language.ENGLISH]: "Enter price",
    [Language.SPANISH]: "Ingresar precio",
    [Language.PORTUGUESE]: "Digite o preço",
  },
  "main-product-price-incomplete-title": {
    [Language.ENGLISH]: "Main Product Price Incomplete",
    [Language.SPANISH]: "Precio del producto principal incompleto",
    [Language.PORTUGUESE]: "Preço do produto principal incompleto",
  },
  "order-bump-product-price-incomplete-title": {
    [Language.ENGLISH]: "Order Bump Product Price Incomplete",
    [Language.SPANISH]: "Precio del order bump incompleto",
    [Language.PORTUGUESE]: "Preço do order bump incompleto",
  },
  "upsell-product-price-incomplete-title": {
    [Language.ENGLISH]: "Upsell Product Price Incomplete",
    [Language.SPANISH]: "Precio del upsell incompleto",
    [Language.PORTUGUESE]: "Preço do upsell incompleto",
  },
  "price-required": {
    [Language.ENGLISH]: "Price required",
    [Language.SPANISH]: "Precio requerido",
    [Language.PORTUGUESE]: "Preço requerido",
  },
  "enter-description-placeholder": {
    [Language.ENGLISH]: "Enter description",
    [Language.SPANISH]: "Ingresar descripción",
    [Language.PORTUGUESE]: "Digite a descrição",
  },
  "product-information-incomplete-message": {
    [Language.ENGLISH]:
      "Please make sure the product has a name, price, description, and images.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el producto tenga un nombre, precio, descripción y imágenes.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o produto tenha um nome, preço, descrição e imagens.",
  },
  "one-last-thing-tell-us-about-your-brand": {
    [Language.ENGLISH]: "One last thing! Tell us about your brand",
    [Language.SPANISH]: "¡Una última cosa! Cuéntanos sobre tu marca",
    [Language.PORTUGUESE]: "Uma última coisa! Conte-nos sobre sua marca",
  },
  "generating-suggestions-with-ai": {
    [Language.ENGLISH]: "Generating suggestions with AI ...",
    [Language.SPANISH]: "Generando sugerencias con IA ...",
    [Language.PORTUGUESE]: "Gerando sugestões com IA ...",
  },
  "sync-error-title": {
    [Language.ENGLISH]: "Sync error",
    [Language.SPANISH]: "Error de sincronización",
    [Language.PORTUGUESE]: "Erro de sincronização",
  },
  "sync-error-description": {
    [Language.ENGLISH]: "Error connecting to the inventory API",
    [Language.SPANISH]: "Error al conectar con el API de inventario",
    [Language.PORTUGUESE]: "Erro ao conectar com o API de inventário",
  },
  generating: {
    [Language.ENGLISH]: "Generating...",
    [Language.SPANISH]: "Generando...",
    [Language.PORTUGUESE]: "Gerando...",
  },
  generate: {
    [Language.ENGLISH]: "Generate",
    [Language.SPANISH]: "Generar",
    [Language.PORTUGUESE]: "Gerar",
  },
  "brand-name": {
    [Language.ENGLISH]: "Brand name",
    [Language.SPANISH]: "Nombre de la marca",
    [Language.PORTUGUESE]: "Nome da marca",
  },
  "enter-your-brand-name-placeholder": {
    [Language.ENGLISH]: "Enter your brand name",
    [Language.SPANISH]: "Ingresar nombre de la marca",
    [Language.PORTUGUESE]: "Digite o nome da marca",
  },
  "price-configuration": {
    [Language.ENGLISH]: "Price configuration (In dollars USA)",
    [Language.SPANISH]: "Configuración de precios (En pesos colombianos)",
    [Language.PORTUGUESE]: "Configuração de preços (Em reais brasileiros)",
  },
  "no-products-configured": {
    [Language.ENGLISH]: "No products configured.",
    [Language.SPANISH]: "No hay productos configurados.",
    [Language.PORTUGUESE]: "Nenhum produto configurado.",
  },
  "product-with-variants-message": {
    [Language.ENGLISH]:
      "This product will be created with variations based on the Dropi page and will be reflected in the created funnel",
    [Language.SPANISH]:
      "Este producto se creará con variaciones basadas en la página de Dropi y quedará reflejado en el embudo creado",
    [Language.PORTUGUESE]:
      "Este produto será criado com variações baseadas na página do Dropi e refletirá no funil criado",
  },
  "main-product": {
    [Language.ENGLISH]: "Main product",
    [Language.SPANISH]: "Producto principal",
    [Language.PORTUGUESE]: "Produto principal",
  },
  "order-bump": {
    [Language.ENGLISH]: "Order bump",
    [Language.SPANISH]: "Order bump",
    [Language.PORTUGUESE]: "Order bump",
  },
  "money-back-guarantee": {
    [Language.ENGLISH]: "Money-Back Guarantee",
    [Language.SPANISH]: "Garantía de devolución de dinero",
    [Language.PORTUGUESE]: "Garantia de devolução de dinheiro",
  },
  days: {
    [Language.ENGLISH]: "Days",
    [Language.SPANISH]: "Días",
    [Language.PORTUGUESE]: "Dias",
  },
  "free-shipfping": {
    [Language.ENGLISH]: "Free shipping",
    [Language.SPANISH]: "Envío gratis",
    [Language.PORTUGUESE]: "Frete grátis",
  },
  "please-select-a-minimum-of-1-marketing-angle": {
    [Language.ENGLISH]: "Please select a minimum of 1 marketing angle.",
    [Language.SPANISH]:
      "Por favor, selecciona un mínimo de 1 ángulo de marketing.",
    [Language.PORTUGUESE]:
      "Por favor, selecione um mínimo de 1 ângulo de marketing.",
  },
  "marketing-angle-required": {
    [Language.ENGLISH]: "Marketing angle required",
    [Language.SPANISH]: "Ángulo de marketing requerido",
    [Language.PORTUGUESE]: "Ângulo de marketing requerido",
  },
  "select-funnels-homes": {
    [Language.ENGLISH]: "Select funnels for your home",
    [Language.SPANISH]: "Selecciona los embudos para tu tienda",
    [Language.PORTUGUESE]: "Selecione os funis para sua loja",
  },
  "search-funnels": {
    [Language.ENGLISH]: "Search and select funnels...",
    [Language.SPANISH]: "Buscar y seleccionar embudos...",
    [Language.PORTUGUESE]: "Pesquisar e selecionar funis...",
  },
  "no-funnels-found": {
    [Language.ENGLISH]: "No funnels found",
    [Language.SPANISH]: "No se encontraron embudos",
    [Language.PORTUGUESE]: "Nenhum funil encontrado",
  },
  "no-funnels-available": {
    [Language.ENGLISH]: "No more funnels available",
    [Language.SPANISH]: "No hay más embudos disponibles",
    [Language.PORTUGUESE]: "Nenhum funil disponível",
  },
  "funnels-selected-home-label": {
    [Language.ENGLISH]: "Here you will see the funnels you select",
    [Language.SPANISH]: "Acá aparecerán los embudos que selecciones",
    [Language.PORTUGUESE]: "Aqui você verá os funis que selecionar",
  },
  "group-funnels-and-create-homes": {
    [Language.ENGLISH]: "Group funnels and create your store in seconds",
    [Language.SPANISH]: "Agrupa embudos y crea tu tienda en segundos",
    [Language.PORTUGUESE]: "Agrupa funis e cria sua loja em segundos",
  },
  "brand-configuration": {
    [Language.ENGLISH]: "Brand configuration",
    [Language.SPANISH]: "Configuración de marca",
    [Language.PORTUGUESE]: "Configuração de marca",
  },
  "brand-context": {
    [Language.ENGLISH]: "Brand context",
    [Language.SPANISH]: "Contexto de marca",
    [Language.PORTUGUESE]: "Contexto de marca",
  },
  "brand-context-description": {
    [Language.ENGLISH]: "What is your mission and what makes your brand unique",
    [Language.SPANISH]: "Cuál es tu misión y qué hace única a tu marca",
    [Language.PORTUGUESE]: "Qual é sua missão e o que torna sua marca única",
  },
  "enter-brand-name": {
    [Language.ENGLISH]: "Enter your brand name",
    [Language.SPANISH]: "Ingresa el nombre de tu marca",
    [Language.PORTUGUESE]: "Digite o nome da marca",
  },
  "describe-brand": {
    [Language.ENGLISH]: "Describe your brand: mission, values, target audience and what makes it unique",
    [Language.SPANISH]: "Describe tu marca: misión, valores, público objetivo y qué la hace única",
    [Language.PORTUGUESE]: "Descreva sua marca: missão, valores, público alvo e o que a torna única",
  },
  "regenerate-with-ia": {
    [Language.ENGLISH]: "Regenerate with IA",
    [Language.SPANISH]: "Regenerar con IA",
    [Language.PORTUGUESE]: "Regenerar com IA",
  },
  "create-store": {
    [Language.ENGLISH]: "Create store",
    [Language.SPANISH]: "Crear tienda",
    [Language.PORTUGUESE]: "Criar loja",
  },
  // SETTINGS PAGE
  "payment-methods": {
    [Language.ENGLISH]: "Payment methods",
    [Language.SPANISH]: "Métodos de pago",
    [Language.PORTUGUESE]: "Métodos de pagamento",
  },
  "customer-support": {
    [Language.ENGLISH]: "Customer support",
    [Language.SPANISH]: "Soporte al cliente",
    [Language.PORTUGUESE]: "Suporte ao cliente",
  },
  logout: {
    [Language.ENGLISH]: "Logout",
    [Language.SPANISH]: "Cerrar sesión",
    [Language.PORTUGUESE]: "Sair",
  },
  "payment-methods-description": {
    [Language.ENGLISH]: "Manage your payment methods",
    [Language.SPANISH]: "Gestiona tus métodos de pago",
    [Language.PORTUGUESE]: "Gerencie seus métodos de pagamento",
  },

  // Funnel Statistics
  "funnel-statistics": {
    [Language.ENGLISH]: "Funnel statistics",
    [Language.SPANISH]: "Estadísticas del embudo",
    [Language.PORTUGUESE]: "Estatísticas do funil",
  },
  "total-revenue": {
    [Language.ENGLISH]: "Total Revenue",
    [Language.SPANISH]: "Ingresos totales",
    [Language.PORTUGUESE]: "Receita total",
  },
  "average-ticket": {
    [Language.ENGLISH]: "Average Ticket",
    [Language.SPANISH]: "Ticket promedio",
    [Language.PORTUGUESE]: "Ticket médio",
  },
  "funnel-products": {
    [Language.ENGLISH]: "Funnel Products",
    [Language.SPANISH]: "Productos del embudo",
    [Language.PORTUGUESE]: "Produtos do funil",
  },
  "no-sales-yet": {
    [Language.ENGLISH]: "There are no sales yet",
    [Language.SPANISH]: "No hay ventas aún",
    [Language.PORTUGUESE]: "Ainda não há vendas",
  },
  "total-visits": {
    [Language.ENGLISH]: "Total Visits",
    [Language.SPANISH]: "Visitas totales",
    [Language.PORTUGUESE]: "Visitas totais",
  },
  "units-sold": {
    [Language.ENGLISH]: "Units sold",
    [Language.SPANISH]: "Unidades vendidas",
    [Language.PORTUGUESE]: "Unidades vendidas",
  },
  revenue: {
    [Language.ENGLISH]: "Revenue",
    [Language.SPANISH]: "Ingresos",
    [Language.PORTUGUESE]: "Receita",
  },
  visits: {
    [Language.ENGLISH]: "Visits",
    [Language.SPANISH]: "Visitas",
    [Language.PORTUGUESE]: "Visitas",
  },
  conversion: {
    [Language.ENGLISH]: "Conversion",
    [Language.SPANISH]: "Conversión",
    [Language.PORTUGUESE]: "Conversão",
  },

  // times
  "all-dates": {
    [Language.ENGLISH]: "All Dates",
    [Language.SPANISH]: "Todas las fechas",
    [Language.PORTUGUESE]: "Todas as datas",
  },
  "last-7-days": {
    [Language.ENGLISH]: "Last 7 Days",
    [Language.SPANISH]: "Últimos 7 días",
    [Language.PORTUGUESE]: "Últimos 7 dias",
  },
  "last-30-days": {
    [Language.ENGLISH]: "Last 30 Days",
    [Language.SPANISH]: "Últimos 30 días",
    [Language.PORTUGUESE]: "Últimos 30 dias",
  },
  "last-90-days": {
    [Language.ENGLISH]: "Last 90 Days",
    [Language.SPANISH]: "Últimos 90 días",
    [Language.PORTUGUESE]: "Últimos 90 dias",
  },
  "custom-range": {
    [Language.ENGLISH]: "Custom Range",
    [Language.SPANISH]: "Rango personalizado",
    [Language.PORTUGUESE]: "Intervalo personalizado",
  },

  // buttons
  "change-currency": {
    [Language.ENGLISH]: "Change currency",
    [Language.SPANISH]: "Cambiar moneda",
    [Language.PORTUGUESE]: "Mudar moeda",
  },
  // payment methods
  inactive: {
    [Language.ENGLISH]: "Inactive",
    [Language.SPANISH]: "Inactivo",
    [Language.PORTUGUESE]: "Inativo",
  },
  on: {
    [Language.ENGLISH]: "On",
    [Language.SPANISH]: "Encendido",
    [Language.PORTUGUESE]: "Ligado",
  },
  off: {
    [Language.ENGLISH]: "Off",
    [Language.SPANISH]: "Apagado",
    [Language.PORTUGUESE]: "Desligado",
  },
  update: {
    [Language.ENGLISH]: "Update",
    [Language.SPANISH]: "Actualizar",
    [Language.PORTUGUESE]: "Atualizar",
  },
  connect: {
    [Language.ENGLISH]: "Connect",
    [Language.SPANISH]: "Conectar",
    [Language.PORTUGUESE]: "Conectar",
  },

  // COMING SOON PAGE
  "you-must-use-a-computer-to-access-the-application": {
    [Language.ENGLISH]: "You must use a computer to access the application",
    [Language.SPANISH]: "Debes utilizar un computador para acceder a la aplicación",
    [Language.PORTUGUESE]: "Você deve usar um computador para acessar a aplicação",
  },
  "more-information": {
    [Language.ENGLISH]: "More information",
    [Language.SPANISH]: "Más información",
    [Language.PORTUGUESE]: "Mais informações",
  },
  "why-use-fluxi-from-a-computer": {
    [Language.ENGLISH]: "Why use Fluxi from a computer?",
    [Language.SPANISH]: "¿Por qué usar Fluxi desde una computadora?",
    [Language.PORTUGUESE]: "Por que usar o Fluxi de um computador?",
  },
  "creating-stores-and-professional-pages-requires-space": {
    [Language.ENGLISH]: "Creating stores and professional pages requires space. In Fluxi you have access to powerful tools: visual customizer, order manager, script creator, integrations with shipping platforms and much more.",
    [Language.SPANISH]: "Crear tiendas y páginas profesionales requiere espacio. En Fluxi tienes acceso a herramientas potentes: personalizador visual, gestor de órdenes, creador de guiones, integraciones con plataformas de envío y mucho más.",
    [Language.PORTUGUESE]: "Criar lojas e páginas profissionais requer espaço. No Fluxi você tem acesso a ferramentas poderosas: personalizador visual, gerenciador de pedidos, criador de guias, integrações com plataformas de envio e muito mais.",
  },
  "all-these-tools-work-better-on-a-large-screen": {
    [Language.ENGLISH]: "All these tools work better on a large screen, where you can see each detail and work comfortably. That's why Fluxi is designed for computer, not for mobile.",
    [Language.SPANISH]: "Todas estas herramientas funcionan mejor en pantalla grande, donde puedes ver cada detalle y trabajar con comodidad. Por eso Fluxi está diseñado para computadora, no para móvil.",
    [Language.PORTUGUESE]: "Todas essas ferramentas funcionam melhor em uma tela grande, onde você pode ver cada detalhe e trabalhar confortavelmente. É por isso que o Fluxi é projetado para computador, não para celular.",
  },
  // CURRENCY
  "currency-cop": {
    [Language.ENGLISH]: "COP",
    [Language.SPANISH]: "COP",
    [Language.PORTUGUESE]: "COP",
  },
  "currency-usd": {
    [Language.ENGLISH]: "USD",
    [Language.SPANISH]: "USD",
    [Language.PORTUGUESE]: "USD",
  },
  "upsell-offer": {
    [Language.ENGLISH]: "Upsell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  "create-funnels": {
    [Language.ENGLISH]: "Create funnels",
    [Language.SPANISH]: "Crear embudos",
    [Language.PORTUGUESE]: "Criar funis",
  },

  // Funnels Card
  "funnel-creation": {
    [Language.ENGLISH]: "Funnel Creation",
    [Language.SPANISH]: "Creación de embudo",
    [Language.PORTUGUESE]: "Criação de funil",
  },
  "researching-target-audience": {
    [Language.ENGLISH]: "Researching Target Audience",
    [Language.SPANISH]: "Investigación de público objetivo",
    [Language.PORTUGUESE]: "Pesquisa de público alvo",
  },
  "uncovering-unique-insights": {
    [Language.ENGLISH]: "Uncovering Unique Insights",
    [Language.SPANISH]: "Descubriendo insights únicos",
    [Language.PORTUGUESE]: "Descobrindo insights únicos",
  },
  "identifying-pain-points": {
    [Language.ENGLISH]: "Identifying Pain Points",
    [Language.SPANISH]: "Identificando puntos de dolor",
    [Language.PORTUGUESE]: "Identificando pontos de dor",
  },
  "writing-persuasive-copy": {
    [Language.ENGLISH]: "Writing Persuasive Copy",
    [Language.SPANISH]: "Escribiendo copy persuasivo",
    [Language.PORTUGUESE]: "Escrevendo copy persuasivo",
  },
  "creating-high-quality-images": {
    [Language.ENGLISH]: "Creating High-Quality Images",
    [Language.SPANISH]: "Creando imágenes de alta calidad",
    [Language.PORTUGUESE]: "Criando imagens de alta qualidade",
  },
  "optimizing-results": {
    [Language.ENGLISH]: "Optimizing Results",
    [Language.SPANISH]: "Optimizando resultados",
    [Language.PORTUGUESE]: "Otimizando resultados",
  },
  "refining-the-details": {
    [Language.ENGLISH]: "Refining the Details",
    [Language.SPANISH]: "Refinando los detalles",
    [Language.PORTUGUESE]: "Refinando os detalhes",
  },
  "manage-membership": {
    [Language.ENGLISH]: "Manage membership",
    [Language.SPANISH]: "Gestionar membresía",
    [Language.PORTUGUESE]: "Gerenciar membros",
  },
  "go-out": {
    [Language.ENGLISH]: "Log out",
    [Language.SPANISH]: "Salir",
    [Language.PORTUGUESE]: "Sair",
  },
  membership: {
    [Language.ENGLISH]: "Membership",
    [Language.SPANISH]: "Membresia",
    [Language.PORTUGUESE]: "Membros",
  },
  credit: {
    [Language.ENGLISH]: "credit",
    [Language.SPANISH]: "crédito",
    [Language.PORTUGUESE]: "crédito",
  },
  credits: {
    [Language.ENGLISH]: "Credits",
    [Language.SPANISH]: "Créditos",
    [Language.PORTUGUESE]: "Créditos",
  },
  "select-3-images": {
    [Language.ENGLISH]: "Select at least 1 image to continue",
    [Language.SPANISH]: "Selecciona al menos 1 imagen para continuar",
    [Language.PORTUGUESE]: "Selecione pelo menos 1 imagem para continuar",
  },
  "max-selection-reached": {
    [Language.ENGLISH]: "You've reached the maximum of 20 templates. Generate these before requesting more.",
    [Language.SPANISH]: "Has alcanzado el máximo de 20 plantillas. Genera estas antes de solicitar más.",
    [Language.PORTUGUESE]: "Você atingiu o máximo de 20 modelos. Gere estes antes de solicitar mais.",
  },
  "total-cost": {
    [Language.ENGLISH]: "Total cost",
    [Language.SPANISH]: "Costo total",
    [Language.PORTUGUESE]: "Custo total",
  },
  available: {
    [Language.ENGLISH]: "available",
    [Language.SPANISH]: "disponibles",
    [Language.PORTUGUESE]: "disponíveis",
  },
  "credits-usage": {
    [Language.ENGLISH]: "Credits usage",
    [Language.SPANISH]: "Uso de créditos",
    [Language.PORTUGUESE]: "Uso de créditos",
  },
  "credits-used": {
    [Language.ENGLISH]: "Credits used",
    [Language.SPANISH]: "Créditos usados",
    [Language.PORTUGUESE]: "Créditos usados",
  },
  "credits-remaining": {
    [Language.ENGLISH]: "Credits remaining",
    [Language.SPANISH]: "Créditos restantes",
    [Language.PORTUGUESE]: "Créditos restantes",
  },
  "plan-total": {
    [Language.ENGLISH]: "Plan total",
    [Language.SPANISH]: "Total del plan",
    [Language.PORTUGUESE]: "Total do plano",
  },
  "payment-history": {
    [Language.ENGLISH]: "Payment history",
    [Language.SPANISH]: "Historial de pagos",
    [Language.PORTUGUESE]: "Histórico de pagamentos",
  },
  "activation-date": {
    [Language.ENGLISH]: "Activation date",
    [Language.SPANISH]: "Fecha de activación",
    [Language.PORTUGUESE]: "Data de ativação",
  },
  "upcoming-renovation": {
    [Language.ENGLISH]: "Upcoming renewal",
    [Language.SPANISH]: "Próxima renovación",
    [Language.PORTUGUESE]: "Renovação próxima",
  },
  succeeded: {
    [Language.ENGLISH]: "Succeeded",
    [Language.SPANISH]: "Completado",
    [Language.PORTUGUESE]: "Completado",
  },
  failed: {
    [Language.ENGLISH]: "Failed",
    [Language.SPANISH]: "Fallido",
    [Language.PORTUGUESE]: "Falhou",
  },
  "try-again": {
    [Language.ENGLISH]: "Try again",
    [Language.SPANISH]: "Volver a intentar",
    [Language.PORTUGUESE]: "Tentar novamente",
  },
  sorry: {
    [Language.ENGLISH]: "Sorry",
    [Language.SPANISH]: "Lo sentimos",
    [Language.PORTUGUESE]: "Desculpe",
  },
  "error-update-plan": {
    [Language.ENGLISH]: "An error occurred with the update of your plan",
    [Language.SPANISH]: "Ha ocurrido un error con la actualización de tu plan",
    [Language.PORTUGUESE]: "Ocorreu um erro com a atualização do seu plano",
  },
  congratulations: {
    [Language.ENGLISH]: "Congratulations!",
    [Language.SPANISH]: "¡Felicitaciones!",
    [Language.PORTUGUESE]: "Parabéns!",
  },
  "plan-updated": {
    [Language.ENGLISH]: "Your plan has been updated successfully",
    [Language.SPANISH]: "Tu plan ha sido actualizado correctamente",
    [Language.PORTUGUESE]: "Seu plan foi atualizado com sucesso",
  },
  "no-products-found-onboarding": {
    [Language.ENGLISH]: "No products found",
    [Language.SPANISH]: "No se encontraron productos",
    [Language.PORTUGUESE]: "Nenhum produto encontrado",
  },
  "upload-images-description-onboarding-product-manual": {
    [Language.ENGLISH]: "Upload images where your product is clearly visible",
    [Language.SPANISH]: "Sube imágenes donde tu producto se vea claramente",
    [Language.PORTUGUESE]:
      "Carregue imagens onde seu produto seja claramente visível",
  },
  "upload-image-description-onboarding-product-manual": {
    [Language.ENGLISH]:
      "Upload a image where your product is clearly visible, this image will be used to create all the content of your page",
    [Language.SPANISH]:
      "Carga una imagen que muestre de forma clara tu producto, esta imagen se usará para que nuestra inteligencia artificial cree todo el contenido de tu página",
    [Language.PORTUGUESE]:
      "Carregue uma imagem que mostre claramente seu produto, esta imagem será usada para que nossa inteligência artificial crie todo o conteúdo da sua página",
  },
  "upload-images-description-upload-onboarding-product-manual": {
    [Language.ENGLISH]:
      "Upload images that show your product clearly and how it is used, these images will be used to create all the content of your page",
    [Language.SPANISH]:
      "Carga imagenes que muestren de forma clara tu producto y como se utiliza, estas imagenes se usarán para que nuestra inteligencia artificial cree todo el contenido de tu página",
    [Language.PORTUGUESE]:
      "Carregue imagens que mostrem claramente seu produto e como é usado, estas imagens serão usadas para que nossa inteligência artificial crie todo o conteúdo da sua página",
  },
  "order-bump-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the order bump has a name, description, and image.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el order bump tenga un nombre, descripción y imagen.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o order bump tenha um nome, descrição e imagem.",
  },
  "order-bump-information-incomplete-title": {
    [Language.ENGLISH]: "Order Bump Information Incomplete",
    [Language.SPANISH]: "Información de order bump incompleta",
    [Language.PORTUGUESE]: "Informações do order bump incompleto",
  },
  "upsell-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the upsell has a name, description, and image.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el upsell tenga un nombre, descripción y imagen.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o upsell tenha um nome, descrição e imagem.",
  },
  "upsell-information-incomplete-title": {
    [Language.ENGLISH]: "Upsell Information Incomplete",
    [Language.SPANISH]: "Información de upsell incompleta",
    [Language.PORTUGUESE]: "Informações do upsell incompleto",
  },
  BUMP_OFFER: {
    [Language.ENGLISH]: "Order Bump",
    [Language.SPANISH]: "Order Bump",
    [Language.PORTUGUESE]: "Order Bump",
  },
  PRINCIPAL: {
    [Language.ENGLISH]: "Main Product",
    [Language.SPANISH]: "Producto principal",
    [Language.PORTUGUESE]: "Produto principal",
  },
  UNKNOWN: {
    [Language.ENGLISH]: "Unknown",
    [Language.SPANISH]: "Desconocido",
    [Language.PORTUGUESE]: "Desconhecido",
  },
  UP_SELL: {
    [Language.ENGLISH]: "Upsell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  integrations: {
    [Language.ENGLISH]: "Integrations",
    [Language.SPANISH]: "Integraciones",
    [Language.PORTUGUESE]: "Integrações",
  },
  cancel: {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "integration-added": {
    [Language.ENGLISH]: "Integration added",
    [Language.SPANISH]: "Integración agregada",
    [Language.PORTUGUESE]: "Integração adicionada",
  },
  "integration-error": {
    [Language.ENGLISH]: "Integration error",
    [Language.SPANISH]: "Error de integración",
    [Language.PORTUGUESE]: "Erro de integração",
  },
  "integration-canceled": {
    [Language.ENGLISH]: "Integration canceled",
    [Language.SPANISH]: "Integración cancelada",
    [Language.PORTUGUESE]: "Integração cancelada",
  },
  DROPI_TOKEN_INVALID: {
    [Language.ENGLISH]: "Dropi token invalid",
    [Language.SPANISH]: "Token de Dropi inválido",
    [Language.PORTUGUESE]: "Token de Dropi inválido",
  },
  "product-cloned-successfully": {
    [Language.ENGLISH]: "Product cloned successfully",
    [Language.SPANISH]: "Producto duplicado correctamente",
    [Language.PORTUGUESE]: "Produto duplicado com sucesso",
  },
  invalid_token: {
    [Language.ENGLISH]: "Invalid MercadoPago access token",
    [Language.SPANISH]: "Token de acceso de MercadoPago inválido",
    [Language.PORTUGUESE]: "Token de acesso de MercadoPago inválido",
  },
  funnel: {
    [Language.ENGLISH]: "Funnel",
    [Language.SPANISH]: "Embudo",
    [Language.PORTUGUESE]: "Funil",
  },
  created: {
    [Language.ENGLISH]: "Created",
    [Language.SPANISH]: "Creado",
    [Language.PORTUGUESE]: "Criado",
  },
  "integration-dropi": {
    [Language.ENGLISH]: "Integration Dropi",
    [Language.SPANISH]: "Integración Dropi",
    [Language.PORTUGUESE]: "Integração Dropi",
  },
  "integration-dropi-description-success": {
    [Language.ENGLISH]: "Order synchronized correctly",
    [Language.SPANISH]: "Orden sincronizada correctamente",
    [Language.PORTUGUESE]: "Ordem sincronizada corretamente",
  },
  "integration-dropi-description-error": {
    [Language.ENGLISH]: "Order synchronization failed",
    [Language.SPANISH]: "Fallo en la sincronización, orden NO sincronizada",
    [Language.PORTUGUESE]: "Falha na sincronização, ordem não sincronizada",
  },
  "integration-dropi-button-text": {
    [Language.ENGLISH]: "View order in Dropi",
    [Language.SPANISH]: "Ver orden en Dropi",
    [Language.PORTUGUESE]: "Ver ordem em Dropi",
  },
  "integration-dropi-sync-order-button": {
    [Language.ENGLISH]: "Sync order",
    [Language.SPANISH]: "Sincronizar orden",
    [Language.PORTUGUESE]: "Sincronizar pedido",
  },
  "funnels-label": {
    [Language.ENGLISH]: "Funnels",
    [Language.SPANISH]: "Embudos",
    [Language.PORTUGUESE]: "Funis",
  },
  "homes-label": {
    [Language.ENGLISH]: "Stores",
    [Language.SPANISH]: "Tiendas",
    [Language.PORTUGUESE]: "Lojas",
  },
  "error-select-funnel": {
    [Language.ENGLISH]: "Please select at least one funnel",
    [Language.SPANISH]: "Por favor, selecciona al menos un embudo",
    [Language.PORTUGUESE]: "Por favor, selecione pelo menos um funil",
  },
  "success-create-home": {
    [Language.ENGLISH]: "Home created successfully",
    [Language.SPANISH]: "Tienda creada correctamente",
    [Language.PORTUGUESE]: "Loja criada com sucesso",
  },
  "error-create-home": {
    [Language.ENGLISH]: "An error occurred with the creation of your home",
    [Language.SPANISH]: "Ha ocurrido un error con la creación de tu tienda",
    [Language.PORTUGUESE]: "Ocorreu um erro com a criação da sua loja",
  },
  "error-brand-data": {
    [Language.ENGLISH]: "Please fill brand name and context",
    [Language.SPANISH]:
      "Por favor, completa el nombre de la marca y el contexto",
    [Language.PORTUGUESE]: "Por favor, complete o nome da marca e o contexto",
  },
  "products-page-description": {
    [Language.ENGLISH]: "Manage all your products",
    [Language.SPANISH]: "Gestiona todos los productos de tu cuenta",
    [Language.PORTUGUESE]: "Gerencie todos os produtos da sua conta",
  },
  "cancel-changes": {
    [Language.ENGLISH]: "Cancel changes",
    [Language.SPANISH]: "Cancelar cambios",
    [Language.PORTUGUESE]: "Cancelar alterações",
  },
  "error-updating-products": {
    [Language.ENGLISH]: "Error updating products. Please try again.",
    [Language.SPANISH]:
      "Error al actualizar los productos. Por favor, intenta nuevamente.",
    [Language.PORTUGUESE]:
      "Erro ao atualizar os produtos. Por favor, tente novamente.",
  },
  "products-updated-successfully": {
    [Language.ENGLISH]: "products updated successfully",
    [Language.SPANISH]: "productos actualizados correctamente",
    [Language.PORTUGUESE]: "produtos atualizados com sucesso",
  },
  "create-new-home": {
    [Language.ENGLISH]: "Create new home",
    [Language.SPANISH]: "Crear nueva tienda",
    [Language.PORTUGUESE]: "Criar nova loja",
  },
  "each-angle-selected-1-credit": {
    [Language.ENGLISH]: "Each funnel selected = 85 credits",
    [Language.SPANISH]: "Cada embudo seleccionado = 85 créditos",
    [Language.PORTUGUESE]: "Cada funil selecionado = 85 créditos",
  },
  "1-credit": {
    [Language.ENGLISH]: "85 credits",
    [Language.SPANISH]: "85 créditos",
    [Language.PORTUGUESE]: "85 créditos",
  },
  "generating-video": {
    [Language.ENGLISH]: "Generating video",
    [Language.SPANISH]: "Generando video",
    [Language.PORTUGUESE]: "Gerando vídeo",
  },
  "error-ad-creation": {
    [Language.ENGLISH]: "An error occurred with the creation of the ad",
    [Language.SPANISH]: "Ha ocurrido un error con la creación de la publicidad",
    [Language.PORTUGUESE]: "Ocorreu um erro com a criação da publicidade",
  },
  "no-video-found": {
    [Language.ENGLISH]: "No video found",
    [Language.SPANISH]: "No se encontró video",
    [Language.PORTUGUESE]: "Nenhum vídeo encontrado",
  },
  INITIALIZING: {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendiente",
    [Language.PORTUGUESE]: "Pendente",
  },
  IN_PROGRESS: {
    [Language.ENGLISH]: "In progress",
    [Language.SPANISH]: "En progreso",
    [Language.PORTUGUESE]: "Em progresso",
  },
  FINISHED: {
    [Language.ENGLISH]: "Done",
    [Language.SPANISH]: "Completado",
    [Language.PORTUGUESE]: "Completado",
  },
  ERROR: {
    [Language.ENGLISH]: "Failed",
    [Language.SPANISH]: "Fallido",
    [Language.PORTUGUESE]: "Falhou",
  },
  "link-copied": {
    [Language.ENGLISH]: "Link copied",
    [Language.SPANISH]: "Link copiado",
    [Language.PORTUGUESE]: "Link copiado",
  },
  "change-plan": {
    [Language.ENGLISH]: "Change plan",
    [Language.SPANISH]: "Cambiar plan",
    [Language.PORTUGUESE]: "Alterar plano",
  },
  "product-images": {
    [Language.ENGLISH]: "Product images",
    [Language.SPANISH]: "Imágenes del producto",
    [Language.PORTUGUESE]: "Imagens do produto",
  },
  "remove-image": {
    [Language.ENGLISH]: "Remove image",
    [Language.SPANISH]: "Eliminar imagen",
    [Language.PORTUGUESE]: "Remover imagem",
  },
  "max-images-reached": {
    [Language.ENGLISH]: "Max images reached",
    [Language.SPANISH]: "Límite alcanzado",
    [Language.PORTUGUESE]: "Limite alcançado",
  },
  "max-file-size-per-image": {
    [Language.ENGLISH]: "Max file size per image is 5MB",
    [Language.SPANISH]: "El límite de tamaño por imagen es de 5MB",
    [Language.PORTUGUESE]: "O limite de tamanho por imagem é de 5MB",
  },
  "uploading-images": {
    [Language.ENGLISH]: "Uploading images...",
    [Language.SPANISH]: "Subiendo imágenes...",
    [Language.PORTUGUESE]: "Carregando imagens...",
  },
  progress: {
    [Language.ENGLISH]: "Progress",
    [Language.SPANISH]: "Progreso",
    [Language.PORTUGUESE]: "Progresso",
  },
  "uploading-image": {
    [Language.ENGLISH]: "Uploading image...",
    [Language.SPANISH]: "Subiendo imagen...",
    [Language.PORTUGUESE]: "Carregando imagem...",
  },
  male: {
    [Language.ENGLISH]: "Male",
    [Language.SPANISH]: "Masculino",
    [Language.PORTUGUESE]: "Masculino",
  },
  female: {
    [Language.ENGLISH]: "Female",
    [Language.SPANISH]: "Femenino",
    [Language.PORTUGUESE]: "Feminino",
  },
  "order-deleted": {
    [Language.ENGLISH]: "Order deleted",
    [Language.SPANISH]: "Orden eliminada",
    [Language.PORTUGUESE]: "Ordem deletada",
  },
  "error-deleting-order": {
    [Language.ENGLISH]: "Error deleting order",
    [Language.SPANISH]: "Error al eliminar la orden",
    [Language.PORTUGUESE]: "Erro ao deletar a ordem",
  },
  "are-you-sure-you-want-to-delete-this-order": {
    [Language.ENGLISH]: "Are you sure you want to delete this order?",
    [Language.SPANISH]: "¿Estás seguro de que deseas eliminar esta orden?",
    [Language.PORTUGUESE]: "Tem certeza que deseja deletar esta ordem?",
  },
  "this-order-is-integrated-with-dropi": {
    [Language.ENGLISH]:
      "This order is integrated with Dropi. If you delete it in Fluxi, you must delete it manually in Dropi to avoid differences between systems.",
    [Language.SPANISH]:
      "Esta orden está integrada con Dropi. Si la eliminas en Fluxi, deberás eliminarla también manualmente en Dropi para evitar diferencias entre sistemas.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Dropi. Se você deletar em Fluxi, deve deletar manualmente em Dropi para evitar diferenças entre sistemas.",
  },
  "this-order-is-integrated-with-shopify": {
    [Language.ENGLISH]:
      "This order is integrated with Shopify. If you delete it in Fluxi, you must delete it manually in Shopify to avoid differences between systems.",
    [Language.SPANISH]:
      "Esta orden está integrada con Shopify. Si la eliminas en Fluxi, deberás eliminarla también manualmente en Shopify para evitar diferencias entre sistemas.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Shopify. Se você deletar em Fluxi, deve deletar manualmente em Shopify para evitar diferenças entre sistemas.",
  },
  "this-order-is-integrated-with-dropi-and-shopify": {
    [Language.ENGLISH]:
      "This order is integrated with Dropi and Shopify. If you delete it in Fluxi, you must delete it manually in both systems to avoid differences.",
    [Language.SPANISH]:
      "Esta orden está integrada con Dropi y Shopify. Si la eliminas en Fluxi, deberás eliminarla también manualmente en ambos sistemas para evitar diferencias.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Dropi e Shopify. Se você deletar em Fluxi, deve deletar manualmente em ambos sistemas para evitar diferenças.",
  },
  "error-getting-order-details": {
    [Language.ENGLISH]: "Error getting order details",
    [Language.SPANISH]: "Error al obtener los detalles de la orden",
    [Language.PORTUGUESE]: "Erro ao obter os detalhes da ordem",
  },
  "custom-angle": {
    [Language.ENGLISH]: "Custom Angle",
    [Language.SPANISH]: "Ángulo personalizado",
    [Language.PORTUGUESE]: "Ângulo personalizado",
  },
  "create-your-own-approach": {
    [Language.ENGLISH]: "Create your own approach.",
    [Language.SPANISH]: "Crea tu propio enfoque.",
    [Language.PORTUGUESE]: "Crie seu próprio enfoque.",
  },
  "visits-unique": {
    [Language.ENGLISH]: "Unique visits",
    [Language.SPANISH]: "Visitas únicas",
    [Language.PORTUGUESE]: "Visitas únicas",
  },
  "login-with-google": {
    [Language.ENGLISH]: "Login with Google",
    [Language.SPANISH]: "Iniciar sesión con Google",
    [Language.PORTUGUESE]: "Iniciar sessão com Google",
  },
  loading: {
    [Language.ENGLISH]: "Loading...",
    [Language.SPANISH]: "Cargando...",
    [Language.PORTUGUESE]: "Carregando...",
  },
  "or-sign-in-with": {
    [Language.ENGLISH]: "Or sign in with",
    [Language.SPANISH]: "O iniciar sesión con",
    [Language.PORTUGUESE]: "O iniciar sessão com",
  },
  "additional-information": {
    [Language.ENGLISH]: "Additional information",
    [Language.SPANISH]: "Información adicional",
    [Language.PORTUGUESE]: "Informação adicional",
  },
  "integration-shopify": {
    [Language.ENGLISH]: "Integration Shopify",
    [Language.SPANISH]: "Integración Shopify",
    [Language.PORTUGUESE]: "Integração Shopify",
  },
  "integration-shopify-description-success": {
    [Language.ENGLISH]: "Order synchronized correctly",
    [Language.SPANISH]: "Orden sincronizada correctamente",
    [Language.PORTUGUESE]: "Ordem sincronizada corretamente",
  },
  "integration-shopify-description-error": {
    [Language.ENGLISH]: "Order synchronization failed",
    [Language.SPANISH]: "Fallo en la sincronización, orden NO sincronizada",
    [Language.PORTUGUESE]: "Falha na sincronização, ordem não sincronizada",
  },
  "fluxi-support": {
    [Language.ENGLISH]: "Fluxi Support",
    [Language.SPANISH]: "Soporte de Fluxi",
    [Language.PORTUGUESE]: "Suporte de Fluxi",
  },
  "we-are-here-to-help-you": {
    [Language.ENGLISH]: "We are here to help you",
    [Language.SPANISH]: "Estamos aquí para ayudarte",
    [Language.PORTUGUESE]: "Estamos aqui para ajudar você",
  },
  "write-your-message": {
    [Language.ENGLISH]: "Write your message...",
    [Language.SPANISH]: "Escribe tu mensaje...",
    [Language.PORTUGUESE]: "Escreva sua mensagem...",
  },
  "buy-credits": {
    [Language.ENGLISH]: "Buy credits",
    [Language.SPANISH]: "Comprar créditos",
    [Language.PORTUGUESE]: "Comprar créditos",
  },
  "insufficient-credits": {
    [Language.ENGLISH]: "Insufficient credits",
    [Language.SPANISH]: "Créditos insuficientes",
    [Language.PORTUGUESE]: "Créditos insuficientes",
  },
  "insufficient-credits-description": {
    [Language.ENGLISH]: "You need {required} credits but only have {available}. Please purchase more credits to continue.",
    [Language.SPANISH]: "Necesitas {required} créditos pero solo tienes {available}. Compra más créditos para continuar.",
    [Language.PORTUGUESE]: "Você precisa de {required} créditos mas só tem {available}. Compre mais créditos para continuar.",
  },
  "waiting-for-payment": {
    [Language.ENGLISH]: "Waiting for payment...",
    [Language.SPANISH]: "Esperando el pago...",
    [Language.PORTUGUESE]: "Aguardando pagamento...",
  },
  "payment-opened-in-new-tab": {
    [Language.ENGLISH]: "Payment page opened in a new tab. Complete your purchase and return here.",
    [Language.SPANISH]: "Se abrió la página de pago en una nueva pestaña. Completa tu compra y regresa aquí.",
    [Language.PORTUGUESE]: "A página de pagamento foi aberta em uma nova aba. Complete sua compra e volte aqui.",
  },
  "verify-payment": {
    [Language.ENGLISH]: "Verify payment",
    [Language.SPANISH]: "Verificar pago",
    [Language.PORTUGUESE]: "Verificar pagamento",
  },
  "credits-updated": {
    [Language.ENGLISH]: "Credits updated!",
    [Language.SPANISH]: "¡Créditos actualizados!",
    [Language.PORTUGUESE]: "Créditos atualizados!",
  },
  "checking-credits": {
    [Language.ENGLISH]: "Checking credits...",
    [Language.SPANISH]: "Verificando créditos...",
    [Language.PORTUGUESE]: "Verificando créditos...",
  },
  "remember-use-credits": {
    [Language.ENGLISH]: "Remember to use your credits.",
    [Language.SPANISH]: "Recuerda usar tus créditos.",
    [Language.PORTUGUESE]: "Lembre-se de usar seus créditos.",
  },
  "product-not-found": {
    [Language.ENGLISH]:
      "Product not found, please try again with a different product or enter manually",
    [Language.SPANISH]:
      "No pudimos extraer la información del producto con el link suministrado, por favor intenta con un link diferente o ingresa la infomación manualmente",
    [Language.PORTUGUESE]:
      "Não conseguimos extrair a informação do produto com o link fornecido, por favor tente com um link diferente ou insira a informação manualmente",
  },
  "no-images-found": {
    [Language.ENGLISH]: "No images found",
    [Language.SPANISH]: "No se encontraron imágenes",
    [Language.PORTUGUESE]: "Nenhuma imagem encontrada",
  },
  "product-not-found-title": {
    [Language.ENGLISH]: "Product not found",
    [Language.SPANISH]: "Producto no encontrado",
    [Language.PORTUGUESE]: "Produto não encontrado",
  },
  "no-images-found-title": {
    [Language.ENGLISH]: "No images found",
    [Language.SPANISH]: "No se encontraron imágenes",
    [Language.PORTUGUESE]: "Nenhuma imagem encontrada",
  },
  english: {
    [Language.ENGLISH]: "English",
    [Language.SPANISH]: "Ingles",
    [Language.PORTUGUESE]: "Inglês",
  },
  spanish: {
    [Language.ENGLISH]: "Spanish",
    [Language.SPANISH]: "Español",
    [Language.PORTUGUESE]: "Espanhol",
  },
  portuguese: {
    [Language.ENGLISH]: "Portuguese",
    [Language.SPANISH]: "Portugués",
    [Language.PORTUGUESE]: "Português",
  },
  "what-country-do-you-want-to": {
    [Language.ENGLISH]: "What country do you want to",
    [Language.SPANISH]: "¿En qué país quieres",
    [Language.PORTUGUESE]: "Em que país você quer",
  },
  "sell-with-fluxi": {
    [Language.ENGLISH]: "sell with Fluxi?",
    [Language.SPANISH]: "vender con Fluxi?",
    [Language.PORTUGUESE]: "vender com Fluxi?",
  },
  "welcome-to": {
    [Language.ENGLISH]: "Welcome to",
    [Language.SPANISH]: "Bienvenid@ a",
    [Language.PORTUGUESE]: "Bem-vindo(a) ao",
  },
  fluxi: {
    [Language.ENGLISH]: "Fluxi",
    [Language.SPANISH]: "Fluxi",
    [Language.PORTUGUESE]: "Fluxi",
  },
  "configure-your-account-in-a-few-moments": {
    [Language.ENGLISH]: "Configure your account in a few moments",
    [Language.SPANISH]: "Configura tu cuenta en solo unos momentos",
    [Language.PORTUGUESE]: "Configure sua conta em alguns momentos",
  },
  "select-your-country": {
    [Language.ENGLISH]: "Select your country...",
    [Language.SPANISH]: "Selecciona tu país...",
    [Language.PORTUGUESE]: "Selecione seu país...",
  },
  argentina: {
    [Language.ENGLISH]: "Argentina",
    [Language.SPANISH]: "Argentina",
    [Language.PORTUGUESE]: "Argentina",
  },
  bolivia: {
    [Language.ENGLISH]: "Bolivia",
    [Language.SPANISH]: "Bolivia",
    [Language.PORTUGUESE]: "Bolivia",
  },
  brazil: {
    [Language.ENGLISH]: "Brazil",
    [Language.SPANISH]: "Brasil",
    [Language.PORTUGUESE]: "Brasil",
  },
  chile: {
    [Language.ENGLISH]: "Chile",
    [Language.SPANISH]: "Chile",
    [Language.PORTUGUESE]: "Chile",
  },
  colombia: {
    [Language.ENGLISH]: "Colombia",
    [Language.SPANISH]: "Colombia",
    [Language.PORTUGUESE]: "Colombia",
  },
  "costa-rica": {
    [Language.ENGLISH]: "Costa Rica",
    [Language.SPANISH]: "Costa Rica",
    [Language.PORTUGUESE]: "Costa Rica",
  },
  cuba: {
    [Language.ENGLISH]: "Cuba",
    [Language.SPANISH]: "Cuba",
    [Language.PORTUGUESE]: "Cuba",
  },
  "dominican-republic": {
    [Language.ENGLISH]: "Dominican Republic",
    [Language.SPANISH]: "República Dominicana",
    [Language.PORTUGUESE]: "República Dominicana",
  },
  ecuador: {
    [Language.ENGLISH]: "Ecuador",
    [Language.SPANISH]: "Ecuador",
    [Language.PORTUGUESE]: "Ecuador",
  },
  "el-salvador": {
    [Language.ENGLISH]: "El Salvador",
    [Language.SPANISH]: "El Salvador",
    [Language.PORTUGUESE]: "El Salvador",
  },
  guatemala: {
    [Language.ENGLISH]: "Guatemala",
    [Language.SPANISH]: "Guatemala",
    [Language.PORTUGUESE]: "Guatemala",
  },
  honduras: {
    [Language.ENGLISH]: "Honduras",
    [Language.SPANISH]: "Honduras",
    [Language.PORTUGUESE]: "Honduras",
  },
  mexico: {
    [Language.ENGLISH]: "Mexico",
    [Language.SPANISH]: "México",
    [Language.PORTUGUESE]: "México",
  },
  nicaragua: {
    [Language.ENGLISH]: "Nicaragua",
    [Language.SPANISH]: "Nicaragua",
    [Language.PORTUGUESE]: "Nicaragua",
  },
  panama: {
    [Language.ENGLISH]: "Panama",
    [Language.SPANISH]: "Panamá",
    [Language.PORTUGUESE]: "Panamá",
  },
  paraguay: {
    [Language.ENGLISH]: "Paraguay",
    [Language.SPANISH]: "Paraguay",
    [Language.PORTUGUESE]: "Paraguay",
  },
  peru: {
    [Language.ENGLISH]: "Peru",
    [Language.SPANISH]: "Perú",
    [Language.PORTUGUESE]: "Perú",
  },
  "puerto-rico": {
    [Language.ENGLISH]: "Puerto Rico",
    [Language.SPANISH]: "Puerto Rico",
    [Language.PORTUGUESE]: "Puerto Rico",
  },
  spain: {
    [Language.ENGLISH]: "Spain",
    [Language.SPANISH]: "España",
    [Language.PORTUGUESE]: "Espanha",
  },
  "united-states": {
    [Language.ENGLISH]: "United States",
    [Language.SPANISH]: "Estados Unidos",
    [Language.PORTUGUESE]: "Estados Unidos",
  },
  uruguay: {
    [Language.ENGLISH]: "Uruguay",
    [Language.SPANISH]: "Uruguay",
    [Language.PORTUGUESE]: "Uruguai",
  },
  venezuela: {
    [Language.ENGLISH]: "Venezuela",
    [Language.SPANISH]: "Venezuela",
    [Language.PORTUGUESE]: "Venezuela",
  },
  "the-currency-is-linked-to-your-country": {
    [Language.ENGLISH]: "The currency is linked to your country",
    [Language.SPANISH]: "La moneda está vinculada a tu país",
    [Language.PORTUGUESE]: "A moeda está vinculada ao seu país",
  },
  "you-can-change-the-language-if-you-need": {
    [Language.ENGLISH]: "You can change the language if you need",
    [Language.SPANISH]: "Puedes cambiar el idioma si lo necesitas",
    [Language.PORTUGUESE]: "Você pode mudar o idioma se precisar",
  },
  "complete-configuration": {
    [Language.ENGLISH]: "Complete configuration",
    [Language.SPANISH]: "Completar configuración",
    [Language.PORTUGUESE]: "Completar configuração",
  },
  "these-settings-cannot-be-changed-later": {
    [Language.ENGLISH]: "These settings cannot be changed later",
    [Language.SPANISH]: "Estas configuraciones no se podrán cambiar después",
    [Language.PORTUGUESE]:
      "Estas configurações não podem ser alteradas mais tarde",
  },
  currency: {
    [Language.ENGLISH]: "Currency",
    [Language.SPANISH]: "Moneda",
    [Language.PORTUGUESE]: "Moeda",
  },
  "linked-to-the-country": {
    [Language.ENGLISH]: "Linked to the country",
    [Language.SPANISH]: "Vinculada al país",
    [Language.PORTUGUESE]: "Vinculada ao país",
  },
  language: {
    [Language.ENGLISH]: "Language",
    [Language.SPANISH]: "Idioma",
    [Language.PORTUGUESE]: "Idioma",
  },
  "colombian-peso": {
    [Language.ENGLISH]: "Colombian Peso",
    [Language.SPANISH]: "Peso Colombiano",
    [Language.PORTUGUESE]: "Peso Colombiano",
  },
  dollar: {
    [Language.ENGLISH]: "Dollar",
    [Language.SPANISH]: "Dólar",
    [Language.PORTUGUESE]: "Dólar",
  },
  "local-currency": {
    [Language.ENGLISH]: "Local Currency",
    [Language.SPANISH]: "Moneda local",
    [Language.PORTUGUESE]: "Moeda local",
  },
  "what-country-do-you-want-to-sell-with-fluxi": {
    [Language.ENGLISH]: "What country do you want to sell with Fluxi?",
    [Language.SPANISH]: "¿En qué país quieres vender con Fluxi?",
    [Language.PORTUGUESE]: "Em que país você quer vender com Fluxi?",
  },
  "configuration-completed-successfully": {
    [Language.ENGLISH]: "Configuration completed successfully",
    [Language.SPANISH]: "Configuración completada correctamente",
    [Language.PORTUGUESE]: "Configuração completada com sucesso",
  },
  "error-completing-configuration": {
    [Language.ENGLISH]: "Error completing configuration",
    [Language.SPANISH]: "Error al completar la configuración",
    [Language.PORTUGUESE]: "Erro ao completar a configuração",
  },
  "delete-order": {
    [Language.ENGLISH]: "Delete order",
    [Language.SPANISH]: "Eliminar orden",
    [Language.PORTUGUESE]: "Deletar pedido",
  },
  "filter-by-product": {
    [Language.ENGLISH]: "Filter by product",
    [Language.SPANISH]: "Filtrar por producto",
    [Language.PORTUGUESE]: "Filtrar por produto",
  },
  "filter-by-sale-angle": {
    [Language.ENGLISH]: "Filter by sale angle",
    [Language.SPANISH]: "Filtrar por ángulo de venta",
    [Language.PORTUGUESE]: "Filtrar por ângulo de venda",
  },
  "public-token": {
    [Language.ENGLISH]: "Public token",
    [Language.SPANISH]: "Token público",
    [Language.PORTUGUESE]: "Token público",
  },
  "private-token": {
    [Language.ENGLISH]: "Private token",
    [Language.SPANISH]: "Token privado",
    [Language.PORTUGUESE]: "Token privado",
  },
  "enter-your-public-token": {
    [Language.ENGLISH]: "Enter your public token",
    [Language.SPANISH]: "Ingresa tu token público",
    [Language.PORTUGUESE]: "Insira seu token público",
  },
  "enter-your-private-token": {
    [Language.ENGLISH]: "Enter your private token",
    [Language.SPANISH]: "Ingresa tu token privado",
    [Language.PORTUGUESE]: "Insira seu token privado",
  },
  "add-integration-token": {
    [Language.ENGLISH]: "Add integration token",
    [Language.SPANISH]: "Agregar token de integración",
    [Language.PORTUGUESE]: "Adicionar token de integração",
  },
  "dropi-token": {
    [Language.ENGLISH]: "Dropi token",
    [Language.SPANISH]: "Token de Dropi",
    [Language.PORTUGUESE]: "Token de Dropi",
  },
  save: {
    [Language.ENGLISH]: "Save",
    [Language.SPANISH]: "Guardar",
    [Language.PORTUGUESE]: "Salvar",
  },
  "example-dropi-token": {
    [Language.ENGLISH]: "Ex: sk_live_1234abc...",
    [Language.SPANISH]: "Ej: sk_live_1234abc...",
    [Language.PORTUGUESE]: "Ej: sk_live_1234abc...",
  },
  questions: {
    [Language.ENGLISH]: "Questions?",
    [Language.SPANISH]: "¿Preguntas?",
    [Language.PORTUGUESE]: "Perguntas?",
  },
  "select-credits": {
    [Language.ENGLISH]: "Select the number of credits you want to buy",
    [Language.SPANISH]: "Selecciona la cantidad de créditos que deseas comprar",
    [Language.PORTUGUESE]:
      "Selecione a quantidade de créditos que deseja comprar",
  },
  "credits-quantity": {
    [Language.ENGLISH]: "Credits quantity",
    [Language.SPANISH]: "Cantidad de créditos",
    [Language.PORTUGUESE]: "Quantidade de créditos",
  },
  "error-creating-purchase-link": {
    [Language.ENGLISH]: "Error creating purchase link",
    [Language.SPANISH]: "Error al crear el enlace de compra",
    [Language.PORTUGUESE]: "Erro ao criar o link de compra",
  },
  "pay-now": {
    [Language.ENGLISH]: "Pay now",
    [Language.SPANISH]: "Pagar ahora",
    [Language.PORTUGUESE]: "Pagar agora",
  },
  "payment-successful": {
    [Language.ENGLISH]: "Payment successful",
    [Language.SPANISH]: "Pago exitoso",
    [Language.PORTUGUESE]: "Pagamento realizado com sucesso",
  },
  "payment-failed": {
    [Language.ENGLISH]: "Payment failed",
    [Language.SPANISH]: "Pago fallido",
    [Language.PORTUGUESE]: "Pagamento falhou",
  },
  "purchase-cancelled": {
    [Language.ENGLISH]: "Purchase cancelled",
    [Language.SPANISH]: "Compra cancelada",
    [Language.PORTUGUESE]: "Compra cancelada",
  },
  "purchase-cancelled-description": {
    [Language.ENGLISH]:
      "The purchase could not be completed. No charges were made.",
    [Language.SPANISH]:
      "No se pudo completar la compra. No se ha realizado ningún cargo.",
    [Language.PORTUGUESE]:
      "A compra não pôde ser concluída. Nenhum cargo foi realizado.",
  },
  "payment-failed-description": {
    [Language.ENGLISH]: "We're sorry, we had problems with your card",
    [Language.SPANISH]:
      "Lamentamos lo ocurrido, hemos tenido problemas con tu tarjeta",
    [Language.PORTUGUESE]:
      "Lamentamos o ocorrido, tivemos problemas com sua cartão",
  },
  "payment-successful-description": {
    [Language.ENGLISH]:
      "Great! You have subscribed to [Plan name], you can now enjoy all its benefits",
    [Language.SPANISH]:
      "¡Genial! Te has suscrito al [Nombre del Plan], ya puedes disfrutar de todos sus beneficios",
    [Language.PORTUGUESE]:
      "Ótimo! Você se inscreveu no [Nome do Plano], agora você pode aproveitar todos os seus benefícios",
  },
  "credits-purchased-description": {
    [Language.ENGLISH]:
      "¡Genial! Has adquirido [Cantidad] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [fecha de vencimiento] para no dejarlos vencer.",
    [Language.SPANISH]:
      "¡Genial! Has adquirido [Cantidad] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [fecha de vencimiento] para no dejarlos vencer.",
    [Language.PORTUGUESE]:
      "Ótimo! Você adquiriu [Quantidade] créditos, agora você pode aproveitar seus novos créditos, lembre-se de usarlos antes de [data de vencimento] para não deixá-los vencer.",
  },
  continue: {
    [Language.ENGLISH]: "Continue",
    [Language.SPANISH]: "Continuar",
    [Language.PORTUGUESE]: "Continuar",
  },
  retry: {
    [Language.ENGLISH]: "Retry",
    [Language.SPANISH]: "Volver a intentar",
    [Language.PORTUGUESE]: "Tentar novamente",
  },
  "credits-purchased": {
    [Language.ENGLISH]: "Credits purchased",
    [Language.SPANISH]: "Créditos comprados",
    [Language.PORTUGUESE]: "Créditos comprados",
  },
  "enter-your-email": {
    [Language.ENGLISH]: "Enter your email",
    [Language.SPANISH]: "Ingresa tu correo",
    [Language.PORTUGUESE]: "Insira seu email",
  },
  "email-required": {
    [Language.ENGLISH]: "Email is required",
    [Language.SPANISH]: "El correo electrónico es requerido",
    [Language.PORTUGUESE]: "O email é obrigatório",
  },
  "email-invalid": {
    [Language.ENGLISH]: "Please enter a valid email",
    [Language.SPANISH]: "Por favor ingresa un correo electrónico válido",
    [Language.PORTUGUESE]: "Por favor, insira um email válido",
  },
  "send-code": {
    [Language.ENGLISH]: "Send code",
    [Language.SPANISH]: "Enviar código",
    [Language.PORTUGUESE]: "Enviar código",
  },
  "sending-code": {
    [Language.ENGLISH]: "Sending code...",
    [Language.SPANISH]: "Enviando código...",
    [Language.PORTUGUESE]: "Enviando código...",
  },
  "create-account-title": {
    [Language.ENGLISH]: "Create account",
    [Language.SPANISH]: "Crear cuenta",
    [Language.PORTUGUESE]: "Criar conta",
  },
  "create-account-banner": {
    [Language.ENGLISH]:
      "We couldn't find an account with the email [email]. Complete your details to create your account.",
    [Language.SPANISH]:
      "No encontramos una cuenta con el correo [email]. Completa tus datos para crear tu cuenta.",
    [Language.PORTUGUESE]:
      "Não encontramos uma conta com o email [email]. Complete seus dados para criar sua conta.",
  },
  "missing-user-detail-banner": {
    [Language.ENGLISH]: "Your account already exists but we need to complete some additional details",
    [Language.SPANISH]: "Tu cuenta ya existe pero necesitamos que completes algunos datos adicionales",
    [Language.PORTUGUESE]: "Sua conta já existe, mas precisamos completar alguns dados adicionais.",
  },
  "switch-guest-welcome-banner": {
    [Language.ENGLISH]: "Welcome to Fluxi! Enter your details below to create your account.",
    [Language.SPANISH]: "¡Bienvenido a Fluxi! Ingresa tus datos a continuación para crear tu cuenta.",
    [Language.PORTUGUESE]: "Bem-vindo ao Fluxi! Insira seus dados abaixo para criar sua conta.",
  },
  name: {
    [Language.ENGLISH]: "Name",
    [Language.SPANISH]: "Nombre",
    [Language.PORTUGUESE]: "Nome",
  },
  "full-name-placeholder": {
    [Language.ENGLISH]: "Full name",
    [Language.SPANISH]: "Nombre Completo",
    [Language.PORTUGUESE]: "Nome completo",
  },
  "email-label": {
    [Language.ENGLISH]: "Email",
    [Language.SPANISH]: "Correo electrónico",
    [Language.PORTUGUESE]: "Email",
  },
  "phone-label": {
    [Language.ENGLISH]: "Phone",
    [Language.SPANISH]: "Celular",
    [Language.PORTUGUESE]: "Celular",
  },
  "phone-placeholder": {
    [Language.ENGLISH]: "+57 300...",
    [Language.SPANISH]: "+57 300...",
    [Language.PORTUGUESE]: "+57 300...",
  },
  "name-required": {
    [Language.ENGLISH]: "Name is required",
    [Language.SPANISH]: "El nombre es requerido",
    [Language.PORTUGUESE]: "O nome é obrigatório",
  },
  "phone-required": {
    [Language.ENGLISH]: "Phone is required",
    [Language.SPANISH]: "El celular es requerido",
    [Language.PORTUGUESE]: "O celular é obrigatório",
  },
  "enter-code-title": {
    [Language.ENGLISH]: "Enter the code",
    [Language.SPANISH]: "Ingresa el código",
    [Language.PORTUGUESE]: "Insira o código",
  },
  "we-sent-code-to": {
    [Language.ENGLISH]: "We sent a 6-digit code to",
    [Language.SPANISH]: "Hemos enviado un código de 6 dígitos a",
    [Language.PORTUGUESE]: "Enviamos um código de 6 dígitos para",
  },
  "enter-verification-code-label": {
    [Language.ENGLISH]: "Enter the verification code",
    [Language.SPANISH]: "Ingresa el código de verificación",
    [Language.PORTUGUESE]: "Insira o código de verificação",
  },
  "verifying-code": {
    [Language.ENGLISH]: "Verifying code...",
    [Language.SPANISH]: "Verificando código...",
    [Language.PORTUGUESE]: "Verificando código...",
  },
  "resend-code": {
    [Language.ENGLISH]: "Resend code",
    [Language.SPANISH]: "Reenviar código",
    [Language.PORTUGUESE]: "Reenviar código",
  },
  "resend-code-in": {
    [Language.ENGLISH]: "Resend code in [seconds]s",
    [Language.SPANISH]: "Reenviar código en [seconds]s",
    [Language.PORTUGUESE]: "Reenviar código em [seconds]s",
  },
  "change-email": {
    [Language.ENGLISH]: "Change email",
    [Language.SPANISH]: "Cambiar correo electrónico",
    [Language.PORTUGUESE]: "Alterar email",
  },
  "code-verified-success": {
    [Language.ENGLISH]: "Code verified successfully",
    [Language.SPANISH]: "Código verificado correctamente",
    [Language.PORTUGUESE]: "Código verificado com sucesso",
  },
  "verification-success-title": {
    [Language.ENGLISH]: "Verification successful!",
    [Language.SPANISH]: "¡Verificación Exitosa!",
    [Language.PORTUGUESE]: "Verificação bem-sucedida!",
  },
  "verification-success-description": {
    [Language.ENGLISH]: "Your email has been verified successfully",
    [Language.SPANISH]: "Tu correo electrónico ha sido verificado correctamente",
    [Language.PORTUGUESE]: "Seu email foi verificado com sucesso",
  },
  "verified-successfully": {
    [Language.ENGLISH]: "Verified successfully",
    [Language.SPANISH]: "Verificado exitosamente",
    [Language.PORTUGUESE]: "Verificado com sucesso",
  },
  "invalid-code": {
    [Language.ENGLISH]: "Invalid code. Please try again.",
    [Language.SPANISH]: "Código inválido. Por favor intenta de nuevo.",
    [Language.PORTUGUESE]: "Código inválido. Por favor tente novamente.",
  },
  "ai": {
    [Language.ENGLISH]: "AI",
    [Language.SPANISH]: "IA",
    [Language.PORTUGUESE]: "IA",
  },
  "magic-art": {
    [Language.ENGLISH]: "magic",
    [Language.SPANISH]: "arte de magia",
    [Language.PORTUGUESE]: "arte de mágica",
  },
  "sales-by-": {
    [Language.ENGLISH]: "Sales like",
    [Language.SPANISH]: "Ventas como por",
    [Language.PORTUGUESE]: "Vendas como por",
  },
  used: {
    [Language.ENGLISH]: "Used",
    [Language.SPANISH]: "Usados",
    [Language.PORTUGUESE]: "Usados",
  },
  remaining: {
    [Language.ENGLISH]: "Remaining",
    [Language.SPANISH]: "Restantes",
    [Language.PORTUGUESE]: "Restantes",
  },
  // PAYMENT RESULT PAGE
  "subscription-success-description": {
    [Language.ENGLISH]:
      "Great! You have subscribed to [plan_name], you can now enjoy all its benefits",
    [Language.SPANISH]:
      "¡Genial! Te has suscrito al [plan_name], ya puedes disfrutar de todos sus beneficios",
    [Language.PORTUGUESE]:
      "Ótimo! Você se inscreveu no [plan_name], agora pode aproveitar todos os benefícios",
  },
  "credits-purchased-title": {
    [Language.ENGLISH]: "Credits purchased!",
    [Language.SPANISH]: "¡Créditos comprados!",
    [Language.PORTUGUESE]: "Créditos comprados!",
  },
  "credits-success-description": {
    [Language.ENGLISH]:
      "Great! You have acquired [credits_amount] credits, you can now enjoy your new credits, remember to use them before [expiration_date] so they don't expire.",
    [Language.SPANISH]:
      "¡Genial! Has adquirido [credits_amount] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [expiration_date] para no dejarlos vencer.",
    [Language.PORTUGUESE]:
      "Ótimo! Você adquiriu [credits_amount] créditos, agora pode aproveitar seus novos créditos, lembre-se de usá-los antes de [expiration_date] para não expirarem.",
  },
  "credits-cancel-description": {
    [Language.ENGLISH]:
      "The purchase of [credits_amount] credits could not be completed. No charges have been made.",
    [Language.SPANISH]:
      "No se pudo completar la compra de [credits_amount] créditos. No se ha realizado ningún cargo.",
    [Language.PORTUGUESE]:
      "A compra de [credits_amount] créditos não pôde ser concluída. Nenhuma cobrança foi realizada.",
  },
  back: {
    [Language.ENGLISH]: "Back",
    [Language.SPANISH]: "Atrás",
    [Language.PORTUGUESE]: "Voltar",
  },
  cost: {
    [Language.ENGLISH]: "Cost",
    [Language.SPANISH]: "Costo",
    [Language.PORTUGUESE]: "Custo",
  },
  "no-valid-files-to-upload": {
    [Language.ENGLISH]: "No valid files to upload",
    [Language.SPANISH]: "No hay archivos válidos para subir",
    [Language.PORTUGUESE]: "Nenhum arquivo válido para upload",
  },
  "upload-photo": {
    [Language.ENGLISH]: "Upload photo",
    [Language.SPANISH]: "Subir foto",
    [Language.PORTUGUESE]: "Enviar foto",
  },
  "select-a-product-to-create-ads": {
    [Language.ENGLISH]: "Select a product to create ads",
    [Language.SPANISH]: "Selecciona un producto para crear anuncios",
    [Language.PORTUGUESE]: "Selecione um produto para criar anúncios",
  },
  "create-new-ad-with-ai": {
    [Language.ENGLISH]: "Create Image with AI",
    [Language.SPANISH]: "Crear Imagen con IA",
    [Language.PORTUGUESE]: "Criar Imagem com IA",
  },
  "creative": {
    [Language.ENGLISH]: "Creative",
    [Language.SPANISH]: "Creativo",
    [Language.PORTUGUESE]: "Creativo",
  },
  "creatives": {
    [Language.ENGLISH]: "creatives",
    [Language.SPANISH]: "creativos",
    [Language.PORTUGUESE]: "creativos",
  },
  "this-funnel-has-no-creatives": {
    [Language.ENGLISH]: "This funnel has no creatives",
    [Language.SPANISH]: "Este embudo no tiene creativos",
    [Language.PORTUGUESE]: "Este embudo não tem creativos",
  },
  "when-you-generate-creatives-they-will-appear-here": {
    [Language.ENGLISH]: "When you generate creatives, they will appear here",
    [Language.SPANISH]: "Cuando generes creativos, aparecerán aquí",
    [Language.PORTUGUESE]: "Quando você gerar creativos, eles aparecerão aqui",
  },
  "missing-query-param": {
    [Language.ENGLISH]: "Missing query param",
    [Language.SPANISH]: "Falta el query param",
    [Language.PORTUGUESE]: "Falta o query param",
  },
  "select-a-funnel": {
    [Language.ENGLISH]: "Select a funnel",
    [Language.SPANISH]: "Selecciona un embudo",
    [Language.PORTUGUESE]: "Selecione um embudo",
  },
  "choose-the-funnel-associated-with-the-new-ad": {
    [Language.ENGLISH]: "Choose the funnel associated with the new ad",
    [Language.SPANISH]: "Elige el embudo al que irá asociado el nuevo anuncio",
    [Language.PORTUGUESE]: "Selecione o embudo associado ao novo anúncio",
  },
  "what-type-of-ad-do-you-want-to-create": {
    [Language.ENGLISH]: "What type of ad do you want to create?",
    [Language.SPANISH]: "¿Qué tipo de anuncio quieres crear?",
    [Language.PORTUGUESE]: "Qual tipo de anúncio você deseja criar?",
  },
  "select-the-format-that-best-suits-your-campaign": {
    [Language.ENGLISH]: "Select the format that best suits your campaign",
    [Language.SPANISH]: "Selecciona el formato que mejor se adapte a tu campaña",
    [Language.PORTUGUESE]: "Selecione o formato que melhor se adapta à sua campanha",
  },
  "image-ad": {
    [Language.ENGLISH]: "Image Ad",
    [Language.SPANISH]: "Imagen Ad",
    [Language.PORTUGUESE]: "Anúncio de imagem",
  },
  "create-image-ads-with-ai-for-your-campaigns": {
    [Language.ENGLISH]: "Create image ads with AI for your campaigns",
    [Language.SPANISH]: "Crea imágenes publicitarias con IA para tus campañas",
    [Language.PORTUGUESE]: "Crie anúncios de imagem com IA para suas campanhas",
  },
  "video-ad": {
    [Language.ENGLISH]: "Video Ad",
    [Language.SPANISH]: "Video Ad",
    [Language.PORTUGUESE]: "Anúncio de vídeo",
  },
  "ad-studio": {
    [Language.ENGLISH]: "Ad Studio Image",
    [Language.SPANISH]: "Ad Studio Imagen",
    [Language.PORTUGUESE]: "Ad Studio Imagem",
  },
  "ad-studio-video": {
    [Language.ENGLISH]: "Ad Studio Video",
    [Language.SPANISH]: "Ad Studio Video",
    [Language.PORTUGUESE]: "Ad Studio Vídeo",
  },
  "configuration": {
    [Language.ENGLISH]: "Settings",
    [Language.SPANISH]: "Configuración",
    [Language.PORTUGUESE]: "Configuração",
  },
  "format": {
    [Language.ENGLISH]: "Format",
    [Language.SPANISH]: "Formato",
    [Language.PORTUGUESE]: "Formato",
  },
  "instructions": {
    [Language.ENGLISH]: "Instructions",
    [Language.SPANISH]: "Instrucciones",
    [Language.PORTUGUESE]: "Instruções",
  },
  "generate-1-image": {
    [Language.ENGLISH]: "Generate 1 image",
    [Language.SPANISH]: "Generar 1 imagen",
    [Language.PORTUGUESE]: "Gerar 1 imagem",
  },
  "all-products": {
    [Language.ENGLISH]: "All products",
    [Language.SPANISH]: "Todos los productos",
    [Language.PORTUGUESE]: "Todos os produtos",
  },
  "no-products-available": {
    [Language.ENGLISH]: "No products available",
    [Language.SPANISH]: "No hay productos disponibles",
    [Language.PORTUGUESE]: "Nenhum produto disponível",
  },
  "select-a-product": {
    [Language.ENGLISH]: "Select a product",
    [Language.SPANISH]: "Selecciona un producto",
    [Language.PORTUGUESE]: "Selecione um produto",
  },
  "select-the-product-for-which-you-want-to-create-the-ad": {
    [Language.ENGLISH]: "Select the product for which you want to create the ad",
    [Language.SPANISH]: "Selecciona el producto para el cual quieres crear el anuncio",
    [Language.PORTUGUESE]: "Selecione o produto para o qual você deseja criar o anúncio",
  },
  "remember-not-to-leave-the-page-so-you-dont-lose-the-progress-of-your-ad": {
    [Language.ENGLISH]: "Remember not to leave the page, so you don't lose the progress of your ad",
    [Language.SPANISH]: "Recuerda no salir de la página, así no perderás el progreso de tu anuncio",
    [Language.PORTUGUESE]: "Lembre-se de não sair da página, para não perder o progresso do seu anúncio",
  },
  "generating-ads": {
    [Language.ENGLISH]: "Generating ads",
    [Language.SPANISH]: "Generando anuncios",
    [Language.PORTUGUESE]: "Gerando anúncios",
  },
  "this-could-take-a-few-minutes": {
    [Language.ENGLISH]: "This could take a few minutes",
    [Language.SPANISH]: "Esto podría tomar unos minutos",
    [Language.PORTUGUESE]: "Isso pode levar alguns minutos",
  },
  "we-are-generating-your-ads": {
    [Language.ENGLISH]: "We are generating your ads",
    [Language.SPANISH]: "Estamos generando tus anuncios",
    [Language.PORTUGUESE]: "Estamos gerando seus anúncios",
  },
  "generating-your-ads": {
    [Language.ENGLISH]: "Generating your ads",
    [Language.SPANISH]: "Generando tus anuncios",
    [Language.PORTUGUESE]: "Gerando seus anúncios",
  },
  "click-on-a-style-to-add-it": {
    [Language.ENGLISH]: "Click on a style to add it",
    [Language.SPANISH]: "Haz clic en un estilo para agregarlo",
    [Language.PORTUGUESE]: "Clique em um estilo para adicioná-lo",
  },
  "viral": {
    [Language.ENGLISH]: "Viral",
    [Language.SPANISH]: "Viral",
    [Language.PORTUGUESE]: "Viral",
  },
  "offer": {
    [Language.ENGLISH]: "Offer",
    [Language.SPANISH]: "Oferta",
    [Language.PORTUGUESE]: "Oferta",
  },
  "testimonials": {
    [Language.ENGLISH]: "Testimonials",
    [Language.SPANISH]: "Testimonios",
    [Language.PORTUGUESE]: "Testimonios",
  },
  "no-creatives-available": {
    [Language.ENGLISH]: "No creatives available",
    [Language.SPANISH]: "Aún no tienes creativos disponibles.",
    [Language.PORTUGUESE]: "Nenhum creativo disponível.",
  },
  "create-a-creative-first": {
    [Language.ENGLISH]: "Create a creative first and then come back here.",
    [Language.SPANISH]: "Crea un creativo primero y luego vuelve aquí.",
    [Language.PORTUGUESE]: "Crie um creativo primeiro e depois volte aqui.",
  },
  "download": {
    [Language.ENGLISH]: "Download",
    [Language.SPANISH]: "Descargar",
    [Language.PORTUGUESE]: "Baixar",
  },
  "custom-reference": {
    [Language.ENGLISH]: "Custom reference",
    [Language.SPANISH]: "Referencia personalizada",
    [Language.PORTUGUESE]: "Referência personalizada",
  },
  "custom-reference-description": {
    [Language.ENGLISH]: "Upload a reference image to use as a custom style",
    [Language.SPANISH]: "Carga una imagen de referencia para usar como estilo personalizado",
    [Language.PORTUGUESE]: "Carregue uma imagem de referência para usar como estilo personalizado",
  },
  "see-my-hyphens": {
    [Language.ENGLISH]: "See my hyphens",
    [Language.SPANISH]: "Ver mis guiones",
    [Language.PORTUGUESE]: "Ver meus guias",
  },
  "verde": {
    [Language.ENGLISH]: "Green",
    [Language.SPANISH]: "Verde",
    [Language.PORTUGUESE]: "Verde",
  },
  "coral": {
    [Language.ENGLISH]: "Coral",
    [Language.SPANISH]: "Coral",
    [Language.PORTUGUESE]: "Coral",
  },
  "oro": {
    [Language.ENGLISH]: "Gold",
    [Language.SPANISH]: "Oro",
    [Language.PORTUGUESE]: "Oro",
  },
  "mono": {
    [Language.ENGLISH]: "Mono",
    [Language.SPANISH]: "Mono",
    [Language.PORTUGUESE]: "Mono",
  },
  "violeta": {
    [Language.ENGLISH]: "Violet",
    [Language.SPANISH]: "Violeta",
    [Language.PORTUGUESE]: "Violeta",
  },
  "no-name": {
    [Language.ENGLISH]: "No name",
    [Language.SPANISH]: "Sin nombre",
    [Language.PORTUGUESE]: "Sem nome",
  },
  "carousels": {
    [Language.ENGLISH]: "Carousels",
    [Language.SPANISH]: "Carruseles",
    [Language.PORTUGUESE]: "Carrosséis",
  },
  "custom": {
    [Language.ENGLISH]: "Custom",
    [Language.SPANISH]: "Personalizado",
    [Language.PORTUGUESE]: "Personalizado",
  },
  "your-styles": {
    [Language.ENGLISH]: "Your styles",
    [Language.SPANISH]: "Tus estilos",
    [Language.PORTUGUESE]: "Seus estilos",
  },
  "styles": {
    [Language.ENGLISH]: "styles",
    [Language.SPANISH]: "estilos",
    [Language.PORTUGUESE]: "estilos",
  },
  "no-styles-found": {
    [Language.ENGLISH]: "No styles found in this category",
    [Language.SPANISH]: "No hay estilos en esta categoría",
    [Language.PORTUGUESE]: "Nenhum estilo nesta categoria",
  },
  "select-styles-from-the-gallery": {
    [Language.ENGLISH]: "Select styles from the gallery",
    [Language.SPANISH]: "Selecciona estilos de la galería",
    [Language.PORTUGUESE]: "Selecione estilos da galeria",
  },
  "example-style-aggressive-close-up-of-the-product": {
    [Language.ENGLISH]: "Example: aggressive style, close-up of the product...",
    [Language.SPANISH]: "Ejemplo: estilo agresivo, close-up del producto...",
    [Language.PORTUGUESE]: "Exemplo: estilo agressivo, close-up do produto...",
  },
  "coming-soon": {
    [Language.ENGLISH]: "Coming soon",
    [Language.SPANISH]: "Próximamente",
    [Language.PORTUGUESE]: "Em breve",
  },
  "video-ads-with-ai-avatars-and-cloned-voices": {
    [Language.ENGLISH]: "Video ads with AI avatars and cloned voices",
    [Language.SPANISH]: "Videos publicitarios con avatares IA y voces clonadas",
    [Language.PORTUGUESE]: "Vídeos publicitários com avatares IA e vozes clonadas",
  },
  "create-image-ad-with-ai": {
    [Language.ENGLISH]: "Create image ad with AI",
    [Language.SPANISH]: "Crear imagen ad con IA",
    [Language.PORTUGUESE]: "Criar anúncio de imagem com IA",
  },
  "configure-the-product-details-to-generate-your-ad": {
    [Language.ENGLISH]: "Configure the product details to generate your ad",
    [Language.SPANISH]: "Configura los detalles del producto para generar tu anuncio",
    [Language.PORTUGUESE]: "Configure os detalhes do produto para gerar seu anúncio",
  },
  "these-data-come-from-your-funnel": {
    [Language.ENGLISH]: "These data come from your funnel. You can edit them if you want.",
    [Language.SPANISH]: "Estos datos vienen de tu embudo. Puedes editarlos si lo deseas.",
    [Language.PORTUGUESE]: "Estes dados vêm do seu embudo. Você pode editá-los se quiser.",
  },
  "uploading...": {
    [Language.ENGLISH]: "Uploading...",
    [Language.SPANISH]: "Subiendo...",
    [Language.PORTUGUESE]: "Enviando...",
  },
  "change-image": {
    [Language.ENGLISH]: "Change image",
    [Language.SPANISH]: "Cambiar imagen",
    [Language.PORTUGUESE]: "Alterar imagem",
  },
  "tell-us-how-you-want-your-ad-to-look": {
    [Language.ENGLISH]: "Tell us how you want your ad to look",
    [Language.SPANISH]: "Cuéntanos cómo quieres que se vea tu anuncio: estilo visual, colores, elementos, escenario, etc.",
    [Language.PORTUGUESE]: "Conte-nos como você quer que seu anúncio pareça: estilo visual, cores, elementos, cenário, etc.",
  },
  "example-prompt-create-image-ad-with-ai": {
    [Language.ENGLISH]: "Ex: I want a minimalist ad with a blue gradient background, the product centered with a soft glow, and text highlighting the main benefits...",
    [Language.SPANISH]: "Ej: Quiero un anuncio minimalista con fondo degradado azul, el producto centrado con un brillo suave, y texto que destaque los beneficios principales...",
    [Language.PORTUGUESE]: "Ex: Quero um anúncio minimalista com fundo degradado azul, o produto centralizado com um brilho suave, e texto que destaque os benefícios principais...",
  },
  "this-field-is-required-to-generate-your-ad": {
    [Language.ENGLISH]: "This field is required to generate your ad",
    [Language.SPANISH]: "Este campo es obligatorio para generar tu anuncio",
    [Language.PORTUGUESE]: "Este campo é obrigatório para gerar seu anúncio",
  },
  "generate-ad": {
    [Language.ENGLISH]: "Generate ad",
    [Language.SPANISH]: "Generar anuncio",
    [Language.PORTUGUESE]: "Gerar anúncio",
  },
  "product-image": {
    [Language.ENGLISH]: "Product image",
    [Language.SPANISH]: "Imagen del producto",
    [Language.PORTUGUESE]: "Imagem do produto",
  },
  "jpg-png-webp": {
    [Language.ENGLISH]: "JPG, PNG or WebP",
    [Language.SPANISH]: "JPG, PNG o WebP",
    [Language.PORTUGUESE]: "JPG, PNG ou WebP",
  },
  "describe-your-ideal-ad": {
    [Language.ENGLISH]: "Describe your ideal ad",
    [Language.SPANISH]: "Describe tu anuncio ideal",
    [Language.PORTUGUESE]: "Descreva seu anúncio ideal",
  },
  "required": {
    [Language.ENGLISH]: "Required",
    [Language.SPANISH]: "Requerido",
    [Language.PORTUGUESE]: "Requerido",
  },
  link: {
    [Language.ENGLISH]: "Link",
    [Language.SPANISH]: "Link",
    [Language.PORTUGUESE]: "Link",
  },
  "increase-your-revenue-with-complementary-products": {
    [Language.ENGLISH]: "Increase your revenue with complementary products",
    [Language.SPANISH]: "Aumenta tu facturación con productos complementarios",
    [Language.PORTUGUESE]: "Aumente sua receita com produtos complementares",
  },
  "add-order-bump": {
    [Language.ENGLISH]: "Add order bump",
    [Language.SPANISH]: "Agregar order bump",
    [Language.PORTUGUESE]: "Adicionar order bump",
  },
  "what-is-an-order-bump": {
    [Language.ENGLISH]: "What is an order bump?",
    [Language.SPANISH]: "¿Qué es un order bump?",
    [Language.PORTUGUESE]: "O que é um order bump?",
  },
  "add-upsell": {
    [Language.ENGLISH]: "Add upsell",
    [Language.SPANISH]: "Agregar upsell",
    [Language.PORTUGUESE]: "Adicionar upsell",
  },
  "what-is-an-upsell": {
    [Language.ENGLISH]: "What is an upsell?",
    [Language.SPANISH]: "¿Qué es un upsell?",
    [Language.PORTUGUESE]: "O que é um upsell?",
  },
  "only-a-few-steps-left": {
    [Language.ENGLISH]: "Only a few steps left",
    [Language.SPANISH]: "Falta muy poco",
    [Language.PORTUGUESE]: "Falta pouco",
  },
  "generate-with-ai": {
    [Language.ENGLISH]: "Generate with AI",
    [Language.SPANISH]: "Generar con IA",
    [Language.PORTUGUESE]: "Gerar com IA",
  },
  warranty: {
    [Language.ENGLISH]: "Warranty",
    [Language.SPANISH]: "Garantía",
    [Language.PORTUGUESE]: "Garantia",
  },
  "load-a-product-to-create-your-page": {
    [Language.ENGLISH]: "Load a product to ",
    [Language.SPANISH]: "Carga un producto para ",
    [Language.PORTUGUESE]: "Carregue um produto para ",
  },
  "create-your-page": {
    [Language.ENGLISH]: "create your page",
    [Language.SPANISH]: "crear tu página",
    [Language.PORTUGUESE]: "criar sua página",
  },
  "no-previous-products-available": {
    [Language.ENGLISH]: "No previous products available",
    [Language.SPANISH]: "No hay productos previos disponibles",
    [Language.PORTUGUESE]: "Nenhum produto anterior disponível",
  },
  "select-one-or-more-sales-angles": {
    [Language.ENGLISH]: "Select one or more sales angles",
    [Language.SPANISH]: "Selecciona uno o varios ángulos de venta",
    [Language.PORTUGUESE]: "Selecione um ou mais ângulos de venda",
  },
  "we-will-create-a-page-with-each-selected-sales-angle": {
    [Language.ENGLISH]: "We will create a page with each selected sales angle",
    [Language.SPANISH]: "Crearemos una página con cada ángulo seleccionado",
    [Language.PORTUGUESE]: "Criaremos uma página com cada ângulo selecionado",
  },
  "enter-custom-sales-angle": {
    [Language.ENGLISH]: "Enter custom sales angle",
    [Language.SPANISH]: "Ingresar ángulo personalizado",
    [Language.PORTUGUESE]: "Inserir ângulo personalizado",
  },
  "custom-sections-only": {
    [Language.ENGLISH]: "Custom sections only",
    [Language.SPANISH]: "Solo secciones personalizadas",
    [Language.PORTUGUESE]: "Apenas seções personalizadas",
  },
  "custom-sections-only-description": {
    [Language.ENGLISH]: "Create funnel with custom sections only",
    [Language.SPANISH]: "Crear embudo solo con secciones personalizadas",
    [Language.PORTUGUESE]: "Criar funil apenas com seções personalizadas",
  },
  "create-page": {
    [Language.ENGLISH]: "Create page",
    [Language.SPANISH]: "Crear página",
    [Language.PORTUGUESE]: "Criar página",
  },
  "how-many-funnels": {
    [Language.ENGLISH]: "How many funnels do you want to create?",
    [Language.SPANISH]: "¿Cuántos embudos quieres crear?",
    [Language.PORTUGUESE]: "Quantos funis você quer criar?",
  },
  "funnel-count-tip": {
    [Language.ENGLISH]: "Sellers who create 3 or more funnels are 47% more likely to find their winning angle.",
    [Language.SPANISH]: "Los vendedores que crean 3 o más embudos tienen un 47% más de probabilidad de encontrar su ángulo ganador.",
    [Language.PORTUGUESE]: "Vendedores que criam 3 ou mais funis têm 47% mais chance de encontrar seu ângulo vencedor.",
  },
  "personalize-funnels": {
    [Language.ENGLISH]: "Personalize your funnels",
    [Language.SPANISH]: "Personaliza tus embudos",
    [Language.PORTUGUESE]: "Personalize seus funis",
  },
  "personalize-funnels-description": {
    [Language.ENGLISH]: "Select a funnel to edit its design, structure, and angle",
    [Language.SPANISH]: "Selecciona un embudo para editar su diseño, estructura y ángulo",
    [Language.PORTUGUESE]: "Selecione um funil para editar seu design, estrutura e ângulo",
  },
  "design-tab": {
    [Language.ENGLISH]: "Design",
    [Language.SPANISH]: "Diseño",
    [Language.PORTUGUESE]: "Design",
  },
  "structure-tab": {
    [Language.ENGLISH]: "Structure",
    [Language.SPANISH]: "Estructura",
    [Language.PORTUGUESE]: "Estrutura",
  },
  "angle-tab": {
    [Language.ENGLISH]: "Angle",
    [Language.SPANISH]: "Ángulo",
    [Language.PORTUGUESE]: "Ângulo",
  },
  "ads-tab": {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  "select-ad-templates": {
    [Language.ENGLISH]: "AD TEMPLATES",
    [Language.SPANISH]: "PLANTILLAS DE ANUNCIOS",
    [Language.PORTUGUESE]: "MODELOS DE ANÚNCIOS",
  },
  "n-ads-selected": {
    [Language.ENGLISH]: "{n} template(s) selected",
    [Language.SPANISH]: "{n} plantilla(s) seleccionada(s)",
    [Language.PORTUGUESE]: "{n} modelo(s) selecionado(s)",
  },
  "max-ad-templates-reached": {
    [Language.ENGLISH]: "Maximum of {n} templates per funnel reached",
    [Language.SPANISH]: "Llegaste al máximo de {n} plantillas por embudo",
    [Language.PORTUGUESE]: "Máximo de {n} modelos por funil atingido",
  },
  "ads-count-label": {
    [Language.ENGLISH]: "ads",
    [Language.SPANISH]: "anuncios",
    [Language.PORTUGUESE]: "anúncios",
  },
  "video-studio": {
    [Language.ENGLISH]: "Videos",
    [Language.SPANISH]: "Videos",
    [Language.PORTUGUESE]: "Videos",
  },
  "estimated-cost": {
    [Language.ENGLISH]: "Estimated cost",
    [Language.SPANISH]: "Costo estimado",
    [Language.PORTUGUESE]: "Custo estimado",
  },
  "template-design": {
    [Language.ENGLISH]: "TEMPLATE / DESIGN",
    [Language.SPANISH]: "PLANTILLA / DISEÑO",
    [Language.PORTUGUESE]: "MODELO / DESIGN",
  },
  "funnel-structure": {
    [Language.ENGLISH]: "FUNNEL STRUCTURE",
    [Language.SPANISH]: "ESTRUCTURA DEL EMBUDO",
    [Language.PORTUGUESE]: "ESTRUTURA DO FUNIL",
  },
  "select-angles-for-funnel": {
    [Language.ENGLISH]: "SALES ANGLES",
    [Language.SPANISH]: "ÁNGULOS DE VENTA",
    [Language.PORTUGUESE]: "ÂNGULOS DE VENDA",
  },
  "sections": {
    [Language.ENGLISH]: "sections",
    [Language.SPANISH]: "secciones",
    [Language.PORTUGUESE]: "seções",
  },
  "all-ready-to-create": {
    [Language.ENGLISH]: "All ready to create",
    [Language.SPANISH]: "Todo listo para crear",
    [Language.PORTUGUESE]: "Tudo pronto para criar",
  },
  "review-summary": {
    [Language.ENGLISH]: "Review the summary of what Fluxi will generate for you",
    [Language.SPANISH]: "Revisa el resumen de lo que Fluxi generará para ti",
    [Language.PORTUGUESE]: "Revise o resumo do que Fluxi irá gerar para você",
  },
  "active-sections": {
    [Language.ENGLISH]: "Active sections",
    [Language.SPANISH]: "Secciones activas",
    [Language.PORTUGUESE]: "Seções ativas",
  },
  "breakdown-by-funnel": {
    [Language.ENGLISH]: "BREAKDOWN BY FUNNEL",
    [Language.SPANISH]: "DESGLOSE POR EMBUDO",
    [Language.PORTUGUESE]: "DETALHAMENTO POR FUNIL",
  },
  "generate-all": {
    [Language.ENGLISH]: "Generate all",
    [Language.SPANISH]: "Generar todo",
    [Language.PORTUGUESE]: "Gerar tudo",
  },
  "add-funnel": {
    [Language.ENGLISH]: "Add funnel",
    [Language.SPANISH]: "Agregar embudo",
    [Language.PORTUGUESE]: "Adicionar funil",
  },
  "please-select-design-for-all-funnels": {
    [Language.ENGLISH]: "Please select a design for all funnels",
    [Language.SPANISH]: "Por favor selecciona un diseño para todos los embudos",
    [Language.PORTUGUESE]: "Por favor selecione um design para todos os funis",
  },
  "design-required": {
    [Language.ENGLISH]: "Design required",
    [Language.SPANISH]: "Diseño requerido",
    [Language.PORTUGUESE]: "Design necessário",
  },

  "survey-title": {
    [Language.ENGLISH]: "Answer a few questions to personalize your account",
    [Language.SPANISH]: "Responde unas preguntas para personalizar tu cuenta",
    [Language.PORTUGUESE]:
      "Responda algumas perguntas para personalizar sua conta",
  },
  "start-survey": {
    [Language.ENGLISH]: "Start survey",
    [Language.SPANISH]: "Comenzar",
    [Language.PORTUGUESE]: "Iniciar",
  },
  "write-your-answer-here": {
    [Language.ENGLISH]: "Write your answer here",
    [Language.SPANISH]: "Escribe tu respuesta aquí",
    [Language.PORTUGUESE]: "Escreva sua resposta aqui",
  },
  "go-to-account": {
    [Language.ENGLISH]: "Go to my account",
    [Language.SPANISH]: "Ir a mi cuenta",
    [Language.PORTUGUESE]: "Ir para minha conta",
  },
  "all-set": {
    [Language.ENGLISH]: "All set",
    [Language.SPANISH]: "Todo listo",
    [Language.PORTUGUESE]: "Tudo pronto",
  },
  "whatsapp-community-message": {
    [Language.ENGLISH]: "Don't miss our exclusive events and the latest Fluxi updates!\n\nJoin the WhatsApp community now.",
    [Language.SPANISH]: "¡No te pierdas de nuestros eventos exclusivos y de las actualizaciones de Fluxi!\n\nIngresa ahora a la comunidad de Whatsapp",
    [Language.PORTUGUESE]: "Não perca nossos eventos exclusivos e as atualizações do Fluxi!\n\nEntre agora na comunidade do WhatsApp.",
  },
  "whatsapp-community-join": {
    [Language.ENGLISH]: "Join the Fluxi community",
    [Language.SPANISH]: "Unirme a la comunidad de Fluxi",
    [Language.PORTUGUESE]: "Entrar na comunidade do Fluxi",
  },
  "whatsapp-community-already-member": {
    [Language.ENGLISH]: "I'm already part of the Fluxi community",
    [Language.SPANISH]: "Ya hago parte de la comunidad de Fluxi",
    [Language.PORTUGUESE]: "Já faço parte da comunidade do Fluxi",
  },
  "Nombres y apellidos": {
    [Language.ENGLISH]: "First and last name",
    [Language.SPANISH]: "Nombres y apellidos",
    [Language.PORTUGUESE]: "Nome e sobrenome",
  },
  "Ingresa tu nombre completo": {
    [Language.ENGLISH]: "Enter your full name",
    [Language.SPANISH]: "Ingresa tu nombre completo",
    [Language.PORTUGUESE]: "Digite seu nome completo",
  },










  // SURVEY TRANSLATIONS
  "¿Cual es tu numero de celular?": {
    [Language.ENGLISH]: "What is your phone number?",
    [Language.SPANISH]: "¿Cuál es tu número de teléfono?",
    [Language.PORTUGUESE]: "Qual é seu número de telefone?",
  },

  "Asegurate de agregar el prefijo de tu pais (ejemplo: +57 3xxxxxx)": {
    [Language.ENGLISH]:
      "Make sure to add the prefix of your country (example: +57 3xxxxxx)",
    [Language.SPANISH]:
      "Asegúrate de agregar el prefijo de tu país (ejemplo: +57 3xxxxxx)",
    [Language.PORTUGUESE]:
      "Certifique-se de adicionar o prefixo do seu país (exemplo: +57 3xxxxxx)",
  },

  "¿Ya has tenido ventas online?": {
    [Language.ENGLISH]: "Have you had online sales before?",
    [Language.SPANISH]: "¿Ya has tenido ventas online?",
    [Language.PORTUGUESE]: "Você já teve vendas online?",
  },

  "¿Por qué medios has vendido?": {
    [Language.ENGLISH]: "Which channels have you sold through?",
    [Language.SPANISH]: "¿Por qué medios has vendido?",
    [Language.PORTUGUESE]: "Por quais canais você vendeu?",
  },

  "Puedes seleccionar varios": {
    [Language.ENGLISH]: "You can select multiple options",
    [Language.SPANISH]: "Puedes seleccionar varios",
    [Language.PORTUGUESE]: "Você pode selecionar várias opções",
  },

  "¿Vendes en tienda física?": {
    [Language.ENGLISH]: "Do you sell in a physical store?",
    [Language.SPANISH]: "¿Vendes en tienda física?",
    [Language.PORTUGUESE]: "Você vende em loja física?",
  },

  "¿Cuánto vendes al mes?": {
    [Language.ENGLISH]: "How much do you sell per month?",
    [Language.SPANISH]: "¿Cuánto vendes al mes?",
    [Language.PORTUGUESE]: "Quanto você vende por mês?",
  },

  "Aproximadamente, en pesos colombianos": {
    [Language.ENGLISH]: "Approximately, in Colombian pesos",
    [Language.SPANISH]: "Aproximadamente, en pesos colombianos",
    [Language.PORTUGUESE]: "Aproximadamente, em pesos colombianos",
  },

  "¿Cuántos productos has vendido?": {
    [Language.ENGLISH]: "How many products have you sold?",
    [Language.SPANISH]: "¿Cuántos productos has vendido?",
    [Language.PORTUGUESE]: "Quantos produtos você vendeu?",
  },

  "Productos diferentes que ofreces": {
    [Language.ENGLISH]: "Different products you offer",
    [Language.SPANISH]: "Productos diferentes que ofreces",
    [Language.PORTUGUESE]: "Produtos diferentes que você oferece",
  },

  "¿Qué productos vendes?": {
    [Language.ENGLISH]: "What products do you sell?",
    [Language.SPANISH]: "¿Qué productos vendes?",
    [Language.PORTUGUESE]: "Quais produtos você vende?",
  },

  "Cuales productos ofreces": {
    [Language.ENGLISH]: "Which products you offer",
    [Language.SPANISH]: "Cuales productos ofreces",
    [Language.PORTUGUESE]: "Quais produtos você oferece",
  },

  "¿Qué crees que te ha hecho falta?": {
    [Language.ENGLISH]: "What do you think you’ve been missing?",
    [Language.SPANISH]: "¿Qué crees que te ha hecho falta?",
    [Language.PORTUGUESE]: "O que você acha que está faltando?",
  },

  "Para empezar a vender online": {
    [Language.ENGLISH]: "To start selling online",
    [Language.SPANISH]: "Para empezar a vender online",
    [Language.PORTUGUESE]: "Para começar a vender online",
  },

  "¿Por qué decidiste comprar Fluxi?": {
    [Language.ENGLISH]: "Why did you decide to buy Fluxi?",
    [Language.SPANISH]: "¿Por qué decidiste comprar Fluxi?",
    [Language.PORTUGUESE]: "Por que você decidiu comprar o Fluxi?",
  },

  "Cuéntanos qué te motivó a elegir nuestra plataforma": {
    [Language.ENGLISH]: "Tell us what motivated you to choose our platform",
    [Language.SPANISH]: "Cuéntanos qué te motivó a elegir nuestra plataforma",
    [Language.PORTUGUESE]:
      "Conte-nos o que motivou você a escolher nossa plataforma",
  },

  "Todo listo": {
    [Language.ENGLISH]: "All set",
    [Language.SPANISH]: "Todo listo",
    [Language.PORTUGUESE]: "Tudo pronto",
  },
  Sí: {
    [Language.ENGLISH]: "Yes",
    [Language.SPANISH]: "Sí",
    [Language.PORTUGUESE]: "Sim",
  },

  No: {
    [Language.ENGLISH]: "No",
    [Language.SPANISH]: "No",
    [Language.PORTUGUESE]: "Não",
  },

  Whatsapp: {
    [Language.ENGLISH]: "Whatsapp",
    [Language.SPANISH]: "Whatsapp",
    [Language.PORTUGUESE]: "Whatsapp",
  },

  "Página web": {
    [Language.ENGLISH]: "Website",
    [Language.SPANISH]: "Página web",
    [Language.PORTUGUESE]: "Site",
  },

  "Tienda física": {
    [Language.ENGLISH]: "Physical store",
    [Language.SPANISH]: "Tienda física",
    [Language.PORTUGUESE]: "Loja física",
  },

  "1": {
    [Language.ENGLISH]: "1",
    [Language.SPANISH]: "1",
    [Language.PORTUGUESE]: "1",
  },

  "10": {
    [Language.ENGLISH]: "10",
    [Language.SPANISH]: "10",
    [Language.PORTUGUESE]: "10",
  },

  "50": {
    [Language.ENGLISH]: "50",
    [Language.SPANISH]: "50",
    [Language.PORTUGUESE]: "50",
  },

  "100": {
    [Language.ENGLISH]: "100",
    [Language.SPANISH]: "100",
    [Language.PORTUGUESE]: "100",
  },

  "Mejor producto": {
    [Language.ENGLISH]: "Better product",
    [Language.SPANISH]: "Mejor producto",
    [Language.PORTUGUESE]: "Produto melhor",
  },

  "Mejor precio": {
    [Language.ENGLISH]: "Better price",
    [Language.SPANISH]: "Mejor precio",
    [Language.PORTUGUESE]: "Preço melhor",
  },

  "Mejor contenido en redes sociales": {
    [Language.ENGLISH]: "Better social media content",
    [Language.SPANISH]: "Mejor contenido en redes sociales",
    [Language.PORTUGUESE]: "Melhor conteúdo nas redes sociais",
  },

  "Mejor página web": {
    [Language.ENGLISH]: "Better website",
    [Language.SPANISH]: "Mejor página web",
    [Language.PORTUGUESE]: "Site melhor",
  },

  "No sé": {
    [Language.ENGLISH]: "I don't know",
    [Language.SPANISH]: "No sé",
    [Language.PORTUGUESE]: "Não sei",
  },

  "$1 millón": {
    [Language.ENGLISH]: "$1 million COP",
    [Language.SPANISH]: "$1 millón",
    [Language.PORTUGUESE]: "1 milhão COP",
  },

  "$10 millones": {
    [Language.ENGLISH]: "$10 million COP",
    [Language.SPANISH]: "$10 millones",
    [Language.PORTUGUESE]: "10 milhões COP",
  },

  "$50 millones": {
    [Language.ENGLISH]: "$50 million COP",
    [Language.SPANISH]: "$50 millones",
    [Language.PORTUGUESE]: "50 milhões COP",
  },

  "$100 millones": {
    [Language.ENGLISH]: "$100 million COP",
    [Language.SPANISH]: "$100 millones",
    [Language.PORTUGUESE]: "100 milhões COP",
  },

  "$500 millones": {
    [Language.ENGLISH]: "$500 million COP",
    [Language.SPANISH]: "$500 millones",
    [Language.PORTUGUESE]: "500 milhões COP",
  },

  "$1 millón-USD": {
    [Language.ENGLISH]: "$1,000 USD",
    [Language.SPANISH]: "$1,000 USD",
    [Language.PORTUGUESE]: "$1,000 USD",
  },

  "$10 millones-USD": {
    [Language.ENGLISH]: "$5,000 USD",
    [Language.SPANISH]: "$5,000 USD",
    [Language.PORTUGUESE]: "$5,000 USD",
  },

  "$50 millones-USD": {
    [Language.ENGLISH]: "$10,000 USD",
    [Language.SPANISH]: "$10,000 USD",
    [Language.PORTUGUESE]: "$10,000 USD",
  },

  "$100 millones-USD": {
    [Language.ENGLISH]: "$50,000 USD",
    [Language.SPANISH]: "$50,000 USD",
    [Language.PORTUGUESE]: "$50,000 USD",
  },

  "$500 millones-USD": {
    [Language.ENGLISH]: "$100,000 USD",
    [Language.SPANISH]: "$100,000 USD",
    [Language.PORTUGUESE]: "$100,000 USD",
  },

  "describe-your-custom-sales-angle-placeholder-manual-entry": {
    [Language.ENGLISH]: "Describe your custom sales angle...",
    [Language.SPANISH]: "Escribe tu angulo de venta...",
    [Language.PORTUGUESE]: "Descreva seu ângulo de venda personalizado...",
  },
  "add": {
    [Language.ENGLISH]: "Add",
    [Language.SPANISH]: "Agregar",
    [Language.PORTUGUESE]: "Adicionar",
  },
  "counter-delivery": {
    [Language.ENGLISH]: "Cash on payment",
    [Language.SPANISH]: "Contra entrega",
    [Language.PORTUGUESE]: "Entrega contra",
  },
  "you-must-spend-these-credits-before": {
    [Language.ENGLISH]: "You must spend these credits before",
    [Language.SPANISH]: "Debes gastar estos créditos antes del",
    [Language.PORTUGUESE]: "Você deve gastar esses créditos antes do",
  },
  "when-your-credits-will-be-renewed": {
    [Language.ENGLISH]: "when your credits will be renewed",
    [Language.SPANISH]: "cuando se te renovarán los créditos",
    [Language.PORTUGUESE]: "quando seus créditos serão renovados",
  },
  "Plan Lite": {
    [Language.ENGLISH]: "Lite Plan",
    [Language.SPANISH]: "Plan Lite",
    [Language.PORTUGUESE]: "Plano Lite",
  },
  "Plan Básico": {
    [Language.ENGLISH]: "Basic Plan",
    [Language.SPANISH]: "Plan Básico",
    [Language.PORTUGUESE]: "Plano Básico",
  },
  "Plan Medio": {
    [Language.ENGLISH]: "Medium Plan",
    [Language.SPANISH]: "Plan Medio",
    [Language.PORTUGUESE]: "Plano Médio",
  },
  "Plan Avanzado": {
    [Language.ENGLISH]: "Advanced Plan",
    [Language.SPANISH]: "Plan Avanzado",
    [Language.PORTUGUESE]: "Plano Avançado",
  },
  "Plan Master": {
    [Language.ENGLISH]: "Master Plan",
    [Language.SPANISH]: "Plan Master",
    [Language.PORTUGUESE]: "Plano Master",
  },
  "Suscripción Mensual Lite": {
    [Language.ENGLISH]: "Monthly Lite Plan",
    [Language.SPANISH]: "Suscripción Mensual Lite",
    [Language.PORTUGUESE]: "Plano Mensal Lite",
  },
  "canada": {
    [Language.ENGLISH]: "Canada",
    [Language.SPANISH]: "Canada",
    [Language.PORTUGUESE]: "Canadá",
  },
  "hello": {
    [Language.ENGLISH]: "Hello!",
    [Language.SPANISH]: "¡Hola!",
    [Language.PORTUGUESE]: "¡Olá!",
  },
  "help-me-create-your-first-page": {
    [Language.ENGLISH]: "I'll help you create your first page",
    [Language.SPANISH]: "Te ayudaré a crear tu primera página",
    [Language.PORTUGUESE]: "Vou ajudar você a criar sua primeira página",
  },
  "do-you-prefer-to-see-the-training-first": {
    [Language.ENGLISH]: "Do you prefer to see the training first?",
    [Language.SPANISH]: "¿Prefieres ver el entrenamiento primero?",
    [Language.PORTUGUESE]: "Prefere ver o treinamento primeiro?",
  },
  "go-to-training": {
    [Language.ENGLISH]: "Go to training",
    [Language.SPANISH]: "Ir al entrenamiento",
    [Language.PORTUGUESE]: "Ir para o treinamento",
  },
  "let's-start": {
    [Language.ENGLISH]: "Let's start",
    [Language.SPANISH]: "Empecemos",
    [Language.PORTUGUESE]: "Vamos começar",
  },

  // TUTORIAL CREATE SALES PAGE
  "Crear página de ventas": {
    [Language.ENGLISH]: "Create sales page",
    [Language.SPANISH]: "Crear página de ventas",
    [Language.PORTUGUESE]: "Criar página de vendas",
  },
  "Inicia dándole clic al botón para empezar a crear tu primera página de ventas de manera guiada.": {
    [Language.ENGLISH]: "Start by clicking the button to start creating your first sales page guided.",
    [Language.SPANISH]: "Inicia dándole clic al botón para empezar a crear tu primera página de ventas de manera guiada.",
    [Language.PORTUGUESE]: "Inicie clicando no botão para começar a criar sua primeira página de vendas guiada.",
  },
  "Elige cómo empezar": {
    [Language.ENGLISH]: "Choose how to start",
    [Language.SPANISH]: "Elige cómo empezar",
    [Language.PORTUGUESE]: "Escolha como começar",
  },
  "Tendrás 3 opciones diferentes para cargar tu producto ganador.": {
    [Language.ENGLISH]: "You will have 3 different options to load your winning product.",
    [Language.SPANISH]: "Tendrás 3 opciones diferentes para cargar tu producto ganador.",
    [Language.PORTUGUESE]: "Você terá 3 opções diferentes para carregar seu produto vencedor.",
  },
  "Order Bump": {
    [Language.ENGLISH]: "Order Bump",
    [Language.SPANISH]: "Order Bump",
    [Language.PORTUGUESE]: "Order Bump",
  },
  "Es una oferta rápida en el checkout. Perfecto para artículos pequeños o complementarios.": {
    [Language.ENGLISH]: "It is a quick offer at checkout. Perfect for small or complementary items.",
    [Language.SPANISH]: "Es una oferta rápida en el checkout. Perfecto para artículos pequeños o complementarios.",
    [Language.PORTUGUESE]: "É uma oferta rápida no checkout. Perfeito para itens pequenos ou complementares.",
  },
  "Upsell": {
    [Language.ENGLISH]: "Upsell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  "Ofrece un producto adicional, o un descuento atractivo, aumenta el ticket de venta.": {
    [Language.ENGLISH]: "Offer an additional product, or an attractive discount, increase the sales ticket.",
    [Language.SPANISH]: "Ofrece un producto adicional, o un descuento atractivo, aumenta el ticket de venta.",
    [Language.PORTUGUESE]: "Ofereça um produto adicional, ou um desconto atraente, aumente o ticket de venda.",
  },
  "Ángulos de venta": {
    [Language.ENGLISH]: "Sales angles",
    [Language.SPANISH]: "Ángulos de venta",
    [Language.PORTUGUESE]: "Ângulos de venda",
  },
  "Selecciona el enfoque de marketing ideal para vender tu producto. Identificamos los dolores mas importantes de tu usuario final, para generar el contenido persuasivo de toda tu pagina de ventas y maximizar tus conversiones.": {
    [Language.ENGLISH]: "Select the ideal marketing focus to sell your product. We identify the most important pains of your final user, to generate the persuasive content of your entire sales page and maximize your conversions.",
    [Language.SPANISH]: "Selecciona el enfoque de marketing ideal para vender tu producto. Identificamos los dolores mas importantes de tu usuario final, para generar el contenido persuasivo de toda tu pagina de ventas y maximizar tus conversiones.",
    [Language.PORTUGUESE]: "Selecione o foco de marketing ideal para vender seu produto. Identificamos os dolores mais importantes do seu usuário final, para gerar o conteúdo persuasivo de toda sua página de vendas e maximizar suas conversões.",
  },
  "¡Listo!, estamos creando tu página de ventas": {
    [Language.ENGLISH]: "Ready, we are creating your sales page",
    [Language.SPANISH]: "¡Listo!, estamos creando tu página de ventas",
    [Language.PORTUGUESE]: "Pronto, estamos criando sua página de vendas",
  },
  "¡Estará lista en algunos minutos! Mientras esperas, puedes seguir explorando Fluxi.": {
    [Language.ENGLISH]: "It will be ready in a few minutes! While you wait, you can continue exploring Fluxi.",
    [Language.SPANISH]: "¡Estará lista en algunos minutos! Mientras esperas, puedes seguir explorando Fluxi.",
    [Language.PORTUGUESE]: "Pronto, estará pronta em alguns minutos! Enquanto espera, você pode continuar explorando o Fluxi.",
  },
  "finalize": {
    [Language.ENGLISH]: "Finalize",
    [Language.SPANISH]: "Finalizar",
    [Language.PORTUGUESE]: "Finalizar",
  },
  "understood": {
    [Language.ENGLISH]: "Understood",
    [Language.SPANISH]: "Entendido",
    [Language.PORTUGUESE]: "Entendido",
  },
  "upgrade-plan": {
    [Language.ENGLISH]: "I want to upgrade my plan",
    [Language.SPANISH]: "Quiero mejorar mi plan",
    [Language.PORTUGUESE]: "Quero melhorar meu plano",
  },
  "your-subscription-has-been-canceled": {
    [Language.ENGLISH]: "Your subscription has been canceled",
    [Language.SPANISH]: "Tu suscripción ha sido cancelada",
    [Language.PORTUGUESE]: "Sua assinatura foi cancelada",
  },
  "your-access-will-end-on": {
    [Language.ENGLISH]: "Your access will end on",
    [Language.SPANISH]: "Tu acceso terminará el",
    [Language.PORTUGUESE]: "Seu acesso terminará em",
  },
  "after-this-date-you-will-lose-access-to-fluxi": {
    [Language.ENGLISH]: "After this date you will lose access to Fluxi",
    [Language.SPANISH]: "Después de esta fecha perderás el acceso a Fluxi",
    [Language.PORTUGUESE]: "Depois desta data, você perderá o acesso ao Fluxi",
  },
  "special-price": {
    [Language.ENGLISH]: "Special Price",
    [Language.SPANISH]: "Precio Especial",
    [Language.PORTUGUESE]: "Preço Especial",
  },
  "to-compensate-the-remaining-days-of-your-previous-plan-we-give-you-a-50-discount-in-the-first-month": {
    [Language.ENGLISH]: "To compensate the remaining days of your previous plan, we give you a 50% discount in the first month",
    [Language.SPANISH]: "Para compensar los días restantes de tu plan anterior, te damos el 50% de descuento en el primer mes",
    [Language.PORTUGUESE]: "Para compensar os dias restantes do seu plano anterior, damos um desconto de 50% no primeiro mês",
  },
  "to-compensate-the-remaining-days-of-your-previous-plan-we-give-you-a-100-discount-in-the-first-month": {
    [Language.ENGLISH]: "To compensate the remaining days of your previous plan, we give you a 100% discount in the first month",
    [Language.SPANISH]: "Para compensar los días restantes de tu plan anterior, te damos el 100% de descuento en el primer mes",
    [Language.PORTUGUESE]: "Para compensar os dias restantes do seu plano anterior, damos um desconto de 100% no primeiro mês",
  },
  "plan-lite-first-month": {
    [Language.ENGLISH]: "Plan Lite - $9.99 first month",
    [Language.SPANISH]: "Plan Lite - $9.99 primer mes",
    [Language.PORTUGUESE]: "Plano Lite - $9.99 primeiro mês",
  },
  "then-19-per-month": {
    [Language.ENGLISH]: "Then $19/month",
    [Language.SPANISH]: "Luego $19/mes",
    [Language.PORTUGUESE]: "Depois $19/mês",
  },
  "before-you-leave-we-offer-you-a-lite-plan-for-only": {
    [Language.ENGLISH]: "Before you leave, we offer you a Lite plan for only ",
    [Language.SPANISH]: "Antes de que te vayas, te ofrecemos un Plan Lite por tan solo ",
    [Language.PORTUGUESE]: "Antes de você ir, oferecemos um Plano Lite por apenas ",
  },
  "keep-all-your-created-pages-active": {
    [Language.ENGLISH]: "Keep all your created pages active",
    [Language.SPANISH]: "Mantén todas tus páginas creadas activas",
    [Language.PORTUGUESE]: "Mantenha todas as suas páginas criadas ativas",
  },
  "no-additional-credits-next-month": {
    [Language.ENGLISH]: "No additional credits next month",
    [Language.SPANISH]: "Sin créditos adicionales el próximo mes",
    [Language.PORTUGUESE]: "Sem créditos adicionais no próximo mês",
  },
  "access-to-the-platform": {
    [Language.ENGLISH]: "Access to the platform",
    [Language.SPANISH]: "Acceso a la plataforma",
    [Language.PORTUGUESE]: "Acesso à plataforma",
  },
  "you-can-buy-credits-or-upgrade-your-plan-when-you-want": {
    [Language.ENGLISH]: "You can buy credits or upgrade your plan when you want",
    [Language.SPANISH]: "Puedes comprar créditos o hacer upgrade a tu plan cuando quieras",
    [Language.PORTUGUESE]: "Você pode comprar créditos ou fazer upgrade do seu plano quando quiser",
  },
  "yes-i-want-the-lite-plan": {
    [Language.ENGLISH]: "Yes, I want the Lite plan",
    [Language.SPANISH]: "¡Sí! Quiero el Plan Lite",
    [Language.PORTUGUESE]: "Sim, quero o Plano Lite",
  },
  "no-thanks-i-want-to-cancel-my-access-to-fluxi": {
    [Language.ENGLISH]: "No thanks, I want to cancel my access to Fluxi",
    [Language.SPANISH]: "No gracias, quiero cancelar mi acceso a Fluxi",
    [Language.PORTUGUESE]: "Não, obrigado, quero cancelar meu acesso ao Fluxi",
  },
  "error-canceling-subscription": {
    [Language.ENGLISH]: "Error canceling subscription",
    [Language.SPANISH]: "Error al cancelar la suscripción",
    [Language.PORTUGUESE]: "Erro ao cancelar a assinatura",
  },
  "the-feedback-must-have-at-least": {
    [Language.ENGLISH]: "The feedback must have at least",
    [Language.SPANISH]: "El feedback debe tener al menos",
    [Language.PORTUGUESE]: "O feedback deve ter pelo menos",
  },
  "please-tell-us-the-real-reason-for-your-cancellation": {
    [Language.ENGLISH]: "Please tell us the real reason for your cancellation. Be honest, we help you improve.",
    [Language.SPANISH]: "Por favor cuéntanos la razón real por la que deseas cancelar. Sé honesto, nos ayudas a mejorar.",
    [Language.PORTUGUESE]: "Por favor, conte-nos a razão real pela qual deseja cancelar. Seja honesto, nos ajuda a melhorar.",
  },
  "write-here-your-answer": {
    [Language.ENGLISH]: "Write here your answer...",
    [Language.SPANISH]: "Escribe aquí tu respuesta...",
    [Language.PORTUGUESE]: "Escreva aqui sua resposta...",
  },
  "minimum-characters": {
    [Language.ENGLISH]: "minimum characters",
    [Language.SPANISH]: "caracteres mínimos",
    [Language.PORTUGUESE]: "caracteres mínimos",
  },
  "tell-me-what-problems-are-you-finding-with-fluxi": {
    [Language.ENGLISH]: "Tell me what problems are you finding with Fluxi that are not allowing you to fully enjoy your membership?",
    [Language.SPANISH]: "Cuéntame, ¿qué problemas estás encontrando con Fluxi que no te permiten aprovechar tu membresía completamente?",
    [Language.PORTUGUESE]: "Conte-me, quais problemas está encontrando com o Fluxi que não lhe permitem aproveitar sua assinatura completamente?",
  },
  "are-you-sure-you-want-to-leave": {
    [Language.ENGLISH]: "Are you sure you want to leave?",
    [Language.SPANISH]: "¿Seguro que quieres irte?",
    [Language.PORTUGUESE]: "Tem certeza que deseja sair?",
  },
  "before-you-lose-access-to-your-funnels-and-metrics-is-there-anything-we-can-resolve-together": {
    [Language.ENGLISH]: "Before you lose access to your funnels and metrics, is there anything we can resolve together?",
    [Language.SPANISH]: "Antes de que pierdas el acceso a tus embudos y métricas, ¿hay algo que podamos resolver juntos?",
    [Language.PORTUGUESE]: "Antes de perder o acesso a seus funnels e métricas, há algo que podemos resolver juntos?",
  },
  "i-prefer-to-talk-to-support": {
    [Language.ENGLISH]: "I prefer to talk to support",
    [Language.SPANISH]: "Prefiero hablar con soporte",
    [Language.PORTUGUESE]: "Prefiro falar com suporte",
  },
  "yes-i-want-to-cancel-my-subscription": {
    [Language.ENGLISH]: "Yes, I want to cancel my subscription",
    [Language.SPANISH]: "Sí, quiero cancelar mi suscripción",
    [Language.PORTUGUESE]: "Sim, quero cancelar minha assinatura",
  },
  "what-would-you-like-to-do-with-your-current-plan": {
    [Language.ENGLISH]: "What would you like to do with your current plan?",
    [Language.SPANISH]: "¿Qué te gustaría hacer con tu plan actual?",
    [Language.PORTUGUESE]: "O que você gostaria de fazer com seu plano atual?",
  },
  "improve-my-plan": {
    [Language.ENGLISH]: "Improve my plan",
    [Language.SPANISH]: "Mejorar mi plan",
    [Language.PORTUGUESE]: "Melhorar meu plano",
  },
  "cancel-my-plan": {
    [Language.ENGLISH]: "Cancel my plan",
    [Language.SPANISH]: "Cancelar mi plan",
    [Language.PORTUGUESE]: "Cancelar meu plano",
  },
  "wait-we-have-a-special-offer": {
    [Language.ENGLISH]: "Wait! We have a special offer",
    [Language.SPANISH]: "¡Espera! Tenemos una oferta especial",
    [Language.PORTUGUESE]: "Espera! Temos uma oferta especial",
  },
  "19-per-month": {
    [Language.ENGLISH]: "Plan Lite - $19/month",
    [Language.SPANISH]: "Plan Lite - $19/mes",
    [Language.PORTUGUESE]: "Plano Lite - $19/mês",
  },
  "downgrade-lite-success": {
    [Language.ENGLISH]: "Downgrade to Lite plan successful",
    [Language.SPANISH]: "Downgrade to Lite plan successful",
    [Language.PORTUGUESE]: "Downgrade to Lite plan successful",
  },
  "downgrade-lite-error": {
    [Language.ENGLISH]: "Error downgrading to Lite plan",
    [Language.SPANISH]: "Error downgrading to Lite plan",
    [Language.PORTUGUESE]: "Error downgrading to Lite plan",
  },
  "$19/mes": {
    [Language.ENGLISH]: "$19/month",
    [Language.SPANISH]: "$19/mes",
    [Language.PORTUGUESE]: "$19/mês",
  },
  "free-first-month": {
    [Language.ENGLISH]: "Plan Lite - Free! first month",
    [Language.SPANISH]: "Plan Lite - ¡Grátis! primer mes",
    [Language.PORTUGUESE]: "Plano Lite - ¡Grátis! primeiro mês",
  },
  "ab-testing-description": {
    [Language.ENGLISH]: "Manage and analyze your price experiments",
    [Language.SPANISH]: "Gestiona y analiza tus experimentos de precios",
    [Language.PORTUGUESE]: "Gerencie e analise seus experimentos de preços",
  },
  "create-ab-test": {
    [Language.ENGLISH]: "Create A/B Test",
    [Language.SPANISH]: "Crear A/B Test",
    [Language.PORTUGUESE]: "Criar Teste A/B",
  },
  "error-loading-experiments": {
    [Language.ENGLISH]: "Error loading experiments",
    [Language.SPANISH]: "Error al cargar los experimentos",
    [Language.PORTUGUESE]: "Erro ao carregar os experimentos",
  },
  "test-updated-successfully": {
    [Language.ENGLISH]: "Test updated successfully",
    [Language.SPANISH]: "Test actualizado correctamente",
    [Language.PORTUGUESE]: "Teste atualizado com sucesso",
  },
  "error-updating-test": {
    [Language.ENGLISH]: "Error updating test",
    [Language.SPANISH]: "Error al actualizar el test",
    [Language.PORTUGUESE]: "Erro ao atualizar o teste",
  },
  "test": {
    [Language.ENGLISH]: "Test",
    [Language.SPANISH]: "Test",
    [Language.PORTUGUESE]: "Teste",
  },
  "variants": {
    [Language.ENGLISH]: "Variants",
    [Language.SPANISH]: "Variantes",
    [Language.PORTUGUESE]: "Variantes",
  },
  "conversions": {
    [Language.ENGLISH]: "Conversions",
    [Language.SPANISH]: "Conversiones",
    [Language.PORTUGUESE]: "Conversões",
  },
  "conversion-rate": {
    [Language.ENGLISH]: "Conversion Rate",
    [Language.SPANISH]: "Tasa de conversión",
    [Language.PORTUGUESE]: "Taxa de conversão",
  },
  "pause": {
    [Language.ENGLISH]: "Pause",
    [Language.SPANISH]: "Pausar",
    [Language.PORTUGUESE]: "Pausar",
  },
  "activate": {
    [Language.ENGLISH]: "Activate",
    [Language.SPANISH]: "Activar",
    [Language.PORTUGUESE]: "Activar",
  },
  "id": {
    [Language.ENGLISH]: "ID",
    [Language.SPANISH]: "ID",
    [Language.PORTUGUESE]: "ID",
  },
  "base-price": {
    [Language.ENGLISH]: "Base price",
    [Language.SPANISH]: "Precio base",
    [Language.PORTUGUESE]: "Preço base",
  },
  "paused": {
    [Language.ENGLISH]: "Paused",
    [Language.SPANISH]: "Pausado",
    [Language.PORTUGUESE]: "Pausado",
  },
  "current-price": {
    [Language.ENGLISH]: "Current price",
    [Language.SPANISH]: "Precio actual",
    [Language.PORTUGUESE]: "Preço atual",
  },
  "change": {
    [Language.ENGLISH]: "Change",
    [Language.SPANISH]: "Cambiar",
    [Language.PORTUGUESE]: "Alterar",
  },
  "test-name": {
    [Language.ENGLISH]: "Test name",
    [Language.SPANISH]: "Nombre del test",
    [Language.PORTUGUESE]: "Nome do teste",
  },
  "test-name-placeholder": {
    [Language.ENGLISH]: "Enter a name for the test",
    [Language.SPANISH]: "Ingresa un nombre para el test",
    [Language.PORTUGUESE]: "Digite um nome para o teste",
  },
  "price-variants": {
    [Language.ENGLISH]: "Price variants",
    [Language.SPANISH]: "Variantes de precio",
    [Language.PORTUGUESE]: "Variantes de preço",
  },
  "add-variant": {
    [Language.ENGLISH]: "Add variant",
    [Language.SPANISH]: "Agregar variante",
    [Language.PORTUGUESE]: "Adicionar variante",
  },
  "variant": {
    [Language.ENGLISH]: "Variant",
    [Language.SPANISH]: "Variante",
    [Language.PORTUGUESE]: "Variante",
  },
  "select-product": {
    [Language.ENGLISH]: "Select product",
    [Language.SPANISH]: "Seleccionar producto",
    [Language.PORTUGUESE]: "Selecionar produto",
  },
  "select-product-description": {
    [Language.ENGLISH]: "Select the product for which you want to create a price A/B test",
    [Language.SPANISH]: "Selecciona el producto para el cual deseas crear un test A/B de precios",
    [Language.PORTUGUESE]: "Selecione o produto para o qual você deseja criar um teste A/B de preços",
  },
  "configure-prices": {
    [Language.ENGLISH]: "Configure prices",
    [Language.SPANISH]: "Configurar precios",
    [Language.PORTUGUESE]: "Configurar preços",
  },
  "step-1": {
    [Language.ENGLISH]: "Step 1",
    [Language.SPANISH]: "Paso 1",
    [Language.PORTUGUESE]: "Passo 1",
  },
  "step-2": {
    [Language.ENGLISH]: "Step 2",
    [Language.SPANISH]: "Paso 2",
    [Language.PORTUGUESE]: "Passo 2",
  },
  "test-created-successfully": {
    [Language.ENGLISH]: "Test created successfully",
    [Language.SPANISH]: "Test creado correctamente",
    [Language.PORTUGUESE]: "Teste criado com sucesso",
  },
  "error-creating-test": {
    [Language.ENGLISH]: "Error creating test",
    [Language.SPANISH]: "Error al crear el test",
    [Language.PORTUGUESE]: "Erro ao criar o teste",
  },
  "information": {
    [Language.ENGLISH]: "Information",
    [Language.SPANISH]: "Información",
    [Language.PORTUGUESE]: "Informação",
  },
  "visitors-will-be-automatically-divided-between-variants": {
    [Language.ENGLISH]: "Visitors will be automatically divided between variants",
    [Language.SPANISH]: "Los visitantes se dividirán automáticamente entre las variantes",
    [Language.PORTUGUESE]: "Os visitantes serão automaticamente divididos entre as variantes",
  },
  "each-variant-will-display-a-different-price": {
    [Language.ENGLISH]: "Each variant will display a different price",
    [Language.SPANISH]: "Cada variante mostrará un precio diferente",
    [Language.PORTUGUESE]: "Cada variante exibirá um preço diferente",
  },
  "conversions-and-metrics-will-be-recorded-for-each-price": {
    [Language.ENGLISH]: "Conversions and metrics will be recorded for each price",
    [Language.SPANISH]: "Se registrarán las conversiones y métricas de cada precio",
    [Language.PORTUGUESE]: "As conversões e métricas serão registradas para cada preço",
  },
  "you-can-pause-or-end-the-test-at-any-time": {
    [Language.ENGLISH]: "You can pause or end the test at any time",
    [Language.SPANISH]: "Puedes pausar o finalizar el test en cualquier momento",
    [Language.PORTUGUESE]: "Você pode pausar ou finalizar o teste em qualquer momento",
  },
  "winner": {
    [Language.ENGLISH]: "Winner",
    [Language.SPANISH]: "Ganador",
    [Language.PORTUGUESE]: "Vencedor",
  },
  "variant-comparison": {
    [Language.ENGLISH]: "Variant comparison",
    [Language.SPANISH]: "Comparación de variantes",
    [Language.PORTUGUESE]: "Comparação de variantes",
  },
  "traffic": {
    [Language.ENGLISH]: "Traffic",
    [Language.SPANISH]: "Tráfico",
    [Language.PORTUGUESE]: "Tráfego",
  },
  "error-loading-experiment": {
    [Language.ENGLISH]: "Error loading experiment",
    [Language.SPANISH]: "Error al cargar el experimento",
    [Language.PORTUGUESE]: "Erro ao carregar o experimento",
  },
  "experiment": {
    [Language.ENGLISH]: "Experiment",
    [Language.SPANISH]: "Experimento",
    [Language.PORTUGUESE]: "Experimento",
  },
  "funnel-id": {
    [Language.ENGLISH]: "Funnel ID",
    [Language.SPANISH]: "ID de embudo",
    [Language.PORTUGUESE]: "ID do funil",
  },
  "error-upserting-experiments": {
    [Language.ENGLISH]: "Error upserting experiments",
    [Language.SPANISH]: "Error al upsertar los experimentos",
    [Language.PORTUGUESE]: "Erro ao upsertar os experimentos",
  },
  "only-one-active-ab-test-per-funnel": {
    [Language.ENGLISH]: "Only one active A/B test per funnel",
    [Language.SPANISH]: "Solo se puede tener un A/B Testing activo por embudo",
    [Language.PORTUGUESE]: "Sólo pode haver um Teste A/B ativo por funil",
  },
  "yes-create-ab-test": {
    [Language.ENGLISH]: "Yes, create A/B Test",
    [Language.SPANISH]: "Sí, crear A/B Test",
    [Language.PORTUGUESE]: "Sim, criar Teste A/B",
  },
  "creating": {
    [Language.ENGLISH]: "Creating...",
    [Language.SPANISH]: "Creando...",
    [Language.PORTUGUESE]: "Criando...",
  },
  "active-ab-tests": {
    [Language.ENGLISH]: "Active A/B Tests",
    [Language.SPANISH]: "A/B Tests activos",
    [Language.PORTUGUESE]: "Testes A/B ativos",
  },
  "will-be-automatically-paused": {
    [Language.ENGLISH]: "will be automatically paused",
    [Language.SPANISH]: "serán pausados automáticamente",
    [Language.PORTUGUESE]: "serão pausados automaticamente",
  },
  "automatically-paused": {
    [Language.ENGLISH]: "automatically paused",
    [Language.SPANISH]: "pausados automáticamente",
    [Language.PORTUGUESE]: "pausados automaticamente",
  },
  "disabled": {
    [Language.ENGLISH]: "disabled",
    [Language.SPANISH]: "deshabilitados",
    [Language.PORTUGUESE]: "desabilitados",
  },
  "if-there-are-other": {
    [Language.ENGLISH]: "If there are other",
    [Language.SPANISH]: "Si existen otros",
    [Language.PORTUGUESE]: "Se houver outros",
  },
  "you-are-about-to-create-an": {
    [Language.ENGLISH]: "You are about to create an",
    [Language.SPANISH]: "Estás a punto de crear un",
    [Language.PORTUGUESE]: "Você está prestes a criar um",
  },
  "for-this-funnel": {
    [Language.ENGLISH]: "for this funnel",
    [Language.SPANISH]: "para este embudo",
    [Language.PORTUGUESE]: "para este funil",
  },
  "all-discounted-prices": {
    [Language.ENGLISH]: "All discounted prices",
    [Language.SPANISH]: "Todos los precios con descuento",
    [Language.PORTUGUESE]: "Todos os preços com desconto",
  },
  "discounted-prices": {
    [Language.ENGLISH]: "discounted prices",
    [Language.SPANISH]: "precios con descuento",
    [Language.PORTUGUESE]: "preços com desconto",
  },
  "will-be-disabled": {
    [Language.ENGLISH]: "will",
    [Language.SPANISH]: "serán",
    [Language.PORTUGUESE]: "serão",
  },
  "all-discounted-prices-will-be-disabled": {
    [Language.ENGLISH]: "All discounted prices by unit that you have in this funnel will be disabled",
    [Language.SPANISH]: "Todos los precios con descuento por unidades que tengas en este embudo serán deshabilitados",
    [Language.PORTUGUESE]: "Todos os preços com desconto por unidade que você tenha neste funil serão desabilitados",
  },
  "percentage-error": {
    [Language.ENGLISH]: "The percentages must sum 100%",
    [Language.SPANISH]: "Los porcentajes deben sumar 100%",
    [Language.PORTUGUESE]: "Os porcentagens devem somar 100%",
  },
  "no-ab-tests-found": {
    [Language.ENGLISH]: "No A/B tests found",
    [Language.SPANISH]: "No se encontraron tests A/B",
    [Language.PORTUGUESE]: "Nenhum teste A/B encontrado",
  },
  "choose-your-plan": {
    [Language.ENGLISH]: "Choose your plan",
    [Language.SPANISH]: "Elige tu plan",
    [Language.PORTUGUESE]: "Escolha seu plano",
  },
  "most-popular": {
    [Language.ENGLISH]: "Most popular",
    [Language.SPANISH]: "Más popular",
    [Language.PORTUGUESE]: "Mais popular",
  },
  "per-month": {
    [Language.ENGLISH]: "per month",
    [Language.SPANISH]: "por mes",
    [Language.PORTUGUESE]: "por mês",
  },
  "everything-included": {
    [Language.ENGLISH]: "Everything included",
    [Language.SPANISH]: "Todo incluido",
    [Language.PORTUGUESE]: "Tudo incluído",
  },
  "start-now": {
    [Language.ENGLISH]: "Start now",
    [Language.SPANISH]: "Comenzar ahora",
    [Language.PORTUGUESE]: "Começar agora",
  },
  "verification-success": {
    [Language.ENGLISH]: "Verification successful",
    [Language.SPANISH]: "Verificación exitosa",
    [Language.PORTUGUESE]: "Verificação bem-sucedida",
  },
  "enter-code": {
    [Language.ENGLISH]: "Enter code",
    [Language.SPANISH]: "Ingresa el código",
    [Language.PORTUGUESE]: "Insira o código",
  },
  "we-have-sent-a-6-digit-code-to": {
    [Language.ENGLISH]: "We have sent a 6 digit code to",
    [Language.SPANISH]: "Hemos enviado un código de 6 dígitos a",
    [Language.PORTUGUESE]: "Enviamos um código de 6 dígitos para",
  },
  "enter-verification-code": {
    [Language.ENGLISH]: "Enter verification code",
    [Language.SPANISH]: "Ingresa el código de verificación",
    [Language.PORTUGUESE]: "Insira o código de verificação",
  },
  "code-sent-successfully": {
    [Language.ENGLISH]: "Code sent successfully",
    [Language.SPANISH]: "Código enviado correctamente",
    [Language.PORTUGUESE]: "Código enviado com sucesso",
  },

  // ─── ADS CREATIVES ────────────────────────────────────────
  "error-generating": {
    [Language.ENGLISH]: "Error generating",
    [Language.SPANISH]: "Error al generar",
    [Language.PORTUGUESE]: "Erro ao gerar",
  },
  "try-again-later": {
    [Language.ENGLISH]: "Try again later",
    [Language.SPANISH]: "Intenta de nuevo más tarde",
    [Language.PORTUGUESE]: "Tente novamente mais tarde",
  },
  "done": {
    [Language.ENGLISH]: "Done",
    [Language.SPANISH]: "Listo",
    [Language.PORTUGUESE]: "Pronto",
  },
  "new": {
    [Language.ENGLISH]: "New",
    [Language.SPANISH]: "Nuevo",
    [Language.PORTUGUESE]: "Novo",
  },
  "generating-ad": {
    [Language.ENGLISH]: "Generating ad",
    [Language.SPANISH]: "Generando anuncio",
    [Language.PORTUGUESE]: "Gerando anúncio",
  },
  "this-may-take-a-moment": {
    [Language.ENGLISH]: "This may take a moment...",
    [Language.SPANISH]: "Esto puede tardar unos momentos...",
    [Language.PORTUGUESE]: "Isso pode levar alguns momentos...",
  },
  "video-generating-wait": {
    [Language.ENGLISH]: "This may take a few minutes, please wait...",
    [Language.SPANISH]: "Esto puede tardar unos minutos, por favor espera...",
    [Language.PORTUGUESE]: "Isso pode levar alguns minutos, por favor aguarde...",
  },
  "no-videos-yet": {
    [Language.ENGLISH]: "This product has no videos yet.",
    [Language.SPANISH]: "Este producto aún no tiene videos.",
    [Language.PORTUGUESE]: "Este produto ainda não tem vídeos.",
  },
  "generate-videos-here": {
    [Language.ENGLISH]: "When you generate videos, they will appear here.",
    [Language.SPANISH]: "Cuando generes videos, aparecerán aquí.",
    [Language.PORTUGUESE]: "Quando você gerar vídeos, eles aparecerão aqui.",
  },
  "create-video-with-ai": {
    [Language.ENGLISH]: "Create Video with AI",
    [Language.SPANISH]: "Crear Video con IA",
    [Language.PORTUGUESE]: "Criar Vídeo com IA",
  },
  "tab-images": {
    [Language.ENGLISH]: "Images",
    [Language.SPANISH]: "Imágenes",
    [Language.PORTUGUESE]: "Imagens",
  },
  "tab-scripts": {
    [Language.ENGLISH]: "Scripts",
    [Language.SPANISH]: "Guiones",
    [Language.PORTUGUESE]: "Roteiros",
  },
  "tab-videos": {
    [Language.ENGLISH]: "Videos",
    [Language.SPANISH]: "Videos",
    [Language.PORTUGUESE]: "Vídeos",
  },
  "view-creative": {
    [Language.ENGLISH]: "View creative",
    [Language.SPANISH]: "Ver creativo",
    [Language.PORTUGUESE]: "Ver criativo",
  },
  "download-creative": {
    [Language.ENGLISH]: "Download creative",
    [Language.SPANISH]: "Descargar creativo",
    [Language.PORTUGUESE]: "Baixar criativo",
  },

  // ─── EDIT PANEL ────────────────────────────────────────────
  "what-do-you-want-to-change": {
    [Language.ENGLISH]: "What do you want to change?",
    [Language.SPANISH]: "¿Qué quieres cambiar?",
    [Language.PORTUGUESE]: "O que você quer mudar?",
  },
  "describe-what-to-change": {
    [Language.ENGLISH]: "Describe what you want to change...",
    [Language.SPANISH]: "Describe qué quieres cambiar...",
    [Language.PORTUGUESE]: "Descreva o que você quer mudar...",
  },
  "change-text": {
    [Language.ENGLISH]: "Change text",
    [Language.SPANISH]: "Cambiar texto",
    [Language.PORTUGUESE]: "Mudar texto",
  },
  "change-text-to": {
    [Language.ENGLISH]: "Change the text to ",
    [Language.SPANISH]: "Cambiar el texto por ",
    [Language.PORTUGUESE]: "Mudar o texto para ",
  },
  "change-price": {
    [Language.ENGLISH]: "Change price",
    [Language.SPANISH]: "Cambiar precio",
    [Language.PORTUGUESE]: "Mudar preço",
  },
  "change-price-to": {
    [Language.ENGLISH]: "Change the price to $",
    [Language.SPANISH]: "Cambiar el precio por $",
    [Language.PORTUGUESE]: "Mudar o preço para $",
  },
  "add-price": {
    [Language.ENGLISH]: "Add price",
    [Language.SPANISH]: "Agregar precio",
    [Language.PORTUGUESE]: "Adicionar preço",
  },
  "add-price-to": {
    [Language.ENGLISH]: "Add the price $",
    [Language.SPANISH]: "Agregar el precio $",
    [Language.PORTUGUESE]: "Adicionar o preço $",
  },
  "add-free-shipping-text": {
    [Language.ENGLISH]: "Add a text that says FREE SHIPPING",
    [Language.SPANISH]: "Agregar un texto que diga ENVÍO GRATIS",
    [Language.PORTUGUESE]: "Adicionar um texto que diga FRETE GRÁTIS",
  },
  "darker-background": {
    [Language.ENGLISH]: "Darker background",
    [Language.SPANISH]: "Fondo más oscuro",
    [Language.PORTUGUESE]: "Fundo mais escuro",
  },
  "make-background-darker": {
    [Language.ENGLISH]: "Make the background darker",
    [Language.SPANISH]: "Hacer el fondo más oscuro",
    [Language.PORTUGUESE]: "Deixar o fundo mais escuro",
  },
  "editing": {
    [Language.ENGLISH]: "Editing...",
    [Language.SPANISH]: "Editando...",
    [Language.PORTUGUESE]: "Editando...",
  },
  "editing-image-progress": {
    [Language.ENGLISH]: "Editing image...",
    [Language.SPANISH]: "Editando imagen...",
    [Language.PORTUGUESE]: "Editando imagem...",
  },

  // ─── AD STUDIO SIDEBAR ────────────────────────────────────
  "instruction-placeholder-1": {
    [Language.ENGLISH]: "E.g.: Add price $29.99, include 2x1 offer...",
    [Language.SPANISH]: "Ej: Agregar precio $29.990, incluir oferta 2x1...",
    [Language.PORTUGUESE]: "Ex: Adicionar preço R$29,99, incluir oferta 2x1...",
  },
  "instruction-placeholder-2": {
    [Language.ENGLISH]: "E.g.: Change the price to $19.99...",
    [Language.SPANISH]: "Ej: Cambiar el precio por $19.990...",
    [Language.PORTUGUESE]: "Ex: Mudar o preço para R$19,99...",
  },
  "instruction-placeholder-3": {
    [Language.ENGLISH]: "E.g.: Add FREE SHIPPING text...",
    [Language.SPANISH]: "Ej: Agregar texto ENVÍO GRATIS...",
    [Language.PORTUGUESE]: "Ex: Adicionar texto FRETE GRÁTIS...",
  },
  "instruction-placeholder-4": {
    [Language.ENGLISH]: "E.g.: Replace offer with 50% discount...",
    [Language.SPANISH]: "Ej: Reemplazar oferta por 50% de descuento...",
    [Language.PORTUGUESE]: "Ex: Substituir oferta por 50% de desconto...",
  },
  "your-images": {
    [Language.ENGLISH]: "Your Images",
    [Language.SPANISH]: "Tus Imágenes",
    [Language.PORTUGUESE]: "Suas Imagens",
  },
  "configure-each-image-before-generating": {
    [Language.ENGLISH]: "Configure each image before generating",
    [Language.SPANISH]: "Configura cada imagen antes de generar",
    [Language.PORTUGUESE]: "Configure cada imagem antes de gerar",
  },
  "auto": {
    [Language.ENGLISH]: "Auto",
    [Language.SPANISH]: "Auto",
    [Language.PORTUGUESE]: "Auto",
  },
  "primary": {
    [Language.ENGLISH]: "Primary",
    [Language.SPANISH]: "Primario",
    [Language.PORTUGUESE]: "Primário",
  },
  "background": {
    [Language.ENGLISH]: "Background",
    [Language.SPANISH]: "Fondo",
    [Language.PORTUGUESE]: "Fundo",
  },
  "generate-images": {
    [Language.ENGLISH]: "Generate Images",
    [Language.SPANISH]: "Generar Imágenes",
    [Language.PORTUGUESE]: "Gerar Imagens",
  },
  "select-n-styles": {
    [Language.ENGLISH]: "Select {n} styles",
    [Language.SPANISH]: "Selecciona {n} estilos",
    [Language.PORTUGUESE]: "Selecione {n} estilos",
  },

  // ─── AD STUDIO GALLERY ────────────────────────────────────
  "templates-selected-ready": {
    [Language.ENGLISH]: "Templates selected! You can now generate your ads",
    [Language.SPANISH]: "¡Plantillas seleccionadas! Ya puedes generar tus anuncios",
    [Language.PORTUGUESE]: "Templates selecionados! Agora você pode gerar seus anúncios",
  },
  "select-n-templates-to-continue": {
    [Language.ENGLISH]: "Select {n} templates to continue",
    [Language.SPANISH]: "Selecciona {n} plantillas para continuar",
    [Language.PORTUGUESE]: "Selecione {n} templates para continuar",
  },
  "select-n-more-templates": {
    [Language.ENGLISH]: "Select {n} more template(s) to continue",
    [Language.SPANISH]: "Selecciona {n} plantilla(s) más para continuar",
    [Language.PORTUGUESE]: "Selecione mais {n} template(s) para continuar",
  },
  "max-templates-reached": {
    [Language.ENGLISH]: "You reached the maximum of {n} templates per generation",
    [Language.SPANISH]: "Llegaste al máximo de {n} plantillas por generación",
    [Language.PORTUGUESE]: "Você atingiu o máximo de {n} templates por geração",
  },
  "n-templates-selected": {
    [Language.ENGLISH]: "{n} template(s) selected",
    [Language.SPANISH]: "{n} plantilla(s) seleccionada(s)",
    [Language.PORTUGUESE]: "{n} template(s) selecionado(s)",
  },
  "templates-selected": {
    [Language.ENGLISH]: "Templates selected!",
    [Language.SPANISH]: "¡Plantillas seleccionadas!",
    [Language.PORTUGUESE]: "Templates selecionados!",
  },
  "remove": {
    [Language.ENGLISH]: "Remove",
    [Language.SPANISH]: "Quitar",
    [Language.PORTUGUESE]: "Remover",
  },
  "caption": {
    [Language.ENGLISH]: "Caption",
    [Language.SPANISH]: "Descripción",
    [Language.PORTUGUESE]: "Legenda",
  },
  "step2-no-product-error": {
    [Language.ENGLISH]: "Error: step=2 but no product selected",
    [Language.SPANISH]: "Error: step=2 pero no hay producto seleccionado",
    [Language.PORTUGUESE]: "Erro: step=2 mas nenhum produto selecionado",
  },
  "custom-reference-style-description": {
    [Language.ENGLISH]: "Upload any ad you like and the AI replicates it with your product maintaining the same visual style",
    [Language.SPANISH]: "Sube cualquier anuncio que te guste y la IA lo replica con tu producto manteniendo el mismo estilo visual",
    [Language.PORTUGUESE]: "Envie qualquer anúncio que você goste e a IA o replica com seu produto mantendo o mesmo estilo visual",
  },
  "close": {
    [Language.ENGLISH]: "Close",
    [Language.SPANISH]: "Cerrar",
    [Language.PORTUGUESE]: "Fechar",
  },

  // ─── CUSTOM REFERENCE CARD ─────────────────────────────────
  "only-jpg-png-webp-allowed": {
    [Language.ENGLISH]: "Only JPG, PNG or WEBP files are allowed",
    [Language.SPANISH]: "Solo se permiten archivos JPG, PNG o WEBP",
    [Language.PORTUGUESE]: "Apenas arquivos JPG, PNG ou WEBP são permitidos",
  },
  "file-max-5mb": {
    [Language.ENGLISH]: "File cannot exceed 5MB",
    [Language.SPANISH]: "El archivo no puede superar 5MB",
    [Language.PORTUGUESE]: "O arquivo não pode exceder 5MB",
  },
  "your-style-your-product": {
    [Language.ENGLISH]: "Your style, your product",
    [Language.SPANISH]: "Tu estilo, tu producto",
    [Language.PORTUGUESE]: "Seu estilo, seu produto",
  },
  "ref": {
    [Language.ENGLISH]: "Ref.",
    [Language.SPANISH]: "Ref.",
    [Language.PORTUGUESE]: "Ref.",
  },
  "your-ad": {
    [Language.ENGLISH]: "Your ad",
    [Language.SPANISH]: "Tu ad",
    [Language.PORTUGUESE]: "Seu ad",
  },
  "upload-an-ad-you-like": {
    [Language.ENGLISH]: "Upload an ad you like",
    [Language.SPANISH]: "Sube un anuncio que te guste",
    [Language.PORTUGUESE]: "Envie um anúncio que você goste",
  },
  "ai-replicates-style-with-product": {
    [Language.ENGLISH]: "AI replicates its style with your product",
    [Language.SPANISH]: "La IA replica su estilo con tu producto",
    [Language.PORTUGUESE]: "A IA replica o estilo com seu produto",
  },
  "view-preview": {
    [Language.ENGLISH]: "View preview",
    [Language.SPANISH]: "Ver preview",
    [Language.PORTUGUESE]: "Ver preview",
  },
  "personalized": {
    [Language.ENGLISH]: "Custom",
    [Language.SPANISH]: "Personalizada",
    [Language.PORTUGUESE]: "Personalizada",
  },

  // ─── STORE / GENERATION ────────────────────────────────────
  "timeout-error": {
    [Language.ENGLISH]: "Timeout reached",
    [Language.SPANISH]: "Tiempo de espera agotado",
    [Language.PORTUGUESE]: "Tempo de espera esgotado",
  },
  "error-starting-generation": {
    [Language.ENGLISH]: "Error starting generation. Try again.",
    [Language.SPANISH]: "Error al iniciar la generación. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Erro ao iniciar a geração. Tente novamente.",
  },
  "image-uploaded-successfully": {
    [Language.ENGLISH]: "Image uploaded successfully",
    [Language.SPANISH]: "Imagen subida correctamente",
    [Language.PORTUGUESE]: "Imagem enviada com sucesso",
  },
  "error-uploading-image": {
    [Language.ENGLISH]: "Error uploading image. Try again.",
    [Language.SPANISH]: "Error al subir la imagen. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Erro ao enviar a imagem. Tente novamente.",
  },
  "could-not-load-reference-image": {
    [Language.ENGLISH]: "Could not load reference image. Upload it manually.",
    [Language.SPANISH]: "No se pudo cargar la imagen de referencia. Súbela manualmente.",
    [Language.PORTUGUESE]: "Não foi possível carregar a imagem de referência. Envie manualmente.",
  },
  "image-edited-and-saved": {
    [Language.ENGLISH]: "Image edited and saved",
    [Language.SPANISH]: "Imagen editada y guardada",
    [Language.PORTUGUESE]: "Imagem editada e salva",
  },
  "image-edited-not-saved": {
    [Language.ENGLISH]: "Image edited (could not save permanently)",
    [Language.SPANISH]: "Imagen editada (no se pudo guardar permanentemente)",
    [Language.PORTUGUESE]: "Imagem editada (não foi possível salvar permanentemente)",
  },
  "error-editing-try-again": {
    [Language.ENGLISH]: "Error editing. Try again.",
    [Language.SPANISH]: "Error al editar. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Erro ao editar. Tente novamente.",
  },
  "no-results-for": {
    [Language.ENGLISH]: "No results for",
    [Language.SPANISH]: "Sin resultados para",
    [Language.PORTUGUESE]: "Sem resultados para",
  },
  "error-creating-product": {
    [Language.ENGLISH]: "Error creating product. Try again.",
    [Language.SPANISH]: "Error al crear el producto. Intenta de nuevo.",
    [Language.PORTUGUESE]: "Erro ao criar o produto. Tente novamente.",
  },
  "no-image-url-received": {
    [Language.ENGLISH]: "No image URL received",
    [Language.SPANISH]: "No se recibió URL de la imagen",
    [Language.PORTUGUESE]: "URL da imagem não recebida",
  },
  "no-product-id-received": {
    [Language.ENGLISH]: "No product ID received",
    [Language.SPANISH]: "No se recibió el ID del producto",
    [Language.PORTUGUESE]: "ID do produto não recebido",
  },
  "all-fields-required": {
    [Language.ENGLISH]: "All fields are required",
    [Language.SPANISH]: "Todos los campos son requeridos",
    [Language.PORTUGUESE]: "Todos os campos são obrigatórios",
  },
  "create-new-product": {
    [Language.ENGLISH]: "Create new product",
    [Language.SPANISH]: "Crear producto nuevo",
    [Language.PORTUGUESE]: "Criar novo produto",
  },
  "add-your-product-to-create-ads": {
    [Language.ENGLISH]: "Add your product to create ads",
    [Language.SPANISH]: "Agrega tu producto para crear anuncios",
    [Language.PORTUGUESE]: "Adicione seu produto para criar anúncios",
  },
  "describe-your-product": {
    [Language.ENGLISH]: "Describe your product, key benefits, target audience...",
    [Language.SPANISH]: "Describe tu producto, beneficios clave, público objetivo...",
    [Language.PORTUGUESE]: "Descreva seu produto, benefícios-chave, público-alvo...",
  },
  "uploading": {
    [Language.ENGLISH]: "Uploading...",
    [Language.SPANISH]: "Subiendo...",
    [Language.PORTUGUESE]: "Enviando...",
  },
  "create-and-continue": {
    [Language.ENGLISH]: "Create and continue",
    [Language.SPANISH]: "Crear y continuar",
    [Language.PORTUGUESE]: "Criar e continuar",
  },
  "no-results": {
    [Language.ENGLISH]: "No results for",
    [Language.SPANISH]: "Sin resultados para",
    [Language.PORTUGUESE]: "Sem resultados para",
  },
  "copied": {
    [Language.ENGLISH]: "Copied",
    [Language.SPANISH]: "Copiado",
    [Language.PORTUGUESE]: "Copiado",
  },
  "copy": {
    [Language.ENGLISH]: "Copy",
    [Language.SPANISH]: "Copiar",
    [Language.PORTUGUESE]: "Copiar",
  },
  "of": {
    [Language.ENGLISH]: "of",
    [Language.SPANISH]: "de",
    [Language.PORTUGUESE]: "de",
  },
  "could-not-save": {
    [Language.ENGLISH]: "Could not save",
    [Language.SPANISH]: "No se pudo guardar",
    [Language.PORTUGUESE]: "Não foi possível salvar",
  },
  "unknown-error": {
    [Language.ENGLISH]: "Unknown error",
    [Language.SPANISH]: "Error desconocido",
    [Language.PORTUGUESE]: "Erro desconhecido",
  },

  // ─── ADS SPY ─────────────────────────────────────────────
  "ads-spy": {
    [Language.ENGLISH]: "Ads Spy",
    [Language.SPANISH]: "Espía de Anuncios",
    [Language.PORTUGUESE]: "Espião de Anúncios",
  },
  "spy-brands": {
    [Language.ENGLISH]: "Brands",
    [Language.SPANISH]: "Marcas",
    [Language.PORTUGUESE]: "Marcas",
  },
  "spy-ads": {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  "spy-bookmarks": {
    [Language.ENGLISH]: "Bookmarks",
    [Language.SPANISH]: "Favoritos",
    [Language.PORTUGUESE]: "Favoritos",
  },
  "add-brand": {
    [Language.ENGLISH]: "Add Brand",
    [Language.SPANISH]: "Añadir Marca",
    [Language.PORTUGUESE]: "Adicionar Marca",
  },
  "analyzing": {
    [Language.ENGLISH]: "Analyzing...",
    [Language.SPANISH]: "Analizando...",
    [Language.PORTUGUESE]: "Analisando...",
  },
  "analyze-all": {
    [Language.ENGLISH]: "Analyze All",
    [Language.SPANISH]: "Analizar Todos",
    [Language.PORTUGUESE]: "Analisar Todos",
  },
  "analyze-ads-with-ai-tooltip": {
    [Language.ENGLISH]: "Analyze ads with AI to enable smart filters",
    [Language.SPANISH]: "Analiza anuncios con IA para habilitar filtros inteligentes",
    [Language.PORTUGUESE]: "Analise anúncios com IA para habilitar filtros inteligentes",
  },
  "search-new-ads": {
    [Language.ENGLISH]: "Search New Ads",
    [Language.SPANISH]: "Buscar Nuevos Anuncios",
    [Language.PORTUGUESE]: "Buscar Novos Anúncios",
  },
  "analyzing-n-ads": {
    [Language.ENGLISH]: "Analyzing {n} ads...",
    [Language.SPANISH]: "Analizando {n} anuncios...",
    [Language.PORTUGUESE]: "Analisando {n} anúncios...",
  },
  "completed": {
    [Language.ENGLISH]: "Completed",
    [Language.SPANISH]: "Completado",
    [Language.PORTUGUESE]: "Concluído",
  },
  "analyze-ads-with-ai": {
    [Language.ENGLISH]: "Analyze ads with AI",
    [Language.SPANISH]: "Analizar anuncios con IA",
    [Language.PORTUGUESE]: "Analisar anúncios com IA",
  },
  "will-analyze-n-ads": {
    [Language.ENGLISH]: "{n} ads will be analyzed that have not been processed yet.",
    [Language.SPANISH]: "Se analizarán {n} anuncios que aún no han sido procesados.",
    [Language.PORTUGUESE]: "{n} anúncios serão analisados que ainda não foram processados.",
  },
  "ai-will-classify-ads": {
    [Language.ENGLISH]: "AI will classify each ad by asset type, visual format, messaging, hook, and offer. This will enable smart filters.",
    [Language.SPANISH]: "La IA clasificará cada anuncio por tipo de recurso, formato visual, mensajería, gancho y oferta. Esto habilitará los filtros inteligentes.",
    [Language.PORTUGUESE]: "A IA classificará cada anúncio por tipo de recurso, formato visual, mensagem, gancho e oferta. Isso habilitará os filtros inteligentes.",
  },
  "no-pending-ads": {
    [Language.ENGLISH]: "No pending ads",
    [Language.SPANISH]: "No hay anuncios pendientes",
    [Language.PORTUGUESE]: "Não há anúncios pendentes",
  },
  "analyze-n-ads": {
    [Language.ENGLISH]: "Analyze {n} ads",
    [Language.SPANISH]: "Analizar {n} anuncios",
    [Language.PORTUGUESE]: "Analisar {n} anúncios",
  },
  "add-a-brand-to-start": {
    [Language.ENGLISH]: "Add a brand to get started",
    [Language.SPANISH]: "Agrega una marca para empezar",
    [Language.PORTUGUESE]: "Adicione uma marca para começar",
  },
  "to-spy-ads-add-brand": {
    [Language.ENGLISH]: "To spy on ads, you first need to add at least one competitor brand.",
    [Language.SPANISH]: "Para espiar anuncios, primero necesitas agregar al menos una marca de la competencia.",
    [Language.PORTUGUESE]: "Para espiar anúncios, primeiro você precisa adicionar pelo menos uma marca concorrente.",
  },
  "add-brand-lowercase": {
    [Language.ENGLISH]: "Add brand",
    [Language.SPANISH]: "Añadir marca",
    [Language.PORTUGUESE]: "Adicionar marca",
  },
  "no-ads-yet": {
    [Language.ENGLISH]: "No ads yet",
    [Language.SPANISH]: "No hay anuncios todavía",
    [Language.PORTUGUESE]: "Nenhum anúncio ainda",
  },
  "scrape-brands-to-see-ads": {
    [Language.ENGLISH]: "Scrape your brands to see their ads",
    [Language.SPANISH]: "Haz scraping de tus marcas para ver sus anuncios",
    [Language.PORTUGUESE]: "Faça scraping das suas marcas para ver seus anúncios",
  },
  "no-more-ads": {
    [Language.ENGLISH]: "No more ads",
    [Language.SPANISH]: "No hay más anuncios",
    [Language.PORTUGUESE]: "Não há mais anúncios",
  },
  "searching-ads-for": {
    [Language.ENGLISH]: "Searching ads for {name}...",
    [Language.SPANISH]: "Buscando anuncios de {name}...",
    [Language.PORTUGUESE]: "Buscando anúncios de {name}...",
  },
  "brand-scrape-result": {
    [Language.ENGLISH]: "{name}: {inserted} new, {duplicates} duplicates",
    [Language.SPANISH]: "{name}: {inserted} nuevos, {duplicates} duplicados",
    [Language.PORTUGUESE]: "{name}: {inserted} novos, {duplicates} duplicados",
  },
  "error-searching-ads-for": {
    [Language.ENGLISH]: "Error searching ads for {name}",
    [Language.SPANISH]: "Error buscando anuncios de {name}",
    [Language.PORTUGUESE]: "Erro ao buscar anúncios de {name}",
  },
  "confirm-delete-brand": {
    [Language.ENGLISH]: "Delete \"{name}\" and all its unsaved ads?",
    [Language.SPANISH]: "Eliminar \"{name}\" y todos sus anuncios no guardados?",
    [Language.PORTUGUESE]: "Excluir \"{name}\" e todos os anúncios não salvos?",
  },
  "brand-deleted": {
    [Language.ENGLISH]: "Brand deleted",
    [Language.SPANISH]: "Marca eliminada",
    [Language.PORTUGUESE]: "Marca excluída",
  },
  "error-deleting-brand": {
    [Language.ENGLISH]: "Error deleting brand",
    [Language.SPANISH]: "Error eliminando marca",
    [Language.PORTUGUESE]: "Erro ao excluir marca",
  },
  "no-brands-yet": {
    [Language.ENGLISH]: "You don't have brands yet",
    [Language.SPANISH]: "Aún no tienes marcas",
    [Language.PORTUGUESE]: "Você ainda não tem marcas",
  },
  "add-first-competitor": {
    [Language.ENGLISH]: "Add your first competitor to start spying on their ads",
    [Language.SPANISH]: "Añade tu primer competidor para empezar a espiar sus anuncios",
    [Language.PORTUGUESE]: "Adicione seu primeiro concorrente para começar a espiar seus anúncios",
  },
  "brand-table-brand": {
    [Language.ENGLISH]: "Brand",
    [Language.SPANISH]: "Marca",
    [Language.PORTUGUESE]: "Marca",
  },
  "brand-table-ads": {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  "brand-table-bookmarks": {
    [Language.ENGLISH]: "Bookmarks",
    [Language.SPANISH]: "Favoritos",
    [Language.PORTUGUESE]: "Favoritos",
  },
  "brand-table-activity": {
    [Language.ENGLISH]: "Activity",
    [Language.SPANISH]: "Actividad",
    [Language.PORTUGUESE]: "Atividade",
  },
  "brand-table-actions": {
    [Language.ENGLISH]: "Actions",
    [Language.SPANISH]: "Acciones",
    [Language.PORTUGUESE]: "Ações",
  },
  "no-activity": {
    [Language.ENGLISH]: "No activity",
    [Language.SPANISH]: "Sin actividad",
    [Language.PORTUGUESE]: "Sem atividade",
  },
  "search-ads": {
    [Language.ENGLISH]: "Search ads",
    [Language.SPANISH]: "Buscar anuncios",
    [Language.PORTUGUESE]: "Buscar anúncios",
  },
  "view-ads": {
    [Language.ENGLISH]: "View ads",
    [Language.SPANISH]: "Ver anuncios",
    [Language.PORTUGUESE]: "Ver anúncios",
  },
  "search-new": {
    [Language.ENGLISH]: "Search new",
    [Language.SPANISH]: "Buscar nuevos",
    [Language.PORTUGUESE]: "Buscar novos",
  },
  "brand-updated": {
    [Language.ENGLISH]: "Brand updated",
    [Language.SPANISH]: "Marca actualizada",
    [Language.PORTUGUESE]: "Marca atualizada",
  },
  "brand-added": {
    [Language.ENGLISH]: "Brand added",
    [Language.SPANISH]: "Marca añadida",
    [Language.PORTUGUESE]: "Marca adicionada",
  },
  "error-saving-brand": {
    [Language.ENGLISH]: "Error saving brand",
    [Language.SPANISH]: "Error guardando marca",
    [Language.PORTUGUESE]: "Erro ao salvar marca",
  },
  "edit-brand": {
    [Language.ENGLISH]: "Edit Brand",
    [Language.SPANISH]: "Editar Marca",
    [Language.PORTUGUESE]: "Editar Marca",
  },
  "brand-name-label": {
    [Language.ENGLISH]: "Brand name",
    [Language.SPANISH]: "Nombre de la marca",
    [Language.PORTUGUESE]: "Nome da marca",
  },
  "brand-name-placeholder": {
    [Language.ENGLISH]: "E.g.: Nike, AG1, Dr. Squatch...",
    [Language.SPANISH]: "Ej: Nike, AG1, Dr. Squatch...",
    [Language.PORTUGUESE]: "Ex: Nike, AG1, Dr. Squatch...",
  },
  "meta-ad-library-url": {
    [Language.ENGLISH]: "Meta Ad Library URL",
    [Language.SPANISH]: "URL de Meta Ad Library",
    [Language.PORTUGUESE]: "URL do Meta Ad Library",
  },
  "paste-ad-library-url": {
    [Language.ENGLISH]: "Paste the Ad Library URL here...",
    [Language.SPANISH]: "Pega aquí la URL de la Ad Library...",
    [Language.PORTUGUESE]: "Cole aqui a URL do Ad Library...",
  },
  "go-to-ad-library-hint": {
    [Language.ENGLISH]: "Go to facebook.com/ads/library, search the brand and copy that URL",
    [Language.SPANISH]: "Ve a facebook.com/ads/library, busca la marca y copia esa URL",
    [Language.PORTUGUESE]: "Acesse facebook.com/ads/library, busque a marca e copie a URL",
  },
  "category": {
    [Language.ENGLISH]: "Category",
    [Language.SPANISH]: "Categoría",
    [Language.PORTUGUESE]: "Categoria",
  },
  "no-active-brands": {
    [Language.ENGLISH]: "No active brands",
    [Language.SPANISH]: "No hay marcas activas",
    [Language.PORTUGUESE]: "Não há marcas ativas",
  },
  "bulk-search": {
    [Language.ENGLISH]: "Bulk Search",
    [Language.SPANISH]: "Búsqueda Masiva",
    [Language.PORTUGUESE]: "Busca em Massa",
  },
  "will-search-new-ads-in-n-brands": {
    [Language.ENGLISH]: "New ads will be searched in {n} active brand(s).",
    [Language.SPANISH]: "Se buscarán anuncios nuevos en {n} marca(s) activa(s).",
    [Language.PORTUGUESE]: "Novos anúncios serão buscados em {n} marca(s) ativa(s).",
  },
  "system-will-check-ad-library": {
    [Language.ENGLISH]: "The system will check each brand's ad library and add those not yet in your collection.",
    [Language.SPANISH]: "El sistema revisará la biblioteca de anuncios de cada marca y agregará los que aún no estén en tu colección.",
    [Language.PORTUGUESE]: "O sistema revisará a biblioteca de anúncios de cada marca e adicionará os que ainda não estão na sua coleção.",
  },
  "search-in-n-brands": {
    [Language.ENGLISH]: "Search in {n} brand(s)",
    [Language.SPANISH]: "Buscar en {n} marca(s)",
    [Language.PORTUGUESE]: "Buscar em {n} marca(s)",
  },
  "search-completed": {
    [Language.ENGLISH]: "Search completed",
    [Language.SPANISH]: "Búsqueda completada",
    [Language.PORTUGUESE]: "Busca concluída",
  },
  "searching-ads": {
    [Language.ENGLISH]: "Searching ads...",
    [Language.SPANISH]: "Buscando anuncios...",
    [Language.PORTUGUESE]: "Buscando anúncios...",
  },
  "n-of-n-brands": {
    [Language.ENGLISH]: "{current} of {total} brands",
    [Language.SPANISH]: "{current} de {total} marcas",
    [Language.PORTUGUESE]: "{current} de {total} marcas",
  },
  "searching-in": {
    [Language.ENGLISH]: "Searching in:",
    [Language.SPANISH]: "Buscando en:",
    [Language.PORTUGUESE]: "Buscando em:",
  },
  "n-new-ads-from-n-brands": {
    [Language.ENGLISH]: "{ads} new ads from {brands} brands",
    [Language.SPANISH]: "{ads} anuncios nuevos de {brands} marcas",
    [Language.PORTUGUESE]: "{ads} novos anúncios de {brands} marcas",
  },
  "n-new": {
    [Language.ENGLISH]: "+{n} new",
    [Language.SPANISH]: "+{n} nuevos",
    [Language.PORTUGUESE]: "+{n} novos",
  },
  "error": {
    [Language.ENGLISH]: "Error",
    [Language.SPANISH]: "Error",
    [Language.PORTUGUESE]: "Erro",
  },
  "search-n-new-ads-n-errors": {
    [Language.ENGLISH]: "Search: {new} new ads, {errors} with error",
    [Language.SPANISH]: "Búsqueda: {new} anuncios nuevos, {errors} con error",
    [Language.PORTUGUESE]: "Busca: {new} novos anúncios, {errors} com erro",
  },
  "search-completed-n-new": {
    [Language.ENGLISH]: "Search completed: {n} new ads",
    [Language.SPANISH]: "Búsqueda completada: {n} anuncios nuevos",
    [Language.PORTUGUESE]: "Busca concluída: {n} novos anúncios",
  },
  "all-brands": {
    [Language.ENGLISH]: "All brands ({n})",
    [Language.SPANISH]: "Todas las marcas ({n})",
    [Language.PORTUGUESE]: "Todas as marcas ({n})",
  },
  "all-types": {
    [Language.ENGLISH]: "All types",
    [Language.SPANISH]: "Todo tipo",
    [Language.PORTUGUESE]: "Todos os tipos",
  },
  "image": {
    [Language.ENGLISH]: "Image",
    [Language.SPANISH]: "Imagen",
    [Language.PORTUGUESE]: "Imagem",
  },
  "all-statuses": {
    [Language.ENGLISH]: "All statuses",
    [Language.SPANISH]: "Todos los estados",
    [Language.PORTUGUESE]: "Todos os status",
  },
  "active-status": {
    [Language.ENGLISH]: "Active",
    [Language.SPANISH]: "Activos",
    [Language.PORTUGUESE]: "Ativos",
  },
  "expired-status": {
    [Language.ENGLISH]: "Expired",
    [Language.SPANISH]: "Expirados",
    [Language.PORTUGUESE]: "Expirados",
  },
  "best-ranked": {
    [Language.ENGLISH]: "Best ranked",
    [Language.SPANISH]: "Mejor clasificados",
    [Language.PORTUGUESE]: "Melhor classificados",
  },
  "most-recent": {
    [Language.ENGLISH]: "Most recent",
    [Language.SPANISH]: "Más recientes",
    [Language.PORTUGUESE]: "Mais recentes",
  },
  "oldest": {
    [Language.ENGLISH]: "Oldest",
    [Language.SPANISH]: "Más antiguos",
    [Language.PORTUGUESE]: "Mais antigos",
  },
  "ai-filters": {
    [Language.ENGLISH]: "AI Filters",
    [Language.SPANISH]: "Filtros IA",
    [Language.PORTUGUESE]: "Filtros IA",
  },
  "clear": {
    [Language.ENGLISH]: "Clear",
    [Language.SPANISH]: "Limpiar",
    [Language.PORTUGUESE]: "Limpar",
  },
  "asset-type": {
    [Language.ENGLISH]: "Asset type",
    [Language.SPANISH]: "Tipo de recurso",
    [Language.PORTUGUESE]: "Tipo de recurso",
  },
  "visual-format": {
    [Language.ENGLISH]: "Visual format",
    [Language.SPANISH]: "Formato visual",
    [Language.PORTUGUESE]: "Formato visual",
  },
  "messaging-angle": {
    [Language.ENGLISH]: "Messaging",
    [Language.SPANISH]: "Mensajería",
    [Language.PORTUGUESE]: "Mensagem",
  },
  "hook-tactic": {
    [Language.ENGLISH]: "Hook",
    [Language.SPANISH]: "Gancho",
    [Language.PORTUGUESE]: "Gancho",
  },
  "offer-type": {
    [Language.ENGLISH]: "Offer",
    [Language.SPANISH]: "Oferta",
    [Language.PORTUGUESE]: "Oferta",
  },
  "no-bookmarks-yet": {
    [Language.ENGLISH]: "No bookmarks yet",
    [Language.SPANISH]: "No hay favoritos todavía",
    [Language.PORTUGUESE]: "Nenhum favorito ainda",
  },
  "click-star-to-save": {
    [Language.ENGLISH]: "Click the star on any ad to save it",
    [Language.SPANISH]: "Haz clic en la estrella de cualquier anuncio para guardarlo",
    [Language.PORTUGUESE]: "Clique na estrela de qualquer anúncio para salvá-lo",
  },
  "no-media": {
    [Language.ENGLISH]: "No media",
    [Language.SPANISH]: "Sin media",
    [Language.PORTUGUESE]: "Sem mídia",
  },
  "ad-expired": {
    [Language.ENGLISH]: "Ad expired",
    [Language.SPANISH]: "Anuncio expirado",
    [Language.PORTUGUESE]: "Anúncio expirado",
  },
  "create-similar": {
    [Language.ENGLISH]: "Create similar",
    [Language.SPANISH]: "Crear similar",
    [Language.PORTUGUESE]: "Criar similar",
  },
  "no-text": {
    [Language.ENGLISH]: "No text",
    [Language.SPANISH]: "Sin texto",
    [Language.PORTUGUESE]: "Sem texto",
  },
  "error-loading-details": {
    [Language.ENGLISH]: "Error loading details",
    [Language.SPANISH]: "Error cargando detalles",
    [Language.PORTUGUESE]: "Erro ao carregar detalhes",
  },
  "no-media-available": {
    [Language.ENGLISH]: "No media available",
    [Language.SPANISH]: "Sin media disponible",
    [Language.PORTUGUESE]: "Sem mídia disponível",
  },
  "no-headline": {
    [Language.ENGLISH]: "No headline",
    [Language.SPANISH]: "Sin titular",
    [Language.PORTUGUESE]: "Sem título",
  },
  "text": {
    [Language.ENGLISH]: "Text",
    [Language.SPANISH]: "Texto",
    [Language.PORTUGUESE]: "Texto",
  },
  "call-to-action": {
    [Language.ENGLISH]: "Call to action",
    [Language.SPANISH]: "Llamada a acción",
    [Language.PORTUGUESE]: "Chamada para ação",
  },
  "type": {
    [Language.ENGLISH]: "Type",
    [Language.SPANISH]: "Tipo",
    [Language.PORTUGUESE]: "Tipo",
  },
  "position": {
    [Language.ENGLISH]: "Position",
    [Language.SPANISH]: "Posición",
    [Language.PORTUGUESE]: "Posição",
  },
  "start": {
    [Language.ENGLISH]: "Start",
    [Language.SPANISH]: "Inicio",
    [Language.PORTUGUESE]: "Início",
  },
  "view-landing-page": {
    [Language.ENGLISH]: "View landing page",
    [Language.SPANISH]: "Ver landing page",
    [Language.PORTUGUESE]: "Ver landing page",
  },
  "view-all-brand-ads": {
    [Language.ENGLISH]: "View all ads from {name}",
    [Language.SPANISH]: "Ver todos los anuncios de {name}",
    [Language.PORTUGUESE]: "Ver todos os anúncios de {name}",
  },
  "view-individual-ad": {
    [Language.ENGLISH]: "View individual ad",
    [Language.SPANISH]: "Ver anuncio individual",
    [Language.PORTUGUESE]: "Ver anúncio individual",
  },
  "analyze-with-ai": {
    [Language.ENGLISH]: "Analyze with AI",
    [Language.SPANISH]: "Analizar con IA",
    [Language.PORTUGUESE]: "Analisar com IA",
  },
  "ai-analysis": {
    [Language.ENGLISH]: "AI Analysis",
    [Language.SPANISH]: "Análisis IA",
    [Language.PORTUGUESE]: "Análise IA",
  },
  "summary": {
    [Language.ENGLISH]: "Summary",
    [Language.SPANISH]: "Resumen",
    [Language.PORTUGUESE]: "Resumo",
  },
  "suggested-improvements": {
    [Language.ENGLISH]: "Suggested improvements",
    [Language.SPANISH]: "Mejoras sugeridas",
    [Language.PORTUGUESE]: "Melhorias sugeridas",
  },

  // LANDING OFFER PAGE
  "offer-enter-email-title": {
    [Language.ENGLISH]: "Enter the email you'll use to create your Fluxi account",
    [Language.SPANISH]: "Ingresa el correo con el que crearás tu cuenta de Fluxi",
    [Language.PORTUGUESE]: "Insira o e-mail com o qual você criará sua conta Fluxi",
  },
  "offer-email-label": {
    [Language.ENGLISH]: "EMAIL ADDRESS",
    [Language.SPANISH]: "CORREO ELECTRÓNICO",
    [Language.PORTUGUESE]: "ENDEREÇO DE E-MAIL",
  },
  "offer-email-placeholder": {
    [Language.ENGLISH]: "you@email.com",
    [Language.SPANISH]: "tu@correo.com",
    [Language.PORTUGUESE]: "seu@email.com",
  },
  "offer-email-warning": {
    [Language.ENGLISH]: "All your invoices, access credentials, purchase confirmations and other Fluxi communications will be sent to this email.",
    [Language.SPANISH]: "A este correo llegarán todas tus facturas, accesos, confirmaciones de compra y demás comunicaciones de Fluxi.",
    [Language.PORTUGUESE]: "Todas as suas faturas, acessos, confirmações de compra e demais comunicações do Fluxi serão enviadas para este e-mail.",
  },
  "offer-email-warning-bold": {
    [Language.ENGLISH]: "Make sure to enter the correct email, as it cannot be changed in the future.",
    [Language.SPANISH]: "Asegúrate de ingresar el correo correcto, ya que no podrá ser modificado en el futuro.",
    [Language.PORTUGUESE]: "Certifique-se de inserir o e-mail correto, pois não poderá ser alterado no futuro.",
  },
  "offer-continue": {
    [Language.ENGLISH]: "Continue",
    [Language.SPANISH]: "Continuar",
    [Language.PORTUGUESE]: "Continuar",
  },
  "offer-processing": {
    [Language.ENGLISH]: "Processing...",
    [Language.SPANISH]: "Procesando...",
    [Language.PORTUGUESE]: "Processando...",
  },
  "offer-error-generic": {
    [Language.ENGLISH]: "An error occurred. Please try again.",
    [Language.SPANISH]: "Ocurrió un error. Por favor intenta de nuevo.",
    [Language.PORTUGUESE]: "Ocorreu um erro. Por favor, tente novamente.",
  },
  "offer-all-rights-reserved": {
    [Language.ENGLISH]: "Fluxi. All rights reserved.",
    [Language.SPANISH]: "Fluxi. Todos los derechos reservados.",
    [Language.PORTUGUESE]: "Fluxi. Todos os direitos reservados.",
  },

  // ABANDONED CARTS
  "orders-tab": {
    [Language.ENGLISH]: "Orders",
    [Language.SPANISH]: "Órdenes",
    [Language.PORTUGUESE]: "Pedidos",
  },
  "abandoned-carts-tab": {
    [Language.ENGLISH]: "Abandoned Carts",
    [Language.SPANISH]: "Carritos Abandonados",
    [Language.PORTUGUESE]: "Carrinhos Abandonados",
  },
  "last-activity": {
    [Language.ENGLISH]: "Last activity",
    [Language.SPANISH]: "Última actividad",
    [Language.PORTUGUESE]: "Última atividade",
  },
  "last-stage-reached": {
    [Language.ENGLISH]: "Last stage",
    [Language.SPANISH]: "Última etapa",
    [Language.PORTUGUESE]: "Última etapa",
  },
  "no-abandoned-carts": {
    [Language.ENGLISH]: "No abandoned carts for this period",
    [Language.SPANISH]: "No hay carritos abandonados en este período",
    [Language.PORTUGUESE]: "Sem carrinhos abandonados neste período",
  },
  "customer-name": {
    [Language.ENGLISH]: "Customer name",
    [Language.SPANISH]: "Nombre cliente",
    [Language.PORTUGUESE]: "Nome do cliente",
  },
  "abandoned-carts-description": {
    [Language.ENGLISH]: "Customers who started a purchase but didn't complete it.",
    [Language.SPANISH]: "Clientes que iniciaron una compra pero no la completaron.",
    [Language.PORTUGUESE]: "Clientes que iniciaram uma compra mas não a concluíram.",
  },

  // FUNNEL EVENTS CHART
  "statistics-tab": {
    [Language.ENGLISH]: "Statistics",
    [Language.SPANISH]: "Estadísticas",
    [Language.PORTUGUESE]: "Estatísticas",
  },
  "chart-tab": {
    [Language.ENGLISH]: "Chart",
    [Language.SPANISH]: "Gráfico",
    [Language.PORTUGUESE]: "Gráfico",
  },
  "conversion-funnel": {
    [Language.ENGLISH]: "Conversion Funnel",
    [Language.SPANISH]: "Embudo de conversión",
    [Language.PORTUGUESE]: "Funil de conversão",
  },
  "funnel-stage-pageview": {
    [Language.ENGLISH]: "Page View",
    [Language.SPANISH]: "Vista de página",
    [Language.PORTUGUESE]: "Visualização de página",
  },
  "funnel-stage-viewContent": {
    [Language.ENGLISH]: "View Content",
    [Language.SPANISH]: "Vista de contenido",
    [Language.PORTUGUESE]: "Visualização de conteúdo",
  },
  "funnel-stage-addToCart": {
    [Language.ENGLISH]: "Add to Cart",
    [Language.SPANISH]: "Agregar al carrito",
    [Language.PORTUGUESE]: "Adicionar ao carrinho",
  },
  "funnel-stage-initiateCheckout": {
    [Language.ENGLISH]: "Initiate Checkout",
    [Language.SPANISH]: "Iniciar checkout",
    [Language.PORTUGUESE]: "Iniciar checkout",
  },
  "funnel-stage-addCheckoutInfo": {
    [Language.ENGLISH]: "Add Checkout Info",
    [Language.SPANISH]: "Información de envío",
    [Language.PORTUGUESE]: "Informações de envio",
  },
  "funnel-stage-addPaymentInfo": {
    [Language.ENGLISH]: "Add Payment Info",
    [Language.SPANISH]: "Información de pago",
    [Language.PORTUGUESE]: "Informações de pagamento",
  },
  "funnel-stage-purchase": {
    [Language.ENGLISH]: "Purchase",
    [Language.SPANISH]: "Compra",
    [Language.PORTUGUESE]: "Compra",
  },
  "funnel-drop-off": {
    [Language.ENGLISH]: "drop-off",
    [Language.SPANISH]: "abandono",
    [Language.PORTUGUESE]: "abandono",
  },
  "no-funnel-data": {
    [Language.ENGLISH]: "No funnel data yet for this period",
    [Language.SPANISH]: "Sin datos de embudo para este período",
    [Language.PORTUGUESE]: "Sem dados de funil para este período",
  },

  // ---- CHAT / WHATSAPP CONFIRMATION ----
  "chat": {
    [Language.ENGLISH]: "Chat",
    [Language.SPANISH]: "Chat",
    [Language.PORTUGUESE]: "Chat",
  },
  "chat-setup-title": {
    [Language.ENGLISH]: "Set up your WhatsApp Business",
    [Language.SPANISH]: "Configura tu WhatsApp Business",
    [Language.PORTUGUESE]: "Configure seu WhatsApp Business",
  },
  "chat-setup-subtitle": {
    [Language.ENGLISH]: "To automatically confirm orders, connect your WhatsApp Business account",
    [Language.SPANISH]: "Para confirmar pedidos automáticamente, conecta tu cuenta de WhatsApp Business",
    [Language.PORTUGUESE]: "Para confirmar pedidos automaticamente, conecte sua conta do WhatsApp Business",
  },
  "chat-setup-cta": {
    [Language.ENGLISH]: "Set up now",
    [Language.SPANISH]: "Configurar ahora",
    [Language.PORTUGUESE]: "Configurar agora",
  },
  "chat-inbox-title": {
    [Language.ENGLISH]: "Chats",
    [Language.SPANISH]: "Chats",
    [Language.PORTUGUESE]: "Chats",
  },
  "chat-filter-all": {
    [Language.ENGLISH]: "All",
    [Language.SPANISH]: "Todos",
    [Language.PORTUGUESE]: "Todos",
  },
  "chat-filter-pending": {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendientes",
    [Language.PORTUGUESE]: "Pendentes",
  },
  "chat-filter-confirmed": {
    [Language.ENGLISH]: "Confirmed",
    [Language.SPANISH]: "Confirmados",
    [Language.PORTUGUESE]: "Confirmados",
  },
  "chat-filter-rejected": {
    [Language.ENGLISH]: "Rejected",
    [Language.SPANISH]: "Rechazados",
    [Language.PORTUGUESE]: "Rejeitados",
  },
  "chat-active-count": {
    [Language.ENGLISH]: "active",
    [Language.SPANISH]: "activos",
    [Language.PORTUGUESE]: "ativos",
  },
  "chat-no-conversations": {
    [Language.ENGLISH]: "No conversations yet",
    [Language.SPANISH]: "Aún no hay conversaciones",
    [Language.PORTUGUESE]: "Nenhuma conversa ainda",
  },
  "chat-select-conversation": {
    [Language.ENGLISH]: "Select a conversation to view messages",
    [Language.SPANISH]: "Selecciona una conversación para ver los mensajes",
    [Language.PORTUGUESE]: "Selecione uma conversa para ver as mensagens",
  },
  "chat-order": {
    [Language.ENGLISH]: "Order",
    [Language.SPANISH]: "Pedido",
    [Language.PORTUGUESE]: "Pedido",
  },
  "chat-search-placeholder": {
    [Language.ENGLISH]: "Search conversations...",
    [Language.SPANISH]: "Buscar conversaciones...",
    [Language.PORTUGUESE]: "Buscar conversas...",
  },
  "chat-ai-footer": {
    [Language.ENGLISH]: "Responses are automatically managed by the AI agent",
    [Language.SPANISH]: "Las respuestas son gestionadas automáticamente por el agente de IA",
    [Language.PORTUGUESE]: "As respostas são gerenciadas automaticamente pelo agente de IA",
  },
  "whatsapp-connect-title": {
    [Language.ENGLISH]: "Connect WhatsApp Business",
    [Language.SPANISH]: "Conectar WhatsApp Business",
    [Language.PORTUGUESE]: "Conectar WhatsApp Business",
  },
  "whatsapp-connect-description": {
    [Language.ENGLISH]: "Connect your WhatsApp Business account to start receiving order confirmations via WhatsApp.",
    [Language.SPANISH]: "Conecta tu cuenta de WhatsApp Business para empezar a recibir confirmaciones de pedidos por WhatsApp.",
    [Language.PORTUGUESE]: "Conecte sua conta do WhatsApp Business para começar a receber confirmações de pedidos pelo WhatsApp.",
  },
  "whatsapp-connect-button": {
    [Language.ENGLISH]: "Connect with WhatsApp",
    [Language.SPANISH]: "Conectar con WhatsApp",
    [Language.PORTUGUESE]: "Conectar com WhatsApp",
  },
  "whatsapp-phone-number-id": {
    [Language.ENGLISH]: "Phone Number ID",
    [Language.SPANISH]: "Phone Number ID",
    [Language.PORTUGUESE]: "Phone Number ID",
  },
  "whatsapp-waba-id": {
    [Language.ENGLISH]: "WABA ID",
    [Language.SPANISH]: "WABA ID",
    [Language.PORTUGUESE]: "WABA ID",
  },
  "whatsapp-access-token": {
    [Language.ENGLISH]: "Access Token",
    [Language.SPANISH]: "Access Token",
    [Language.PORTUGUESE]: "Access Token",
  },
  "whatsapp-app-secret": {
    [Language.ENGLISH]: "App Secret (optional)",
    [Language.SPANISH]: "App Secret (opcional)",
    [Language.PORTUGUESE]: "App Secret (opcional)",
  },
  "whatsapp-verify-token": {
    [Language.ENGLISH]: "Verify Token",
    [Language.SPANISH]: "Verify Token",
    [Language.PORTUGUESE]: "Verify Token",
  },
  "whatsapp-display-name": {
    [Language.ENGLISH]: "Display Name (optional)",
    [Language.SPANISH]: "Nombre visible (opcional)",
    [Language.PORTUGUESE]: "Nome visível (opcional)",
  },
  "select-design-template": {
    [Language.ENGLISH]: "Select a template for the product page",
    [Language.SPANISH]: "Selecciona una plantilla para la página de producto",
    [Language.PORTUGUESE]: "Selecione um modelo para a página do produto",
  },
  "select-sales-angle": {
    [Language.ENGLISH]: "Select a sales angle",
    [Language.SPANISH]: "Selecciona un ángulo de venta",
    [Language.PORTUGUESE]: "Selecione um ângulo de venda",
  },
  "select-ad-templates-title": {
    [Language.ENGLISH]: "Select up to 20 ad templates for this funnel",
    [Language.SPANISH]: "Selecciona hasta 20 plantillas de anuncios para este embudo",
    [Language.PORTUGUESE]: "Selecione até 20 modelos de anúncios para este funil",
  },
  "ad-templates-subtitle": {
    [Language.ENGLISH]: "For each selected template, we will create an ad for your product.",
    [Language.SPANISH]: "A partir de cada plantilla seleccionada crearemos un anuncio para tu producto.",
    [Language.PORTUGUESE]: "Para cada modelo selecionado, criaremos um anúncio para seu produto.",
  },
  "next-funnel": {
    [Language.ENGLISH]: "Next funnel",
    [Language.SPANISH]: "Siguiente embudo",
    [Language.PORTUGUESE]: "Próximo funil",
  },
  "n-selected": {
    [Language.ENGLISH]: "{n} selected",
    [Language.SPANISH]: "{n} seleccionados",
    [Language.PORTUGUESE]: "{n} selecionados",
  },
  "edit-angle": {
    [Language.ENGLISH]: "Edit",
    [Language.SPANISH]: "Editar",
    [Language.PORTUGUESE]: "Editar",
  },
  "funnel-label": {
    [Language.ENGLISH]: "Funnel",
    [Language.SPANISH]: "Embudo",
    [Language.PORTUGUESE]: "Funil",
  },
  "custom-angle-name-placeholder": {
    [Language.ENGLISH]: "Angle name",
    [Language.SPANISH]: "Nombre del ángulo",
    [Language.PORTUGUESE]: "Nome do ângulo",
  },
  "custom-angle-desc-placeholder": {
    [Language.ENGLISH]: "Describe your sales approach...",
    [Language.SPANISH]: "Describe tu enfoque de venta...",
    [Language.PORTUGUESE]: "Descreva sua abordagem de vendas...",
  },

  // ─── VIDEO STUDIO ───
  "video-tab-all": {
    [Language.ENGLISH]: "All",
    [Language.SPANISH]: "Todos",
    [Language.PORTUGUESE]: "Todos",
  },
  "video-tab-medical": {
    [Language.ENGLISH]: "3D Animated",
    [Language.SPANISH]: "Animado 3D",
    [Language.PORTUGUESE]: "Animado 3D",
  },
  "video-tab-ugc": {
    [Language.ENGLISH]: "UGC",
    [Language.SPANISH]: "UGC",
    [Language.PORTUGUESE]: "UGC",
  },
  "video-tab-demo": {
    [Language.ENGLISH]: "Demo",
    [Language.SPANISH]: "Demo",
    [Language.PORTUGUESE]: "Demo",
  },
  "video-style-selected": {
    [Language.ENGLISH]: "style selected",
    [Language.SPANISH]: "estilo seleccionado",
    [Language.PORTUGUESE]: "estilo selecionado",
  },
  "video-estimated-time": {
    [Language.ENGLISH]: "Creation time:",
    [Language.SPANISH]: "Tiempo de creación:",
    [Language.PORTUGUESE]: "Tempo de criação:",
  },
  "video-required": {
    [Language.ENGLISH]: "required",
    [Language.SPANISH]: "obligatorio",
    [Language.PORTUGUESE]: "obrigatório",
  },
  "video-optional": {
    [Language.ENGLISH]: "optional",
    [Language.SPANISH]: "opcional",
    [Language.PORTUGUESE]: "opcional",
  },
  "video-select-tone": {
    [Language.ENGLISH]: "Select a tone",
    [Language.SPANISH]: "Selecciona un tono",
    [Language.PORTUGUESE]: "Selecione um tom",
  },
  "tone-educational": {
    [Language.ENGLISH]: "Educational",
    [Language.SPANISH]: "Educativo",
    [Language.PORTUGUESE]: "Educativo",
  },
  "tone-dramatic": {
    [Language.ENGLISH]: "Dramatic",
    [Language.SPANISH]: "Dramático",
    [Language.PORTUGUESE]: "Dramático",
  },
  "tone-humorous": {
    [Language.ENGLISH]: "Humorous",
    [Language.SPANISH]: "Humorístico",
    [Language.PORTUGUESE]: "Humorístico",
  },
  "tone-urgent": {
    [Language.ENGLISH]: "Urgent",
    [Language.SPANISH]: "Urgente",
    [Language.PORTUGUESE]: "Urgente",
  },
  "video-empty-title": {
    [Language.ENGLISH]: "You don't have any generated videos yet",
    [Language.SPANISH]: "Aún no tienes videos generados",
    [Language.PORTUGUESE]: "Você ainda não tem vídeos gerados",
  },
  "video-empty-subtitle": {
    [Language.ENGLISH]: "Create your first AI-powered advertising video",
    [Language.SPANISH]: "Crea tu primer video publicitario con IA",
    [Language.PORTUGUESE]: "Crie seu primeiro vídeo publicitário com IA",
  },
  "video-no-styles-found": {
    [Language.ENGLISH]: "No styles found",
    [Language.SPANISH]: "No se encontraron estilos",
    [Language.PORTUGUESE]: "Nenhum estilo encontrado",
  },
  "video-type-sassy-object-name": {
    [Language.ENGLISH]: "Product with Life",
    [Language.SPANISH]: "Producto con Vida",
    [Language.PORTUGUESE]: "Produto com Vida",
  },
  "video-type-sassy-object-desc": {
    [Language.ENGLISH]: "Your product comes alive with its own personality and talks directly to the customer",
    [Language.SPANISH]: "Tu producto cobra vida con personalidad propia y le habla directo al cliente",
    [Language.PORTUGUESE]: "Seu produto ganha vida com personalidade própria e fala diretamente ao cliente",
  },
  "video-type-animated-problem-name": {
    [Language.ENGLISH]: "Animated Problem",
    [Language.SPANISH]: "Problema Animado",
    [Language.PORTUGUESE]: "Problema Animado",
  },
  "video-type-animated-problem-desc": {
    [Language.ENGLISH]: "The problem your product solves becomes visible and comes alive to explain itself",
    [Language.SPANISH]: "El problema que tu producto resuelve se hace visible y cobra vida para explicarse",
    [Language.PORTUGUESE]: "O problema que seu produto resolve se torna visível e ganha vida para se explicar",
  },
  "video-type-label": {
    [Language.ENGLISH]: "Video Type",
    [Language.SPANISH]: "Tipo de Video",
    [Language.PORTUGUESE]: "Tipo de Vídeo",
  },
  "video-style-3d-anatomy": {
    [Language.ENGLISH]: "3D Animated",
    [Language.SPANISH]: "Animado 3D",
    [Language.PORTUGUESE]: "Animado 3D",
  },
  "video-style-3d-anatomy-desc": {
    [Language.ENGLISH]: "A 3D animated character with an anthropomorphic face explains the health problem your product solves. Educational viral style for TikTok/Reels.",
    [Language.SPANISH]: "Un personaje animado 3D con cara antropomórfica explica el problema de salud que tu producto resuelve. Estilo educativo viral para TikTok/Reels.",
    [Language.PORTUGUESE]: "Um personagem animado 3D com rosto antropomórfico explica o problema de saúde que seu produto resolve. Estilo educativo viral para TikTok/Reels.",
  },
  "video-style-ugc-testimonial": {
    [Language.ENGLISH]: "UGC Testimonial",
    [Language.SPANISH]: "Testimonial UGC",
    [Language.PORTUGUESE]: "Depoimento UGC",
  },
  "video-style-ugc-testimonial-desc": {
    [Language.ENGLISH]: "Real user-style video speaking to camera about product benefits.",
    [Language.SPANISH]: "Video estilo usuario real hablando a cámara sobre los beneficios del producto.",
    [Language.PORTUGUESE]: "Vídeo estilo usuário real falando para a câmera sobre os benefícios do produto.",
  },
  "video-style-modeling": {
    [Language.ENGLISH]: "Modeling",
    [Language.SPANISH]: "Modelando",
    [Language.PORTUGUESE]: "Modelando",
  },
  "video-style-modeling-desc": {
    [Language.ENGLISH]: "Person models with the product — acts out symptoms and shows relief. Silent video without speech.",
    [Language.SPANISH]: "La persona modela con el producto — actúa síntomas y muestra alivio. Video silencioso sin habla.",
    [Language.PORTUGUESE]: "A pessoa modela com o produto — atua sintomas e mostra alívio. Vídeo silencioso sem fala.",
  },
  "video-tab-modeling": {
    [Language.ENGLISH]: "Modeling",
    [Language.SPANISH]: "Modelando",
    [Language.PORTUGUESE]: "Modelando",
  },
  "video-instruction-placeholder-modeling": {
    [Language.ENGLISH]: "E.g.: scratch arm, show headache, rub knee...",
    [Language.SPANISH]: "Ej: que se rasque el brazo, que muestre dolor de cabeza, que se frote la rodilla...",
    [Language.PORTUGUESE]: "Ex: coçar o braço, mostrar dor de cabeça, esfregar o joelho...",
  },
  "video-style-product-demo": {
    [Language.ENGLISH]: "Product Demo",
    [Language.SPANISH]: "Demo de Producto",
    [Language.PORTUGUESE]: "Demo do Produto",
  },
  "video-style-product-demo-desc": {
    [Language.ENGLISH]: "Visual product demonstration with animations and dynamic text.",
    [Language.SPANISH]: "Demostración visual del producto con animaciones y texto dinámico.",
    [Language.PORTUGUESE]: "Demonstração visual do produto com animações e texto dinâmico.",
  },
  "video-sidebar-title": {
    [Language.ENGLISH]: "Your Video",
    [Language.SPANISH]: "Tu Video",
    [Language.PORTUGUESE]: "Seu Vídeo",
  },
  "video-sidebar-subtitle": {
    [Language.ENGLISH]: "Configure generation parameters",
    [Language.SPANISH]: "Configura los parámetros de generación",
    [Language.PORTUGUESE]: "Configure os parâmetros de geração",
  },
  "video-select-style": {
    [Language.ENGLISH]: "Select a style from the gallery",
    [Language.SPANISH]: "Selecciona un estilo de la galería",
    [Language.PORTUGUESE]: "Selecione um estilo da galeria",
  },
  "video-duration": {
    [Language.ENGLISH]: "Duration",
    [Language.SPANISH]: "Duración",
    [Language.PORTUGUESE]: "Duração",
  },
  "video-advanced-options": {
    [Language.ENGLISH]: "Advanced options",
    [Language.SPANISH]: "Opciones avanzadas",
    [Language.PORTUGUESE]: "Opções avançadas",
  },
  "video-instruction": {
    [Language.ENGLISH]: "Instruction",
    [Language.SPANISH]: "Instrucción",
    [Language.PORTUGUESE]: "Instrução",
  },
  "video-key-ingredient": {
    [Language.ENGLISH]: "Key ingredient",
    [Language.SPANISH]: "Ingrediente clave",
    [Language.PORTUGUESE]: "Ingrediente chave",
  },
  "video-consumer-problem": {
    [Language.ENGLISH]: "Consumer problem",
    [Language.SPANISH]: "Problema del consumidor",
    [Language.PORTUGUESE]: "Problema do consumidor",
  },
  "video-tone": {
    [Language.ENGLISH]: "Tone",
    [Language.SPANISH]: "Tono",
    [Language.PORTUGUESE]: "Tom",
  },
  "video-generate": {
    [Language.ENGLISH]: "Generate Video",
    [Language.SPANISH]: "Generar Video",
    [Language.PORTUGUESE]: "Gerar Vídeo",
  },
  "video-generating": {
    [Language.ENGLISH]: "Generating...",
    [Language.SPANISH]: "Generando...",
    [Language.PORTUGUESE]: "Gerando...",
  },
  "video-generation-time": {
    [Language.ENGLISH]: "Generation takes 8-10 minutes",
    [Language.SPANISH]: "La generación tarda entre 8-10 minutos",
    [Language.PORTUGUESE]: "A geração leva de 8-10 minutos",
  },
  "video-duration-5s-subtitle": {
    [Language.ENGLISH]: "Quick hook",
    [Language.SPANISH]: "Hook rápido",
    [Language.PORTUGUESE]: "Hook rápido",
  },
  "video-duration-10s-subtitle": {
    [Language.ENGLISH]: "Standard",
    [Language.SPANISH]: "Estándar",
    [Language.PORTUGUESE]: "Padrão",
  },
  "video-duration-15s-subtitle": {
    [Language.ENGLISH]: "Full educational",
    [Language.SPANISH]: "Educativo completo",
    [Language.PORTUGUESE]: "Educativo completo",
  },
  "video-cost": {
    [Language.ENGLISH]: "Cost:",
    [Language.SPANISH]: "Costo:",
    [Language.PORTUGUESE]: "Custo:",
  },
  "video-credits": {
    [Language.ENGLISH]: "credits",
    [Language.SPANISH]: "créditos",
    [Language.PORTUGUESE]: "créditos",
  },
  "video-instruction-placeholder": {
    [Language.ENGLISH]: "E.g.: Focus on knee pain when climbing stairs.",
    [Language.SPANISH]: "Ej: Enfócate en el dolor de rodilla al subir escaleras.",
    [Language.PORTUGUESE]: "Ex: Foque na dor no joelho ao subir escadas.",
  },
  "video-instruction-placeholder-sassy-object": {
    [Language.ENGLISH]: "E.g.: Make the product float and glow, highlight it from multiple angles with an energetic vibe.",
    [Language.SPANISH]: "Ej: Haz que el producto flote y brille, resáltalo desde varios ángulos con una vibra energética.",
    [Language.PORTUGUESE]: "Ex: Faça o produto flutuar e brilhar, destaque-o de vários ângulos com uma vibe energética.",
  },
  "video-instruction-placeholder-animated-problem": {
    [Language.ENGLISH]: "E.g.: Show knee pain when climbing stairs, then present the product as the solution.",
    [Language.SPANISH]: "Ej: Muestra el dolor de rodilla al subir escaleras y luego presenta el producto como la solución.",
    [Language.PORTUGUESE]: "Ex: Mostre a dor no joelho ao subir escadas e depois apresente o produto como a solução.",
  },
  "video-instruction-placeholder-ugc": {
    [Language.ENGLISH]: "E.g.: Talk about how the product changed your daily routine, mention that you used to have joint pain.",
    [Language.SPANISH]: "Ej: Habla de cómo el producto cambió tu rutina diaria, menciona que antes tenías dolor articular.",
    [Language.PORTUGUESE]: "Ex: Fale sobre como o produto mudou sua rotina diária, mencione que antes tinha dor articular.",
  },
  "video-count-video": {
    [Language.ENGLISH]: "Video",
    [Language.SPANISH]: "Video",
    [Language.PORTUGUESE]: "Vídeo",
  },
  "video-count-videos": {
    [Language.ENGLISH]: "Videos",
    [Language.SPANISH]: "Videos",
    [Language.PORTUGUESE]: "Vídeos",
  },
  "video-type-ugc-name": {
    [Language.ENGLISH]: "UGC Testimonial",
    [Language.SPANISH]: "UGC Testimonial",
    [Language.PORTUGUESE]: "UGC Testimonial",
  },
  "video-type-ugc-desc": {
    [Language.ENGLISH]: "Real person gives testimonial with your product",
    [Language.SPANISH]: "Persona real da testimonio con tu producto",
    [Language.PORTUGUESE]: "Pessoa real dá testemunho com seu produto",
  },
  "video-avatar-title": {
    [Language.ENGLISH]: "Configure your Avatar",
    [Language.SPANISH]: "Configura tu Avatar",
    [Language.PORTUGUESE]: "Configure seu Avatar",
  },
  "video-avatar-gender": {
    [Language.ENGLISH]: "Gender",
    [Language.SPANISH]: "Género",
    [Language.PORTUGUESE]: "Gênero",
  },
  "video-avatar-age": {
    [Language.ENGLISH]: "Age",
    [Language.SPANISH]: "Edad",
    [Language.PORTUGUESE]: "Idade",
  },
  "video-avatar-skin": {
    [Language.ENGLISH]: "Skin tone",
    [Language.SPANISH]: "Tono de piel",
    [Language.PORTUGUESE]: "Tom de pele",
  },
  "video-avatar-hair": {
    [Language.ENGLISH]: "Hair",
    [Language.SPANISH]: "Cabello",
    [Language.PORTUGUESE]: "Cabelo",
  },
  "video-avatar-hair-color": {
    [Language.ENGLISH]: "Hair color",
    [Language.SPANISH]: "Color de cabello",
    [Language.PORTUGUESE]: "Cor do cabelo",
  },
  "video-avatar-vibe": {
    [Language.ENGLISH]: "Style",
    [Language.SPANISH]: "Estilo",
    [Language.PORTUGUESE]: "Estilo",
  },
  "video-avatar-setting": {
    [Language.ENGLISH]: "Setting",
    [Language.SPANISH]: "Escenario",
    [Language.PORTUGUESE]: "Cenário",
  },
  "gender-female": {
    [Language.ENGLISH]: "Female",
    [Language.SPANISH]: "Mujer",
    [Language.PORTUGUESE]: "Mulher",
  },
  "gender-male": {
    [Language.ENGLISH]: "Male",
    [Language.SPANISH]: "Hombre",
    [Language.PORTUGUESE]: "Homem",
  },
  "age-18-25": {
    [Language.ENGLISH]: "18-25",
    [Language.SPANISH]: "18-25",
    [Language.PORTUGUESE]: "18-25",
  },
  "age-25-35": {
    [Language.ENGLISH]: "25-35",
    [Language.SPANISH]: "25-35",
    [Language.PORTUGUESE]: "25-35",
  },
  "age-35-45": {
    [Language.ENGLISH]: "35-45",
    [Language.SPANISH]: "35-45",
    [Language.PORTUGUESE]: "35-45",
  },
  "age-45+": {
    [Language.ENGLISH]: "45+",
    [Language.SPANISH]: "45+",
    [Language.PORTUGUESE]: "45+",
  },
  "skin-light": {
    [Language.ENGLISH]: "Light",
    [Language.SPANISH]: "Claro",
    [Language.PORTUGUESE]: "Claro",
  },
  "skin-medium": {
    [Language.ENGLISH]: "Medium",
    [Language.SPANISH]: "Medio",
    [Language.PORTUGUESE]: "Médio",
  },
  "skin-tan": {
    [Language.ENGLISH]: "Tan",
    [Language.SPANISH]: "Bronceado",
    [Language.PORTUGUESE]: "Bronzeado",
  },
  "skin-dark": {
    [Language.ENGLISH]: "Dark",
    [Language.SPANISH]: "Oscuro",
    [Language.PORTUGUESE]: "Escuro",
  },
  "hair-short-straight": {
    [Language.ENGLISH]: "Short straight",
    [Language.SPANISH]: "Corto liso",
    [Language.PORTUGUESE]: "Curto liso",
  },
  "hair-short-curly": {
    [Language.ENGLISH]: "Short curly",
    [Language.SPANISH]: "Corto rizado",
    [Language.PORTUGUESE]: "Curto cacheado",
  },
  "hair-long-straight": {
    [Language.ENGLISH]: "Long straight",
    [Language.SPANISH]: "Largo liso",
    [Language.PORTUGUESE]: "Longo liso",
  },
  "hair-long-wavy": {
    [Language.ENGLISH]: "Long wavy",
    [Language.SPANISH]: "Largo ondulado",
    [Language.PORTUGUESE]: "Longo ondulado",
  },
  "hair-long-curly": {
    [Language.ENGLISH]: "Long curly",
    [Language.SPANISH]: "Largo rizado",
    [Language.PORTUGUESE]: "Longo cacheado",
  },
  "hair-bun": {
    [Language.ENGLISH]: "Bun",
    [Language.SPANISH]: "Moño",
    [Language.PORTUGUESE]: "Coque",
  },
  "hair-ponytail": {
    [Language.ENGLISH]: "Ponytail",
    [Language.SPANISH]: "Cola",
    [Language.PORTUGUESE]: "Rabo de cavalo",
  },
  "hair-color-black": {
    [Language.ENGLISH]: "Black",
    [Language.SPANISH]: "Negro",
    [Language.PORTUGUESE]: "Preto",
  },
  "hair-color-brown": {
    [Language.ENGLISH]: "Brown",
    [Language.SPANISH]: "Castaño",
    [Language.PORTUGUESE]: "Castanho",
  },
  "hair-color-blonde": {
    [Language.ENGLISH]: "Blonde",
    [Language.SPANISH]: "Rubio",
    [Language.PORTUGUESE]: "Loiro",
  },
  "hair-color-red": {
    [Language.ENGLISH]: "Red",
    [Language.SPANISH]: "Rojo",
    [Language.PORTUGUESE]: "Ruivo",
  },
  "hair-color-gray": {
    [Language.ENGLISH]: "Gray",
    [Language.SPANISH]: "Canoso",
    [Language.PORTUGUESE]: "Grisalho",
  },
  "vibe-casual-natural": {
    [Language.ENGLISH]: "Natural",
    [Language.SPANISH]: "Natural",
    [Language.PORTUGUESE]: "Natural",
  },
  "vibe-professional": {
    [Language.ENGLISH]: "Professional",
    [Language.SPANISH]: "Profesional",
    [Language.PORTUGUESE]: "Profissional",
  },
  "vibe-sporty": {
    [Language.ENGLISH]: "Sporty",
    [Language.SPANISH]: "Deportivo",
    [Language.PORTUGUESE]: "Esportivo",
  },
  "vibe-glam": {
    [Language.ENGLISH]: "Glam",
    [Language.SPANISH]: "Glam",
    [Language.PORTUGUESE]: "Glam",
  },
  "setting-bedroom": {
    [Language.ENGLISH]: "Bedroom",
    [Language.SPANISH]: "Cuarto",
    [Language.PORTUGUESE]: "Quarto",
  },
  "setting-bathroom": {
    [Language.ENGLISH]: "Bathroom",
    [Language.SPANISH]: "Baño",
    [Language.PORTUGUESE]: "Banheiro",
  },
  "setting-kitchen": {
    [Language.ENGLISH]: "Kitchen",
    [Language.SPANISH]: "Cocina",
    [Language.PORTUGUESE]: "Cozinha",
  },
  "setting-gym": {
    [Language.ENGLISH]: "Gym",
    [Language.SPANISH]: "Gym",
    [Language.PORTUGUESE]: "Academia",
  },
  "setting-outdoor": {
    [Language.ENGLISH]: "Outdoor",
    [Language.SPANISH]: "Exterior",
    [Language.PORTUGUESE]: "Exterior",
  },
  "setting-office": {
    [Language.ENGLISH]: "Office",
    [Language.SPANISH]: "Oficina",
    [Language.PORTUGUESE]: "Escritório",
  },
  "video-style-podcast": {
    [Language.ENGLISH]: "Podcast",
    [Language.SPANISH]: "Podcast",
    [Language.PORTUGUESE]: "Podcast",
  },
  "video-style-podcast-desc": {
    [Language.ENGLISH]: "Podcast-style clip that generates curiosity about a problem without showing the product.",
    [Language.SPANISH]: "Clip estilo podcast que genera curiosidad sobre un problema sin mostrar producto.",
    [Language.PORTUGUESE]: "Clipe estilo podcast que gera curiosidade sobre um problema sem mostrar o produto.",
  },
  "video-tab-podcast": {
    [Language.ENGLISH]: "Podcast",
    [Language.SPANISH]: "Podcast",
    [Language.PORTUGUESE]: "Podcast",
  },
  "video-instruction-placeholder-podcast": {
    [Language.ENGLISH]: "E.g.: Talk about insomnia and how it affects your energy",
    [Language.SPANISH]: "Ej: Habla sobre el insomnio y cómo afecta tu energía",
    [Language.PORTUGUESE]: "Ex: Fale sobre a insônia e como afeta sua energia",
  },
  "video-info-medical-3d": {
    [Language.ENGLISH]: "Generates an animated 3D video showing how the product works inside the body. Ideal for supplements, health and wellness products.",
    [Language.SPANISH]: "Genera un video animado 3D mostrando cómo actúa el producto dentro del cuerpo. Ideal para suplementos, salud y bienestar.",
    [Language.PORTUGUESE]: "Gera um vídeo animado 3D mostrando como o produto atua dentro do corpo. Ideal para suplementos, saúde e bem-estar.",
  },
  "video-info-ugc-testimonial": {
    [Language.ENGLISH]: "A person appears on camera giving a natural testimonial about your product, as if sharing their real experience. Great for building trust.",
    [Language.SPANISH]: "Una persona aparece en cámara dando un testimonio natural sobre tu producto, como si compartiera su experiencia real. Ideal para generar confianza.",
    [Language.PORTUGUESE]: "Uma pessoa aparece na câmera dando um depoimento natural sobre seu produto, como se compartilhasse sua experiência real. Ideal para gerar confiança.",
  },
  "video-info-product-modeling": {
    [Language.ENGLISH]: "A person poses and models with your product on camera — showcasing it naturally in different angles. A silent video without speech.",
    [Language.SPANISH]: "Una persona posa y modela con tu producto en cámara — mostrándolo de forma natural en diferentes ángulos. Un video sin voz.",
    [Language.PORTUGUESE]: "Uma pessoa posa e modela com seu produto na câmera — mostrando-o de forma natural em diferentes ângulos. Um vídeo sem voz.",
  },
  "video-info-podcast-style": {
    [Language.ENGLISH]: "This style generates a podcast-style clip that talks about the problem your product solves, without showing the product. Ideal for generating curiosity and FOMO.",
    [Language.SPANISH]: "Este estilo genera un clip tipo podcast que habla sobre el problema que tu producto resuelve, sin mostrar el producto. Ideal para generar curiosidad y FOMO.",
    [Language.PORTUGUESE]: "Este estilo gera um clipe estilo podcast que fala sobre o problema que seu produto resolve, sem mostrar o produto. Ideal para gerar curiosidade e FOMO.",
  },
  "video-angle": {
    [Language.ENGLISH]: "Sales angle",
    [Language.SPANISH]: "Ángulo de venta",
    [Language.PORTUGUESE]: "Ângulo de venda",
  },
  "video-angle-placeholder": {
    [Language.ENGLISH]: "E.g.: fear of aging, desire for energy, social pressure...",
    [Language.SPANISH]: "Ej: miedo a envejecer, deseo de energía, presión social...",
    [Language.PORTUGUESE]: "Ex: medo de envelhecer, desejo de energia, pressão social...",
  },
  "tone-auto": {
    [Language.ENGLISH]: "Automatic",
    [Language.SPANISH]: "Automático",
    [Language.PORTUGUESE]: "Automático",
  },
  "video-no-results": {
    [Language.ENGLISH]: "No results",
    [Language.SPANISH]: "Sin resultados",
    [Language.PORTUGUESE]: "Sem resultados",
  },
  "setting-studio-dark": {
    [Language.ENGLISH]: "Dark Studio",
    [Language.SPANISH]: "Estudio Oscuro",
    [Language.PORTUGUESE]: "Estúdio Escuro",
  },
  "setting-studio-warm": {
    [Language.ENGLISH]: "Warm Studio",
    [Language.SPANISH]: "Estudio Cálido",
    [Language.PORTUGUESE]: "Estúdio Quente",
  },
  "setting-home-office": {
    [Language.ENGLISH]: "Home Office",
    [Language.SPANISH]: "Oficina/Home",
    [Language.PORTUGUESE]: "Home Office",
  },
  "setting-outdoor-night": {
    [Language.ENGLISH]: "Night Terrace",
    [Language.SPANISH]: "Terraza Nocturna",
    [Language.PORTUGUESE]: "Terraço Noturno",
  },
  "setting-minimal": {
    [Language.ENGLISH]: "Minimal",
    [Language.SPANISH]: "Minimalista",
    [Language.PORTUGUESE]: "Minimalista",
  },
  "setting-red-mood": {
    [Language.ENGLISH]: "Red Mood",
    [Language.SPANISH]: "Mood Rojo",
    [Language.PORTUGUESE]: "Mood Vermelho",
  },
  "failed-to-fetch-product-data": {
    [Language.ENGLISH]: "We couldn't get information from the selected page. You can try loading it manually or with a different link.",
    [Language.SPANISH]: "No pudimos obtener información de la página seleccionada. Podés intentar cargarlo de manera manual o con otro link.",
    [Language.PORTUGUESE]: "Não conseguimos obter informações da página selecionada. Você pode tentar carregá-la manualmente ou com outro link.",
  },
  "failed-to-fetch-product-data-title": {
    [Language.ENGLISH]: "Couldn't load page",
    [Language.SPANISH]: "No pudimos cargar la página",
    [Language.PORTUGUESE]: "Não conseguimos carregar a página",
  },
};
